import { Component, OnInit, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { TokenService } from 'src/app/auth/token.service';
import { EditorService, FootageSource, SpcCollection, SpcDraft, SpcResource } from 'src/app/components/editor/editor.service';
import { MusicPickerComponent } from 'src/app/components/music-picker/music-picker.component';
declare var $: any;

type SpcCollectionList = { results: SpcCollection[]; isLoading: boolean; hasError: boolean; request: number; search: string };
type SpcPicks = {
  byEntry: WeakMap<object, { [fieldType: string]: SpcCollection }>;
  defaults: { [fieldType: string]: SpcCollection };
  pagers: { [collectionId: number]: { page: number; limit: number } };
};

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.css']
})
export class EditorComponent implements OnInit, OnDestroy {
  toolbars: any = [
    { type: 'image', text: 'Image' },
    { type: 'video', text: 'Video' },
    { type: 'text', text: 'Text' },
    { type: 'lyric', text: 'Lyric' },
    { type: 'compilation', text: 'Compilation' },
    { type: 'mix_lyric', text: 'Mix lyric' },
    { type: 'motion', text: 'Motion' },
    { type: 'text_list', text: 'Textlist' },
    { type: 'footage', text: 'Footage' },
    { type: 'element', text: 'Animation' }
  ];

  storageKey: any = null;
  outputWidth: any = 1920;
  outputHeight: any = 1080;
  dimensions: any = { workspaceWidth: 960, workspaceHeight: 540 };
  rate: any = this.dimensions.workspaceWidth / this.outputWidth;
  defaultStep: any = 10;
  thumbnailSeconds: any = 0;
  projectName: any = 'Untitled project';
  controlType: any = '';
  layers: any = [];
  layerIndex: any = 0;
  layerData: any = {};
  previews: any = [];
  defaultFonts: any = [];
  addedFonts: any = [];
  state: any = {};
  username: any = null;
  usertoken: any = null;
  channel: any = {};
  channelList: any = [];
  undoList: any = [];
  // tiktok_title: '', tiktok_desc: '', tiktok_start_time_hours: 0, tiktok_start_time_minutes: 0, tiktok_start_time_seconds: 30, tiktok_duration_hours: 0, tiktok_duration_minutes: 0, tiktok_duration_seconds: 30, tiktok_transpose: true
  defaultAutoTemplate: any = { meta: { auto_upload: false, public_x: true, schedule: null, is_premiere: false, auto_comment: false, comment: '', is_pin_comment: false, hash_sign: '', tiktok_auto_upload: false }, hub: [], env: [{ name: null, value: null }], is_schedule: true, time_stop: Math.floor((new Date(Date.now() + 30 * 86400 * 1000)).getTime() / 1000.0), time_start: 0 };
  autoTemplate: any = {};
  templateType: any = null;
  templateList: any = [];
  currentTemplate: any = {};
  hubList: any = [];
  currentHub: any = {};
  hubLog: any = '';
  isLoadingHubLog: any = false;

  lyricList: any = [];
  lyricData: any = null;
  lyricSource: any = 'deezer';
  isLoading: any = false;
  langCodeList: any = [];
  highlightTag: any = { title: [], description: [], tags: [], comment: [], prompt: [] };
  highlightEnv: any = {};
  mentionConfig: any = {};
  currentTime: any = 0;
  parentClass: any = '.modal-preview-body';
  spinnerArraySource: any = [];
  spinnerJsonSource: any = [];
  bgColor: any = ["#ff7a7a6e", "#ffc47a6e", "#f1ff7a6e", "#b3ff7a6e", "#7affb56e", "#7afff96e", "#7ad4ff6e", "#7aa3ff6e", "#7aa3ff52", "#7aa3ff29", "#ff7ad629", "#ff7a8029", "#6efb796e", "#33f3426e", "#0cf31e6e", "#f501016e", "#f71c1c6e"];
  groupTemp: any = [];
  fukArtists: any = [];
  userList: any = [];
  timeOptions: any = [
    { id: '1w', label: '1W', value: 7 },
    { id: '2w', label: '2W', value: 14 },
    { id: '1m', label: '1M', value: 30 },
    { id: '2m', label: '2M', value: 60 },
    { id: '3m', label: '3M', value: 90 },
  ];

  constructor(private snackBar: MatSnackBar, private route: Router, private activatedRoute: ActivatedRoute, private tokenService: TokenService, public editorService: EditorService) { }

  async ngOnInit() {
    const that = this;
    this.usertoken = this.tokenService.getToken();
    axios.defaults.headers.common['aux'] = this.usertoken;
    let state: any = null;
    let sourceId: any = null;

    let loadId = this.activatedRoute.snapshot.queryParamMap.get('loadId');
    if (loadId) {
      let uri = encodeURIComponent(`${environment.magic}/job/loadx/${loadId}`);
      let response = await axios.get(`/pass/${uri}`);
      let data = response.data;
      if (data.id != 0) {
        if (data.template.includes('Hub_')) {
          let hubId = data.template.split('Hub_')[1];
          uri = encodeURIComponent(`${environment.magic}/hub/load/${hubId}`);
          response = await axios.get(`/pass/${uri}`);
          data = response.data;
          if (data.id != 0) {
            this.currentHub = { id: data.id, name: data.name, is_saved: true };
            uri = encodeURIComponent(`${environment.magic}/template/load/${data.template_id}`);
            response = await axios.get(`/pass/${uri}`);
            data = response.data;
            if (data.id != 0) {
              this.username = data.user_name;
              this.channel = { id: data.channel_id, name: data.channel_name };
              this.currentTemplate = { id: data.id, name: data.name, is_saved: true };
              this.storageKey = `state_${this.username}_${this.channel.id}_${this.currentTemplate.id}`;
              state = JSON.parse(data.tpl_studio);
            }
          }
        } else {
          state = JSON.parse(data.template);
          this.username = state.username;
          this.channel = { id: state.channel.id, name: state.channel.name };
          this.storageKey = `state_${this.username}_${this.channel.id}`;
        }
        if (state) {
          localStorage.setItem(this.storageKey, JSON.stringify({
            username: state.username,
            channel: state.channel,
            layers: state.layers,
            previews: state.previews,
            outputWidth: state.outputWidth,
            outputHeight: state.outputHeight,
            dimensions: state.dimensions,
            defaultStep: state.defaultStep,
            thumbnailSeconds: state.thumbnailSeconds,
            autoTemplate: state.autoTemplate,
            projectName: state.projectName,
            addedFonts: state.addedFonts,
            lyricData: state.lyricData,
            lyricSource: state.lyricSource
          }));
        }
      }
    } else {
      let deezerId = this.activatedRoute.snapshot.queryParamMap.get('deezerId');
      let localId = this.activatedRoute.snapshot.queryParamMap.get('localId');
      if (deezerId) {
        this.lyricSource = 'deezer';
        sourceId = deezerId;
      } else if (localId) {
        this.lyricSource = 'local';
        sourceId = localId;
      }
      if (sourceId != null) {
        localStorage.removeItem('currentChannel');
        localStorage.setItem('sourceId', sourceId);
        this.route.navigate([], {
          queryParams: {},
          relativeTo: this.activatedRoute
        });
      }

      this.username = this.tokenService.getUsername();
      this.channel = JSON.parse(localStorage.getItem('currentChannel')) || { id: null, name: null };
      this.currentTemplate = JSON.parse(localStorage.getItem('currentTemplate')) || { id: null, name: null, is_saved: true };
      this.currentHub = JSON.parse(localStorage.getItem('currentHub')) || { id: null, name: null, is_saved: true };
      if (this.currentTemplate.id != null && this.currentTemplate.id != -1) this.storageKey = `state_${this.username}_${this.channel.id}_${this.currentTemplate.id}`;
      else this.storageKey = `state_${this.username}_${this.channel.id}`;
      state = JSON.parse(localStorage.getItem(this.storageKey));
    }

    if (!state) $('#chooseChannel').modal('show');
    else {
      this.username = state.username;
      this.channel = state.channel;
      this.layers = state.layers;
      this.previews = state.previews;
      this.outputWidth = state.outputWidth;
      this.outputHeight = state.outputHeight;
      this.dimensions = state.dimensions || { workspaceWidth: 960, workspaceHeight: 540 };
      this.calculateWorkspace();
      this.defaultStep = state.defaultStep;
      this.thumbnailSeconds = state.thumbnailSeconds;
      this.autoTemplate = state.autoTemplate || this.defaultAutoTemplate;
      this.normalizeAutoMeta(this.autoTemplate.meta);
      this.projectName = state.projectName;
      this.addedFonts = state.addedFonts;
      this.lyricData = state.lyricData;
      sourceId = localStorage.getItem('sourceId');
      if (sourceId == null) this.lyricSource = state.lyricSource;

      if (this.layers.length > 0) this.layerIndex = this.layers.slice(-1)[0].index + 1;
      this.undoList.push(JSON.parse(JSON.stringify({ layers: state.layers, previews: state.previews })));
      this.newLyricComp(sourceId);
    }

    $('#chooseChannel').on('hidden.bs.modal', function () {
      if (that.channel.id == null) $('#chooseChannel').modal('show');
    });
    $('#templateModal').on('hidden.bs.modal', function () {
      if (that.templateType == 'isSavedTemplate') that.templateList = JSON.parse(JSON.stringify(that.templateList));
      else if (that.templateType == 'isSavedHub') that.hubList = JSON.parse(JSON.stringify(that.hubList));
      that.channelInput.nativeElement.value = that.channel.name;
    });
    $('.alert').on('closed.bs.alert', function () {
      that.alertMessage = null;
    })
    $('#collectionModal').on('hidden.bs.modal', function () {
      that.reloadCollection();
    });
    $('#collectionChildModal').on('hidden.bs.modal', function () {
      that.spcMusicPicker?.stopAudio();
      that.saveSpcDraft();
      that.stopSpcDraft();
    });

    this.editorService.getChannels(this.username).then(results => this.channelList = results);
    this.getDefaultFonts();
    this.getBoomGenres();
    this.getLangCode();
    this.getTemplate();
    this.getHub();
    this.loadHub();
    this.getCollections();
    this.getShortsTopics();
    this.getPrompts();
    this.editorService.getFukArtists().then((results: any) => this.fukArtists = new Set(results.map((e) => e.spotify_artists_id)));
    this.editorService.listUsers().then(results => this.userList = results);

    this.addTags(['title', 'description', 'tags', 'comment', 'tiktok_title', 'tiktok_desc']);
    this.addWidget();
    this.closePreviewModal();
    this.askMetaData.languages = this.editorService.languages;

    let sevenDaysAgo = Math.floor(new Date().getTime() / 1000.0) - 604800;
    for (let key in localStorage) {
      if (!key.includes('state_') || key == this.storageKey) continue;
      let item = JSON.parse(localStorage.getItem(key));
      if (item && item.updated_time && item.updated_time < sevenDaysAgo) localStorage.removeItem(key);
    }
    // Retried on the next load.
    this.editorService.deleteSpcDraftsBefore(sevenDaysAgo).catch(() => undefined);
  }

  @ViewChild('channelInput') channelInput: ElementRef;
  @ViewChild('spcMusicPicker') spcMusicPicker: MusicPickerComponent;

  @HostListener('window:keydown.control.delete', ['$event']) deleteKeyDown() {
    const index = this.layers.findIndex(x => x.id == this.layerData.id);
    if (index == -1) return;
    this.deleteLayer(index);
  }

  @HostListener('window:keydown.control.arrowleft', ['$event']) arrowLeftKeyDown() {
    const index = this.layers.findIndex(x => x.id == this.layerData.id);
    if (index == -1) return;
    let selectedIndex = this.layers[index];
    let previewIndex = this.previews[index];
    let x = selectedIndex.position.x;
    x -= this.defaultStep;
    if (x < 0) x = 0;
    previewIndex.layer.left = `${this.setRatio(x, '*')}px`;
    selectedIndex.position.x = x;
    this.updateEffect(selectedIndex);
  }

  @HostListener('window:keydown.control.arrowright', ['$event']) arrowRightKeyDown() {
    const index = this.layers.findIndex(x => x.id == this.layerData.id);
    if (index == -1) return;
    let selectedIndex = this.layers[index];
    let previewIndex = this.previews[index];
    let x = selectedIndex.position.x;
    x += this.defaultStep;
    let xBorder = this.outputWidth - selectedIndex.position.width;
    if (x > xBorder) x = xBorder;
    previewIndex.layer.left = `${this.setRatio(x, '*')}px`;
    selectedIndex.position.x = x;
    this.updateEffect(selectedIndex);
  }

  @HostListener('window:keydown.control.arrowup', ['$event']) arrowUpKeyDown() {
    const index = this.layers.findIndex(x => x.id == this.layerData.id);
    if (index == -1) return;
    let selectedIndex = this.layers[index];
    let previewIndex = this.previews[index];
    let y = selectedIndex.position.y;
    y -= this.defaultStep;
    if (y < 0) y = 0;
    previewIndex.layer.top = `${this.setRatio(y, '*')}px`;
    selectedIndex.position.y = y;
    this.updateEffect(selectedIndex);
  }

  @HostListener('window:keydown.control.arrowdown', ['$event']) arrowDownKeyDown() {
    const index = this.layers.findIndex(x => x.id == this.layerData.id);
    if (index == -1) return;
    let selectedIndex = this.layers[index];
    let previewIndex = this.previews[index];
    let y = selectedIndex.position.y;
    y += this.defaultStep;
    let yBorder = this.outputHeight - selectedIndex.position.height;
    if (y > yBorder) y = yBorder;
    previewIndex.layer.top = `${this.setRatio(y, '*')}px`;
    selectedIndex.position.y = y;
    this.updateEffect(selectedIndex);
  }

  @HostListener('window:keydown.control.z', ['$event']) ctrlZKeyDown() {
    if (this.undoList.length >= 1) {
      let lastUndo = this.undoList.pop();
      this.layers = lastUndo.layers;
      this.previews = lastUndo.previews;
      this.addWidget();
    }
    this.saveStorage({ layers: this.layers, previews: this.previews }, true, true);
  }

  transpose(matrix) {
    return matrix[0].map((col, c) => matrix.map((row, r) => matrix[r][c]));
  }

  spinnerClear() {
    this.spinnerArraySource = [];
    this.spinnerJsonSource = [];
    $("#spinText").val("");
  }

  spinnerChange(type: any) {
    if (this.groupTemp.length > 0) {
      this.groupTemp.forEach(id => {
        if (type == "group") {
          var keep = this.spinnerJsonSource[this.groupTemp[0]].color;
          this.spinnerJsonSource[id].color = keep;
        } else if (type == "ungroup") {
          this.spinnerJsonSource[id].color = this.bgColor[id];
        } else if (type == "show") {
          var show = this.spinnerJsonSource[id].show;
          if (show == 1) {
            show = 0;
            $(".spinner-" + id).css({ "opacity": "0.6" });
          } else {
            show = 1;
            $(".spinner-" + id).css({ "opacity": "1" });
          }
          this.spinnerJsonSource[id].show = show;
        } else if (type == "down") {
          this.spinnerJsonSource[id].level = this.spinnerJsonSource[id].level + 1;
          var newLv = this.spinnerJsonSource[id].level;
          $(".spinner-" + id).css({ "margin-top": newLv * 10 + "px" });
        } else if (type == "up") {
          this.spinnerJsonSource[id].level = this.spinnerJsonSource[id].level - 1;
          var newLv = this.spinnerJsonSource[id].level;
          $(".spinner-" + id).css({ "margin-top": newLv * 10 + "px" });
        }
      });
    }
  }

  spinnerCheckGroup(event: any) {
    if (event.target.checked) {
      this.groupTemp.push(event.target.value);
    } else {
      this.groupTemp = this.groupTemp.filter(e => e !== event.target.value);
    }
  }

  spinCopyToClipboard() {
    this.openSnackBar('Copied', 1000);
  }

  spinConvert() {
    let formData = new FormData();
    formData.append('data', JSON.stringify(this.spinnerJsonSource));
    let uri = encodeURIComponent(`${environment.magic}/spin/convert`);
    axios.post(`/pass/${uri}`, formData)
      .then((response) => {
        $("#spinner-result").val(response.data.code);
        $("#spinner-example").val(response.data.ex);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  spinGroupping(event: any) {
    var dataId = event.target.getAttribute("dataId");
    var colorId = event.target.getAttribute("colorId");
    var newColorId = parseInt(colorId) + 1;
    if (newColorId == this.spinnerJsonSource.length) {
      newColorId = 0;
    }
    this.spinnerJsonSource[dataId].color = this.bgColor[newColorId];
    event.target.setAttribute("colorId", newColorId);
  }

  spinShowHide(id: any) {
    var show = this.spinnerJsonSource[id].show;
    if (show == 0) {
      show = 1;
      $(".spinner-" + id).css({ "opacity": "1" });
    } else {
      show = 0;
      $(".spinner-" + id).css({ "opacity": "0.6" });
    }
    this.spinnerJsonSource[id].show = show;
  }

  spinChangeLevelDown(id: any) {
    this.spinnerJsonSource[id].level = this.spinnerJsonSource[id].level + 1;
    var newLv = this.spinnerJsonSource[id].level;
    $(".spinner-" + id).css({ "margin-top": newLv * 10 + "px" });
  }

  spinChangeLevelUp(id: any) {
    this.spinnerJsonSource[id].level = this.spinnerJsonSource[id].level - 1;
    var newLv = this.spinnerJsonSource[id].level;
    $(".spinner-" + id).css({ "margin-top": newLv * 10 + "px" });
  }

  previewSpinnerText() {
    $('#modal-spinner').modal({ backdrop: 'static' });
  }

  processSpinText() {
    this.spinnerArraySource = [];
    this.spinnerJsonSource = [];
    var data = $("#spinText").val();
    var splits = data.split('\n');
    var mat: any = [];
    $.each(splits, function (i, value) {
      mat.push(value.split('\t'));
    });
    var x = this.transpose(mat);
    this.spinnerArraySource = x;
    this.spinnerArraySource.forEach((item, index) => {
      var obj = { "id": index, "data": item, "show": 1, "color": this.bgColor[index], "level": 0 };
      this.spinnerJsonSource.push(obj);
    });
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }

  newLyricComp(sourceId: any) {
    if (sourceId == null) return;
    this.getLyric(sourceId).then((response: any) => {
      if (response.length < 1) return;
      let isNewLyric = true;
      let item = response[0];
      this.lyricData = item;
      let _startLyric = 0;
      let _lyricText = null;
      let _wrap_width = 30;
      let duration = 0;
      if ('duration' in item) duration = item.duration;
      let parts = item.url_128 != null ? item.url_128.split('.') : '';
      try {
        let lyricSync = JSON.parse(item.lyric_sync);
        if (lyricSync.length > 0) {
          _startLyric = Math.round((parseInt(lyricSync[0]['milliseconds']) / 1000) % 60);
          lyricSync.forEach(x => {
            if (x['line'].length >= _wrap_width) {
              _lyricText = x['line'].slice(0, _wrap_width);
              return;
            }
          });
        }
      } catch (err) {
        console.log(err);
        this.openSnackBar('This song has no lyrics');
      }
      this.projectName = `${item.artist} - ${item.title}`;
      this.layers.forEach(async e => {
        if (e.mapType == 'title') e.text = item.title;
        if (e.mapType == 'artist') e.text = item.artist;
        if (e.type == 'lyric' && isNewLyric) {
          isNewLyric = false;
          e.lyric_sync = item.lyric_sync;
          e.audio_url = item.url_128;
          e.audio_duration = duration;
          e.audio_ext = parts[parts.length - 1];
          e.startLyric = _startLyric;
          e.text = _lyricText;
          if (item.deezer_id) {
            let artistId = await this.getDeezerArtistId(item.deezer_id);
            if (artistId) e.deezer_artist_id = artistId;
          } else if (item.deezer_artist_id) e.deezer_artist_id = item.deezer_artist_id;
        }
      });
      if (isNewLyric) {
        let newLayerId = uuidv4();
        let newPreview = {
          id: newLayerId,
          layer: {
            color: 'rgba(255, 255, 255, 1)',
            fontFamily: this.defaultFonts[0]?.file_name || 'inherit',
            left: 0,
            top: 0,
            width: `${this.setRatio(256, '*')}px`,
            height: `${this.setRatio(144, '*')}px`,
            position: 'absolute',
            'z-index': this.layerIndex,
            'justify-content': 'center',
            'align-items': 'start'
          },
          image: {},
          video: {}
        };
        let newLayer = {
          id: newLayerId,
          font_url: this.defaultFonts[0]?.direct_link || null,
          color: 'rgba(255, 255, 255, 1)',
          stroke_width: null,
          stroke_color: null,
          backgroundColor: null,
          fontSize: this.setRatio(20, '/'),
          lyric_sync: item.lyric_sync,
          audio_duration: duration,
          startLyric: _startLyric,
          wrap_width: _wrap_width,
          fade_in: 0.1,
          fade_out: 0.1,
          lyric_moving: false,
          source_id: null,
          type: 'lyric',
          text: _lyricText,
          position: {
            x: 0,
            y: 0,
            width: 256,
            height: 144,
            rotation: 0
          },
          startTime: 0,
          duration: -1,
          isLockRatio: false,
          audio_url: item.url_128,
          audio_ext: parts[parts.length - 1],
          audio_loop: false,
          index: this.layerIndex,
          isHidden: false,
          is_hub: false
        };
        this.layerIndex++;

        this.controlType = newLayer.type;
        this.layerData = newLayer;
        this.layers.push(newLayer);
        this.previews.push(newPreview);
        this.addWidget();
      }
      this.saveStorage({ lyricData: this.lyricData, layers: this.layers, previews: this.previews, projectName: this.projectName });
      localStorage.removeItem('sourceId');
    });
  }

  getDefaultFonts() {
    const that = this;
    this.defaultFonts = [];
    let styleElement = document.createElement('style');
    if (!this.addedFonts.length) {
      let uri = encodeURIComponent(`${environment.magic}/resource/get/font/all/1/1`);
      axios.get(`/pass/${uri}`)
        .then(function (response) {
          that.defaultFonts = response.data;
          that.defaultFonts.map(e => {
            e.file_name = e.file_name.split('.').shift();
            return e;
          });
          let item = that.defaultFonts[0];
          styleElement.appendChild(document.createTextNode(`@font-face {font-family: "${item.file_name}"; src: url("${item.direct_link}")}`));
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      for (let item of that.addedFonts) {
        styleElement.appendChild(document.createTextNode(`@font-face {font-family: "${item.fontName}"; src: url("${item.fontUrl}")}`));
        const fontIndex = that.defaultFonts.findIndex(x => x.file_name.toLowerCase() == item.fontName.toLowerCase());
        if (fontIndex == -1) that.defaultFonts.unshift({ direct_link: item.fontUrl, file_name: item.fontName });
      }
    }
    document.head.appendChild(styleElement);
  }

  selectedChannel(item: any) {
    this.channel = { id: item.chanel_id, name: item.chanel_name };
    localStorage.setItem('currentChannel', JSON.stringify(this.channel));
    this.storageKey = `state_${this.username}_${this.channel.id}`;
    let state = JSON.parse(localStorage.getItem(this.storageKey));
    if (!state) {
      localStorage.setItem(this.storageKey, JSON.stringify({
        username: this.username,
        channel: this.channel,
        layers: [],
        previews: [],
        outputWidth: this.outputWidth,
        outputHeight: this.outputHeight,
        dimensions: this.dimensions,
        defaultStep: 10,
        thumbnailSeconds: 0,
        autoTemplate: this.defaultAutoTemplate,
        projectName: 'Untitled project',
        addedFonts: [],
        lyricData: null,
        lyricSource: 'deezer'
      }));
    }
    $('#chooseChannel').modal('hide');
    localStorage.removeItem('currentTemplate');
    localStorage.removeItem('currentHub');
    window.location.reload();
  }

  channelChange(value: any) {
    let selectedOption = $(`#channels option[value="${value}"]`);
    if (!selectedOption.length) return;
    if (this.currentTemplate.id != null && this.currentTemplate.id != -1 && !this.currentTemplate.is_saved) {
      this.templateType = 'isSavedTemplate';
      $('#templateModal').modal('show');
    } else if (this.currentHub.id != null && this.currentHub.id != -1 && !this.currentHub.is_saved) {
      this.templateType = 'isSavedHub';
      $('#templateModal').modal('show');
    } else {
      this.channel = { id: selectedOption.val(), name: selectedOption.text() };
      localStorage.setItem('currentChannel', JSON.stringify(this.channel));
      this.storageKey = `state_${this.username}_${this.channel.id}`;
      let state = JSON.parse(localStorage.getItem(this.storageKey));
      if (!state) {
        localStorage.setItem(this.storageKey, JSON.stringify({
          username: this.username,
          channel: this.channel,
          layers: [],
          previews: [],
          outputWidth: this.outputWidth,
          outputHeight: this.outputHeight,
          dimensions: this.dimensions,
          defaultStep: 10,
          thumbnailSeconds: 0,
          autoTemplate: this.defaultAutoTemplate,
          projectName: 'Untitled project',
          addedFonts: [],
          lyricData: null,
          lyricSource: 'deezer'
        }));
      }
      localStorage.removeItem('currentTemplate');
      localStorage.removeItem('currentHub');
      window.location.reload();
    }
  }

  clearStorage() {
    localStorage.removeItem(this.storageKey);
    localStorage.removeItem('currentChannel');
    localStorage.removeItem('currentTemplate');
    localStorage.removeItem('currentHub');
    window.location.reload();
  }

  saveStorage(obj: any, woUndo: any = false, objChanged: any = false) {
    let state = JSON.parse(localStorage.getItem(this.storageKey));
    if (state) {
      if (!woUndo) this.undoList.push(JSON.parse(JSON.stringify({ layers: state.layers, previews: state.previews })));
      if (obj.hasOwnProperty('layers') && objChanged) {
        this.currentTemplate.is_saved = false;
        state.updated_time = Math.floor(new Date().getTime() / 1000.0);
      }
      for (let [key, value] of Object.entries(obj)) {
        state[key] = value;
      }
      localStorage.setItem(this.storageKey, JSON.stringify(state));
    }
  }

  setResolution(width: number, height: number) {
    this.outputWidth = width;
    this.outputHeight = height;
    this.calculateWorkspace();
    this.saveStorage({ 
      outputWidth: this.outputWidth, 
      outputHeight: this.outputHeight, 
      dimensions: this.dimensions 
    });
  }

  outputWidthChange(value: any) {
    this.outputWidth = value;
    this.calculateWorkspace();
    this.saveStorage({ outputWidth: this.outputWidth, dimensions: this.dimensions });
  }

  outputHeightChange(value: any) {
    this.outputHeight = value;
    this.calculateWorkspace();
    this.saveStorage({ outputHeight: this.outputHeight, dimensions: this.dimensions });
  }

  isPortrait: boolean = false;

  private calculateWorkspace() {
    if (!this.outputWidth || !this.outputHeight) return;

    this.isPortrait = this.outputHeight > this.outputWidth;
    const maxHeight = window.innerHeight - 150;

    if (this.isPortrait) {
      this.rate = Math.min(maxHeight / this.outputHeight, 1);
      this.dimensions.workspaceWidth = Math.round(this.outputWidth * this.rate);
      this.dimensions.workspaceHeight = Math.round(this.outputHeight * this.rate);
    } else {
      this.dimensions.workspaceWidth = 960;
      this.rate = this.dimensions.workspaceWidth / this.outputWidth;
      this.dimensions.workspaceHeight = Math.round(this.outputHeight * this.rate);

      if (this.dimensions.workspaceHeight > maxHeight) {
        this.rate = maxHeight / this.outputHeight;
        this.dimensions.workspaceWidth = Math.round(this.outputWidth * this.rate);
        this.dimensions.workspaceHeight = maxHeight;
      }
    }
  }

  defaultStepChange(value: any) {
    this.defaultStep = value;
    this.saveStorage({ defaultStep: this.defaultStep });
  }

  thumbnailSecondsChange(value: any) {
    this.thumbnailSeconds = value;
    this.saveStorage({ thumbnailSeconds: this.thumbnailSeconds });
  }

  projectNameChange(value: any) {
    this.projectName = value;
    this.saveStorage({ projectName: this.projectName });
  }

  setMentionConfig() {
    this.langCodeList = JSON.parse(JSON.stringify(this.langCodeList));
    this.mentionConfig = {
      mentions: [
        {
          items: this.langCodeList,
          labelKey: 'name',
          triggerChar: '@',
          mentionSelect: item => item.code,
          mentionFilter: this.mentionFilter
        },
        {
          items: this.langCodeList,
          labelKey: 'name',
          triggerChar: '#',
          mentionSelect: item => item.code.replace(/@@/g, '##'),
          mentionFilter: this.mentionFilter
        }
      ]
    };
  }

  getLangCode() {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/lang-code/get/all`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        that.langCodeList = response.data;
        that.setMentionConfig();
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  mentionFilter(filterValue: any, items: any) {
    return items.filter(item => item.name.toLowerCase().includes(filterValue));
  }

  matchMentions: any = /(@@\w+@@) ?/g;
  matchHashtags: any = /(##\w+##) ?/g;

  addTags(keys: any) {
    const regexList = [
      { regex: this.matchMentions, getClass: (data: string) => (data.includes('env') ? 'bg-danger' : 'bg-primary') },
      { regex: this.matchHashtags, getClass: () => 'bg-yellow' }
    ];
    for (let key of keys) {
      this.highlightTag[key] = [];
      let text = this.autoTemplate.meta[key];
      for (let { regex, getClass } of regexList) {
        let match;
        while ((match = regex.exec(text))) {
          this.highlightTag[key].push({
            indices: {
              start: match.index,
              end: match.index + match[1].length
            },
            data: match[1],
            cssClass: getClass(match[1])
          });
        }
      }
    }
  }

  addEnvTags(item: any) {
    this.highlightEnv[item.name] = [];
    const regexList = [
      { regex: this.matchMentions, getClass: (data: string) => (data.includes('env') ? 'bg-danger' : 'bg-primary') },
      { regex: this.matchHashtags, getClass: () => 'bg-yellow' }
    ];
    for (let { regex, getClass } of regexList) {
      let match;
      while ((match = regex.exec(item.value))) {
        this.highlightEnv[item.name].push({
          indices: {
            start: match.index,
            end: match.index + match[1].length
          },
          data: match[1],
          cssClass: getClass(match[1])
        });
      }
    }
  }

  postTypeChange(event: any, type: any) {
    if (event.target.checked) this.autoTemplate.post_type = type;
    else this.autoTemplate.post_type = 0;
  }

  isTextUpperChange(event: any, type: any) {
    if (event.target.checked) this.autoTemplate.meta[`is_${type}_upper`] = true;
    else {
      this.autoTemplate.meta[`is_${type}_upper`] = false;
      if (this.autoTemplate.meta.hasOwnProperty(`${type}_ucfirst`)) delete this.autoTemplate.meta[`${type}_ucfirst`];
      if (this.autoTemplate.meta.hasOwnProperty(`${type}_ucword`)) delete this.autoTemplate.meta[`${type}_ucword`];
    }
  }

  isTextEmptyChange(event: any, type: any) {
    if (event.target.checked) this.autoTemplate.meta[`is_${type}_empty`] = true;
    else delete this.autoTemplate.meta[`is_${type}_empty`];
  }

  isTextFontChanged(event: any, type: any) {
    if (event.target.checked) this.autoTemplate.meta[`is_${type}_font_changed`] = true;
    else {
      this.autoTemplate.meta[`is_${type}_font_changed`] = false;
      if (this.autoTemplate.meta.hasOwnProperty(`fc_${type}_first_letter`)) delete this.autoTemplate.meta[`fc_${type}_first_letter`];
      if (this.autoTemplate.meta.hasOwnProperty(`fc_${type}_font_name`)) delete this.autoTemplate.meta[`fc_${type}_font_name`];
    }
  }

  textFontChanged(event: any, type: any) {
    this.autoTemplate.meta[`fc_${type}_font_name`] = event.target.value;
    this.autoTemplate.meta[`fc_${type}_first_letter`] = '';
  }

  textFirstLetterChanged(event: any, type: any) {
    if (event.target.checked) this.autoTemplate.meta[`fc_${type}_first_letter`] = ' ';
    else this.autoTemplate.meta[`fc_${type}_first_letter`] = '';
  }

  textCapChange(event: any, type: any) {
    if (event.target.checked) this.autoTemplate.meta[`${type}_ucfirst`] = true;
    else delete this.autoTemplate.meta[`${type}_ucfirst`];
  }

  textUpperChange(event: any, type: any) {
    if (event.target.checked) this.autoTemplate.meta[`${type}_ucword`] = true;
    else delete this.autoTemplate.meta[`${type}_ucword`];
  }

  textLowerChange(event: any, type: any) {
    if (event.target.checked) this.autoTemplate.meta[`${type}_lowercase`] = true;
    else delete this.autoTemplate.meta[`${type}_lowercase`];
  }

  videoTitleChange(value: any) {
    this.autoTemplate.meta.title = value;
    this.addTags(['title']);
  }

  videoDescChange(value: any) {
    value = (value || '').replace('<', '').replace('>', '');
    this.autoTemplate.meta.description = value;
    this.addTags(['description']);
  }

  videoDescValidate(event: any) {
    return new RegExp(/[^<>]/).test(event.key);
  }

  videoTagsChange(value: any) {
    this.autoTemplate.meta.tags = value;
    this.addTags(['tags']);
  }

  scheduleChange(event: any) {
    if (event.target.checked) this.autoTemplate.meta.schedule = [{ date: new Date().toLocaleDateString('en-US'), seq_type: 'daily', seq_data: '', time: null, time_zone: 'GMT+07:00' }];
    else this.autoTemplate.meta.schedule = null;
  }

  dateScheduleChange(event: any, index: any) {
    let d = new Date(event.value);
    this.autoTemplate.meta.schedule[index].date = d.toLocaleDateString('en-US');
  }

  scheduleHubChange(event: any, type: any) {
    let timeSec = Math.floor(new Date(event.value).getTime() / 1000.0);
    this.autoTemplate[`time_${type}`] = timeSec;
  }

  restartChange(event: any) {
    this.autoTemplate.time_start = event.target.checked ? Math.floor((new Date(Date.now() + 60 * 86400 * 1000)).getTime() / 1000.0) : 0;
  }

  btnTimeChange(days: any, type: any) {
    this.autoTemplate[`time_${type}`] = Math.floor((new Date(Date.now() + days * 86400 * 1000)).getTime() / 1000.0);
    if (type == 'stop') this.autoTemplate.time_start = Math.floor((new Date(Date.now() + days * 2 * 86400 * 1000)).getTime() / 1000.0);
  }

  bindDate(d: any) {
    if (d) {
      if (!isNaN(d)) d = d * 1000;
      return (new FormControl(new Date(d))).value;
    }
    else return (new FormControl(new Date())).value;
  }

  seqTypeChange(event: any, index: any) {
    let item = this.autoTemplate.meta.schedule[index];
    if (event.target.value) item.seq_type = event.target.value;
    if (event.target.value == 'daily') item.seq_data = '';
  }

  validSeqData(event: any, type: any) {
    let pattern: any = '';
    if (type === 'weekly') pattern = /[1-7,-]/;
    else if (type == 'monthly') pattern = /[0-9,-]/;
    return new RegExp(pattern).test(event.key);
  }

  seqDataChange(value: any, index: any) {
    this.autoTemplate.meta.schedule[index].seq_data = value;
  }

  timeScheduleChange(values: any, index: any) {
    this.autoTemplate.meta.schedule[index].time_random = values;
    if (values.length) this.autoTemplate.meta.schedule[index].time = values[0];
    else this.autoTemplate.meta.schedule[index].time = null;
  }

  tzScheduleChange(event: any, index: any) {
    this.autoTemplate.meta.schedule[index].time_zone = event.target.value;
  }

  addSchedule(index: any) {
    let s = this.autoTemplate.meta.schedule[index];
    this.autoTemplate.meta.schedule.push({
      date: s.date,
      seq_type: s.seq_type,
      seq_data: s.seq_data,
      time: s.time,
      time_zone: s.time_zone,
      time_random: s.time_random || []
    });
  }

  deleteSchedule(index: any) {
    if (this.autoTemplate.meta.schedule.length > 1) this.autoTemplate.meta.schedule.splice(index, 1);
  }

  commentChange(value: any) {
    this.autoTemplate.meta.comment = value;
    this.addTags(['comment']);
  }

  tiktokTitleChange(value: any) {
    this.autoTemplate.meta.tiktok_title = value;
    this.addTags(['tiktok_title']);
  }

  tiktokDescChange(value: any) {
    this.autoTemplate.meta.tiktok_desc = value;
    this.addTags(['tiktok_desc']);
  }

  get autoCardEnabled(): boolean {
    return !!this.autoTemplate?.meta?.auto_card;
  }

  set autoCardEnabled(value: boolean) {
    this.autoTemplate.meta.auto_card = value ? { target_video_id: '' } : null;
  }

  get autoEndscreenEnabled(): boolean {
    return !!this.autoTemplate?.meta?.auto_endscreen;
  }

  set autoEndscreenEnabled(value: boolean) {
    this.autoTemplate.meta.auto_endscreen = value ? { target_video_id: '' } : null;
  }

  normalizeAutoMeta(meta: any) {
    if (!meta) return;
    if (typeof meta.auto_card === 'boolean') {
      let targetVideoId = '';
      const videoCard = meta.payload_card?.infoCardEdit?.infoCards?.find((c: any) => c.videoInfoCard?.videoId);
      if (videoCard) targetVideoId = videoCard.videoInfoCard.videoId;
      meta.auto_card = meta.auto_card ? { target_video_id: targetVideoId } : null;
    }
    if (typeof meta.auto_endscreen === 'boolean') {
      let targetVideoId = '';
      const videoElement = meta.payload_endscreen?.endscreenEdit?.endscreen?.elements?.[1]?.videoEndscreenElement;
      if (videoElement?.videoType == 'VIDEO_TYPE_FIXED' && videoElement.encryptedVideoId) targetVideoId = videoElement.encryptedVideoId;
      meta.auto_endscreen = meta.auto_endscreen ? { target_video_id: targetVideoId } : null;
    }
  }

  parseYoutubeId(e: any) {
    let text = e.target ? e.target.value : e;
    text = text.trim();
    if (text.includes('youtube.com') || text.includes('youtu.be')) {
      if (text.includes('playlist')) text = text.match(/list=(.*?)(&|$)/)[1];
      else if (text.includes('channel')) text = text.split('/').pop();
      else text = text.includes('youtube.com') ? text.match(/v=(.*?)(&|$)/)[1] : text.split('/').pop();
    }
    return text;
  }

  openSnackBar(message: any, duration: any = 5000) {
    this.snackBar.open(message, '', {
      duration: duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: duration != 5000 ? 'bg-primary' : 'bg-danger'
    });
  }

  setRatio(number: any, operator: any) {
    let result = 0;
    if (operator == '*') {
      result = Math.round(number * this.rate);
    } else {
      result = Math.round(number / this.rate);
    }
    return result;
  }

  newLayer(item: any) {
    if (this.layers.length == 0) this.layerIndex = 0;
    let layerId = uuidv4();
    let preview = {
      id: layerId,
      layer: {
        color: 'rgba(255, 255, 255, 1)',
        fontFamily: this.defaultFonts[0]?.file_name || 'inherit',
        left: 0,
        top: 0,
        width: `${this.setRatio(256, '*')}px`,
        height: `${this.setRatio(144, '*')}px`,
        position: 'absolute',
        'z-index': this.layerIndex
      },
      image: {},
      video: {}
    };
    let layer = {
      id: layerId,
      ...item,
      position: {
        x: 0,
        y: 0,
        width: 256,
        height: 144,
        rotation: 0
      },
      startTime: 0,
      duration: -1,
      isLockRatio: false,
      audio_url: null,
      audio_ext: null,
      audio_loop: false,
      index: this.layerIndex,
      isHidden: false,
      is_hub: false
    };
    this.layerIndex++;

    switch (item.type) {
      case 'text':
        layer = {
          font_url: this.defaultFonts[0]?.direct_link || null,
          color: 'rgba(255, 255, 255, 1)',
          stroke_width: null,
          stroke_color: null,
          backgroundColor: null,
          fontSize: this.setRatio(20, '/'),
          mapType: null,
          lang_code: null,
          link_layer: '',
          effect: { data: [] },
          wrap_width: 30,
          ...layer
        };
        break;
      case 'text_list':
        layer = {
          font_url: this.defaultFonts[0]?.direct_link || null,
          color: 'rgba(255, 255, 255, 1)',
          stroke_width: null,
          stroke_color: null,
          backgroundColor: null,
          fontSize: this.setRatio(20, '/'),
          lang_code: '@@song_name_all@@',
          text: '@@song_name_all@@',
          num_columns: 2,
          min_spacing: 100,
          padding_h: 15,
          margin: 10,
          ...layer
        };
        break;
      case 'lyric':
        layer = {
          font_url: this.defaultFonts[0]?.direct_link || null,
          color: 'rgba(255, 255, 255, 1)',
          stroke_width: null,
          stroke_color: null,
          backgroundColor: null,
          fontSize: this.setRatio(20, '/'),
          lyric_sync: null,
          audio_duration: 0,
          startLyric: 0,
          wrap_width: 30,
          fade_in: 0.1,
          fade_out: 0.1,
          lyric_moving: false,
          source_id: null,
          ...layer
        };
        preview.layer['justify-content'] = 'center';
        preview.layer['align-items'] = 'start';
        $('#lyricModal').modal('show');
        break;
      case 'image':
        layer = {
          directUrl: null,
          image_url: null,
          ext: null,
          isBackground: false,
          isMask: false,
          maskColor: [],
          smart_crop: false,
          gradient: { color1: null, color2: null, direction: null },
          opacity: 1,
          isCanva: false,
          ...layer
        };
        break;
      case 'video':
        layer = {
          directUrl: null,
          video_url: null,
          ext: null,
          isMute: false,
          isLoop: true,
          isBackground: false,
          isSmoothLoop: false,
          isMask: false,
          maskColor: [],
          smart_crop: false,
          source_type: 'long',
          footage_cross_transition: false,
          opacity: 1,
          isCanva: false,
          ...layer
        };
        break;
      case 'element':
        layer = {
          rate_summon: 10,
          arr_summon_template: [],
          arr_direction: [1, 2, 3],
          rang_locx: [0, 256],
          rang_locy: [0, 144],
          rang_speedx: [10, 80],
          rang_speedy: [10, 80],
          rang_opacity: [20, 800],
          delay: 0,
          rang_size: [10, 80],
          arr_color: [],
          ...layer
        };
        break;
      case 'compilation':
        layer = {
          music_data: [],
          comp_data: {},
          source_id: null,
          sound_effect: [],
          sound_effect_id: null,
          meta: { boommix_update_title: true, public_x: true },
          is_trim_silence: true,
          silence_threshold: -30,
          strict: false,
          ...layer
        };
        break;
      case 'mix_lyric':
        layer = {
          mix_data: [],
          music_data: [],
          comp_data: {},
          source_id: null,
          meta: { boommix_update_title: true, public_x: true },
          font_url: this.defaultFonts[0]?.direct_link || null,
          color: 'rgba(255, 255, 255, 1)',
          stroke_width: null,
          stroke_color: null,
          backgroundColor: null,
          fontSize: this.setRatio(20, '/'),
          lyric_sync: null,
          lyric_lines: 2,
          wrap_width: 30,
          fade_in: 0.1,
          fade_out: 0.1,
          lyric_moving: false,
          strict: false,
          ...layer
        };
        break;
      case 'footage':
        layer = {
          source_users: [],
          source_id: null,
          ...layer
        };
        break;
      case 'motion':
        layer = {
          comp_data: {},
          render_data: { config: { width: 256, height: 144, fps: 30 }, data: {} },
          directUrl: null,
          video_url: null,
          ext: 'mp4',
          isMute: false,
          isLoop: true,
          isBackground: false,
          isSmoothLoop: false,
          isMask: false,
          maskColor: [],
          opacity: 1,
          isCanva: false,
          md5: null,
          ...layer
        };
        break;
    }

    this.controlType = item.type;
    this.layerData = layer;
    this.layers.push(layer);
    this.previews.push(preview);
    this.addWidget();
    this.saveStorage({ layers: this.layers, previews: this.previews }, false, true);
  }

  deleteLayer(index: any) {
    this.layers.splice(index, 1);
    this.previews.splice(index, 1);
    this.controlType = '';
    this.layerData = {};
    this.saveStorage({ layers: this.layers, previews: this.previews }, false, true);
  }

  dropEvent() {
    const that = this;
    $(function () {
      $('.canvas').draggable({
        snap: '.canvas',
        scroll: false,
        create: (event, ui) => {
          let element = event.target;
          let elementId = $(element).data('id');
          const index = that.layers.findIndex(x => x.id == elementId);
          if (index == -1) return;
          let selectedIndex = that.layers[index];
          let options = $(element).draggable('option');
          if (selectedIndex.type == 'element') options.containment = false;
          else options.containment = '.workspace';
          $(element).draggable(options);
        },
        stop: (event, ui) => {
          let element = event.target;
          let elementId = $(element).data('id');
          const index = that.layers.findIndex(x => x.id == elementId);
          if (index == -1) return;
          let selectedIndex = that.layers[index];
          let previewIndex = that.previews[index];
          let x = element.offsetLeft;
          let y = element.offsetTop;
          let width = element.clientWidth;
          let height = element.clientHeight;

          previewIndex.layer.left = `${x}px`;
          previewIndex.layer.top = `${y}px`;
          selectedIndex.position.x = that.setRatio(x, '/');
          selectedIndex.position.y = that.setRatio(y, '/');
          selectedIndex.position.width = that.setRatio(width, '/');
          selectedIndex.position.height = that.setRatio(height, '/');
          if (selectedIndex.type == 'element') {
            selectedIndex.rang_locx = [that.setRatio(x, '/'), that.setRatio((x + width), '/')];
            selectedIndex.rang_locy = [that.setRatio(y, '/'), that.setRatio((y + height), '/')];
          }
          that.updateEffect(selectedIndex);
          that.saveStorage({ layers: that.layers, previews: that.previews });
        }
      });
    });
  }

  resizeEvent() {
    const that = this;
    $(function () {
      $('.canvas').resizable({
        handles: 'n, e, s, w, se',
        create: (event, ui) => {
          let element = event.target;
          let elementId = $(element).data('id');
          const index = that.layers.findIndex(x => x.id == elementId);
          if (index == -1) return;
          let selectedIndex = that.layers[index];
          let options = $(element).resizable('option');
          // if (selectedIndex.type == 'text') options.disabled = true;
          // else options.disabled = false;
          if (selectedIndex.type == 'element') options.containment = false;
          else options.containment = '.workspace';
          $(element).resizable(options);
        },
        stop: (event, ui) => {
          let element = event.target;
          let elementId = $(element).data('id');
          const index = that.layers.findIndex(x => x.id == elementId);
          if (index == -1) return;
          let selectedIndex = that.layers[index];
          let previewIndex = that.previews[index];
          let width = ui.size.width;
          let height = ui.size.height;

          previewIndex.layer.width = `${width}px`;
          previewIndex.layer.height = `${height}px`;
          selectedIndex.position.width = that.setRatio(width, '/');
          selectedIndex.position.height = that.setRatio(height, '/');
          if (selectedIndex.type == 'element') {
            selectedIndex.rang_locx = [that.setRatio(selectedIndex.position.x, '/'), that.setRatio((selectedIndex.position.x + width), '/')];
            selectedIndex.rang_locy = [that.setRatio(selectedIndex.position.y, '/'), that.setRatio((selectedIndex.position.y + height), '/')];
          }
          that.saveStorage({ layers: that.layers, previews: that.previews });
        }
      });
    });
  }

  addWidget() {
    this.dropEvent();
    this.resizeEvent();
  }

  selectedLayer(item: any) {
    this.controlType = item.type;
    this.layerData = item;
  }

  getPreview(id: any, type: any) {
    const index = this.layers.findIndex(x => x.id == id);
    if (index == -1) return;
    return this.previews[index][type];
  }

  updateEffect(layer: any) {
    if (layer.type == 'text' && layer.effect && layer.effect.type) {
      let currentX = layer.position.x;
      let currentY = layer.position.y;
      let offsetX = layer.effect.offsetX;
      let offsetY = layer.effect.offsetY;
      layer.effect.data.map((e, i) => {
        switch (layer.effect.type) {
          case 'shadow':
          case 'splice':
            e.position.x = currentX + offsetX;
            e.position.y = currentY + offsetY;
            break;
          case 'echo':
            if (i == 0) {
              e.position.x = currentX + offsetX;
              e.position.y = currentY + offsetY;
            } else {
              e.position.x = currentX + (offsetX * 2);
              e.position.y = currentY + (offsetY * 2);
            }
            break;
          case 'glitch':
            if (i == 0) {
              e.position.x = currentX + (offsetX * -1);
              e.position.y = currentY + (offsetY * -1);
            } else {
              e.position.x = currentX + offsetX;
              e.position.y = currentY + offsetY;
            }
            break;
        }
      });
    }
  }

  changedControl(event: any) {
    const index = this.layers.findIndex(x => x.id == event.id);
    if (index == -1) return;
    let selectedIndex = this.layers[index];
    let previewIndex = this.previews[index];
    let _strokeWidth: any;
    let _x: any;
    let _y: any;
    let layerText: string;

    switch (event.type) {
      case 'uploadFont':
      case 'canvaFont':
      case 'browseFont':
      case 'fontUrl':
        const fontIndex = this.addedFonts.findIndex(x => x.fontName.toLowerCase() == event.fontName.toLowerCase());
        if (fontIndex == -1) {
          let styleElement = document.createElement('style');
          styleElement.appendChild(document.createTextNode(`@font-face {font-family: "${event.fontName}"; src: url("${event.fontUrl}")}`));
          document.head.appendChild(styleElement);
          this.addedFonts.push({ fontName: event.fontName, fontUrl: event.fontUrl });
        }
        else this.addedFonts[fontIndex] = { fontName: event.fontName, fontUrl: event.fontUrl };
        this.saveStorage({ addedFonts: this.addedFonts });

        previewIndex.layer.fontFamily = `"${event.fontName}"`;
        selectedIndex.font_url = event.fontUrl;
        selectedIndex.md5 = event.md5;
        break;
      case 'fontSize':
        previewIndex.layer.fontSize = `${this.setRatio(event.fontSize, '*')}px`;
        selectedIndex.fontSize = event.fontSize;
        // if (selectedIndex.type == 'text') {
        //   previewIndex.layer.width = 'auto';
        //   previewIndex.layer.height = 'auto';
        //   setTimeout(() => {
        //     let element = $(`div[data-id="${event.id}"]`);
        //     selectedIndex.position.width = this.setRatio(element.width(), '/');
        //     selectedIndex.position.height = this.setRatio(element.height(), '/');
        //   }, 10);
        // }
        break;
      case 'strokeWidth':
        _strokeWidth = event.strokeWidth == null ? 0 : event.strokeWidth;
        previewIndex.layer['-webkit-text-stroke-width'] = `${_strokeWidth}px`;
        selectedIndex.stroke_width = event.strokeWidth;
        break;
      case 'strokeColor':
        _strokeWidth = selectedIndex.stroke_width == null ? 1 : selectedIndex.stroke_width;
        previewIndex.layer['-webkit-text-stroke-width'] = `${_strokeWidth}px`;
        previewIndex.layer['-webkit-text-stroke-color'] = event.strokeColor;
        selectedIndex.stroke_color = event.strokeColor;
        selectedIndex.stroke_width = _strokeWidth;
        break;
      case 'color':
        previewIndex.layer.color = event.color;
        selectedIndex.color = event.color;
        break;
      case 'backgroundColor':
        previewIndex.layer.backgroundColor = event.backgroundColor;
        selectedIndex.backgroundColor = event.backgroundColor;
        break;
      case 'startTime':
        selectedIndex.startTime = event.startTime;
        break;
      case 'duration':
        selectedIndex.duration = event.duration;
        break;
      case 'wrapWidth':
        selectedIndex.wrap_width = event.wrapWidth;
        break;
      case 'numColumns':
        selectedIndex.num_columns = event.numColumns;
        break;
      case 'minSpacing':
        selectedIndex.min_spacing = event.minSpacing;
        break;
      case 'paddingH':
        selectedIndex.padding_h = event.paddingH;
        break;
      case 'margin':
        selectedIndex.margin = event.margin;
        break;
      case 'imgTextList':
        previewIndex.text_list = {
          backgroundImage: `url('data:image/png;base64,${event.imgTextList}')`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          position: 'absolute',
          width: '100%',
          height: '100%',
          textIndent: '-9999px',
          whiteSpace: 'nowrap'
        };
        break;
      case 'x':
        previewIndex.layer.left = `${this.setRatio(event.x, '*')}px`;
        selectedIndex.position.x = event.x;
        this.updateEffect(selectedIndex);
        break;
      case 'y':
        previewIndex.layer.top = `${this.setRatio(event.y, '*')}px`;
        selectedIndex.position.y = event.y;
        this.updateEffect(selectedIndex);
        break;
      case 'width':
        previewIndex.layer.width = `${this.setRatio(event.width, '*')}px`;
        selectedIndex.position.width = event.width;
        if (selectedIndex.type == 'motion') selectedIndex.render_data.config.width = event.width;
        break;
      case 'height':
        previewIndex.layer.height = `${this.setRatio(event.height, '*')}px`;
        selectedIndex.position.height = event.height;
        if (selectedIndex.type == 'motion') selectedIndex.render_data.config.height = event.height;
        break;
      case 'rotate':
        previewIndex.layer.transform = `rotateZ(${event.rotate}deg)`;
        selectedIndex.position.rotation = event.rotate;
        break;
      case 'textReplaceKey':
        selectedIndex.text_replace_key = event.textReplaceKey;
        break;
      case 'textReplaceValue':
        selectedIndex.text_replace_value = event.textReplaceValue;
        break;
      case 'opacity':
        if (selectedIndex.type == 'image') previewIndex.image.opacity = event.opacity;
        else previewIndex.video.opacity = event.opacity;
        selectedIndex.opacity = event.opacity;
        break;
      case 'sendBackward':
        previewIndex.layer['z-index'] = event.sendBackward;
        selectedIndex.index = event.sendBackward;
        break;
      case 'bringForward':
        previewIndex.layer['z-index'] = event.bringForward;
        selectedIndex.index = event.bringForward;
        break;
      case 'cloneLayer':
        let newLayerId = uuidv4();
        let cloneLayer = JSON.parse(JSON.stringify(selectedIndex));
        let clonePreview = JSON.parse(JSON.stringify(previewIndex));
        cloneLayer.id = newLayerId;
        cloneLayer.index = this.layerIndex;
        clonePreview.id = newLayerId;
        clonePreview.layer['z-index'] = this.layerIndex;
        this.layerIndex++;

        this.controlType = cloneLayer.type;
        this.layerData = cloneLayer;
        this.layers.push(cloneLayer);
        this.previews.push(clonePreview);
        this.addWidget();
        break;
      case 'delete':
        this.deleteLayer(index);
        break;
      case 'browseImage':
      case 'image':
      case 'canvaImage':
        previewIndex.image = {
          backgroundImage: `url('${event.directUrl}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          position: 'absolute',
          width: '100%',
          height: '100%',
        };
        selectedIndex.directUrl = event.directUrl;
        selectedIndex.image_url = event.url;
        selectedIndex.ext = event.ext;
        selectedIndex.md5 = event.md5;
        if (event.width) {
          previewIndex.layer.width = `${this.setRatio(event.width, '*')}px`;
          selectedIndex.position.width = parseInt(event.width);
        }
        if (event.height) {
          previewIndex.layer.height = `${this.setRatio(event.height, '*')}px`;
          selectedIndex.position.height = parseInt(event.height);
        }
        selectedIndex.gradient = { color1: null, color2: null, direction: null };
        break;
      case 'browseVideo':
      case 'browseIntro':
      case 'video':
      case 'canva':
        previewIndex.video = {
          objectFit: 'cover',
          position: 'absolute',
          width: '100%',
          height: '100%',
          left: 0,
          top: 0,
        };
        selectedIndex.directUrl = event.directUrl;
        selectedIndex.video_url = event.url;
        selectedIndex.ext = event.ext;
        if ('poster' in event) selectedIndex.poster = event.poster;
        selectedIndex.md5 = event.md5;
        if (event.width) {
          previewIndex.layer.width = `${this.setRatio(event.width, '*')}px`;
          selectedIndex.position.width = parseInt(event.width);
        }
        if (event.height) {
          previewIndex.layer.height = `${this.setRatio(event.height, '*')}px`;
          selectedIndex.position.height = parseInt(event.height);
        }
        if (event.type == 'canva') selectedIndex.isCanva = true;
        else selectedIndex.isCanva = false;
        const video: any = document.getElementById(`${selectedIndex.id}_video`);
        video.load();
        break;
      case 'setAsBackground':
        let oldIndex = this.layers.findIndex(x => x.index == 0);
        if (oldIndex !== -1) {
          let oldSelectedIndex = this.layers[oldIndex];
          let oldPreviewIndex = this.previews[oldIndex];
          oldPreviewIndex.layer['z-index'] = previewIndex.layer['z-index'];
          oldSelectedIndex.index = selectedIndex.index;
          oldSelectedIndex.isBackground = false;
          if (oldSelectedIndex.type == 'video_background') {
            oldSelectedIndex.isLoop = true;
            oldSelectedIndex.type = 'video';
            oldSelectedIndex.text = 'Video';
            oldSelectedIndex.keep_ori_wh = false;
          }
        }

        previewIndex.layer.left = 0;
        previewIndex.layer.top = 0;
        previewIndex.layer.width = `${this.setRatio(this.outputWidth, '*')}px`;
        previewIndex.layer.height = `${this.setRatio(this.outputHeight, '*')}px`;
        previewIndex.layer['z-index'] = 0;
        selectedIndex.position.x = 0;
        selectedIndex.position.y = 0;
        selectedIndex.position.width = this.outputWidth;
        selectedIndex.position.height = this.outputHeight;
        selectedIndex.index = 0;
        selectedIndex.isBackground = true;
        if (selectedIndex.type == 'video') {
          selectedIndex.isLoop = false;
          selectedIndex.isSmoothLoop = false;
          selectedIndex.isMask = false;
          selectedIndex.type = 'video_background';
          selectedIndex.text = 'Video Background';
          selectedIndex.keep_ori_wh = true;
        }

        if (oldIndex !== -1) {
          this.layers.sort((a, b) => a.index - b.index);
          this.previews.sort((a, b) => a.layer['z-index'] - b.layer['z-index']);
        }
        this.controlType = selectedIndex.type;
        break;
      case 'setAsIntro':
        selectedIndex.is_intro = event.isIntro;
        if (event.isIntro) {
          selectedIndex.isLoop = false;
          selectedIndex.isSmoothLoop = false;
          selectedIndex.is_intro_use_music_bg = true;
          $('#settings').modal('show');
        } else {
          selectedIndex.isLoop = true;
          selectedIndex.isSmoothLoop = true;
          selectedIndex.is_intro_use_music_bg = false;
        }
        break;
      case 'useMusicBg':
        selectedIndex.is_intro_use_music_bg = event.useMusicBg;
        break;
      case 'setAsOutro':
        selectedIndex.is_outro = event.isOutro;
        if (event.isOutro) {
          selectedIndex.isLoop = false;
          selectedIndex.isSmoothLoop = false;
          $('#settings').modal('show');
        } else {
          selectedIndex.isLoop = true;
          selectedIndex.isSmoothLoop = true;
        }
        break;
      case 'text':
        // previewIndex.layer.width = 'auto';
        // previewIndex.layer.height = 'auto';
        selectedIndex.text = event.text;
        if (event.mapType != undefined) selectedIndex.mapType = event.mapType;
        // setTimeout(() => {
        //   let element = $(`div[data-id="${event.id}"]`);
        //   selectedIndex.position.width = this.setRatio(element.width(), '/');
        //   selectedIndex.position.height = this.setRatio(element.height(), '/');
        // }, 10);
        break;
      case 'tplCode':
        selectedIndex.lang_code = event.tplCode;
        break;
      case 'linkLayer':
        selectedIndex.link_layer = event.linkLayer;
        break;
      case 'mute':
        selectedIndex.isMute = event.isMute;
        break;
      case 'loop':
        selectedIndex.isLoop = event.isLoop;
        break;
      case 'canvasBg':
        selectedIndex.isBackground = event.isBackground;
        if (selectedIndex.type == 'video' && event.isBackground) {
          selectedIndex.isLoop = false;
          selectedIndex.isSmoothLoop = false;
          selectedIndex.isMask = false;
          selectedIndex.type = 'video_background';
          selectedIndex.text = 'Video Background';
          selectedIndex.keep_ori_wh = true;
        } else if (selectedIndex.type == 'video_background' && !event.isBackground) {
          selectedIndex.isLoop = true;
          selectedIndex.type = 'video';
          selectedIndex.text = 'Video';
          selectedIndex.keep_ori_wh = false;
        }
        this.controlType = selectedIndex.type;
        break;
      case 'smoothLoop':
        selectedIndex.isSmoothLoop = event.isSmoothLoop;
        break;
      case 'smoothFade':
        selectedIndex.footage_cross_transition = event.isSmoothFade;
        break;
      case 'msSourceType':
        selectedIndex.source_type = event.msSourceType;
        if (event.msSourceType != 'footage') selectedIndex.footage_cross_transition = false;
        break;
      case 'mask':
        selectedIndex.isMask = event.isMask;
        if (!event.isMask) selectedIndex.maskColor = [];
        break;
      case 'maskColor':
        selectedIndex.maskColor = event.maskColor;
        break;
      case 'smartCrop':
        selectedIndex.smart_crop = event.smartCrop;
        break;
      case 'isTrimSilence':
        selectedIndex.is_trim_silence = event.isTrimSilence;
        break;
      case 'silenceThreshold':
        selectedIndex.silence_threshold = event.silenceThreshold;
        break;
      case 'strict':
        selectedIndex.strict = event.strict;
        break;
      case 'posTL':
        previewIndex.layer.left = 0;
        previewIndex.layer.top = 0;
        selectedIndex.position.x = 0;
        selectedIndex.position.y = 0;
        this.updateEffect(selectedIndex);
        break;
      case 'posTC':
        _x = (this.outputWidth / 2) - (selectedIndex.position.width / 2);
        previewIndex.layer.left = `${this.setRatio(_x, '*')}px`;
        previewIndex.layer.top = 0;
        selectedIndex.position.x = _x;
        selectedIndex.position.y = 0;
        this.updateEffect(selectedIndex);
        break;
      case 'posTR':
        _x = this.outputWidth - selectedIndex.position.width;
        previewIndex.layer.left = `${this.setRatio(_x, '*')}px`;
        previewIndex.layer.top = 0;
        selectedIndex.position.x = _x;
        selectedIndex.position.y = 0;
        this.updateEffect(selectedIndex);
        break;
      case 'posCL':
        _y = (this.outputHeight / 2) - (selectedIndex.position.height / 2);
        previewIndex.layer.left = 0;
        previewIndex.layer.top = `${this.setRatio(_y, '*')}px`;
        selectedIndex.position.x = 0;
        selectedIndex.position.y = _y;
        this.updateEffect(selectedIndex);
        break;
      case 'posCC':
        _x = (this.outputWidth / 2) - (selectedIndex.position.width / 2);
        _y = (this.outputHeight / 2) - (selectedIndex.position.height / 2);
        previewIndex.layer.left = `${this.setRatio(_x, '*')}px`;
        previewIndex.layer.top = `${this.setRatio(_y, '*')}px`;
        selectedIndex.position.x = _x;
        selectedIndex.position.y = _y;
        this.updateEffect(selectedIndex);
        break;
      case 'posCR':
        _x = this.outputWidth - selectedIndex.position.width;
        _y = (this.outputHeight / 2) - (selectedIndex.position.height / 2);
        previewIndex.layer.left = `${this.setRatio(_x, '*')}px`;
        previewIndex.layer.top = `${this.setRatio(_y, '*')}px`;
        selectedIndex.position.x = _x;
        selectedIndex.position.y = _y;
        this.updateEffect(selectedIndex);
        break;
      case 'posBL':
        _y = this.outputHeight - selectedIndex.position.height;
        previewIndex.layer.left = 0;
        previewIndex.layer.top = `${this.setRatio(_y, '*')}px`;
        selectedIndex.position.x = 0;
        selectedIndex.position.y = _y;
        this.updateEffect(selectedIndex);
        break;
      case 'posBC':
        _x = (this.outputWidth / 2) - (selectedIndex.position.width / 2);
        _y = this.outputHeight - selectedIndex.position.height;
        previewIndex.layer.left = `${this.setRatio(_x, '*')}px`;
        previewIndex.layer.top = `${this.setRatio(_y, '*')}px`;
        selectedIndex.position.x = _x;
        selectedIndex.position.y = _y;
        this.updateEffect(selectedIndex);
        break;
      case 'posBR':
        _x = this.outputWidth - selectedIndex.position.width;
        _y = this.outputHeight - selectedIndex.position.height;
        previewIndex.layer.left = `${this.setRatio(_x, '*')}px`;
        previewIndex.layer.top = `${this.setRatio(_y, '*')}px`;
        selectedIndex.position.x = _x;
        selectedIndex.position.y = _y;
        this.updateEffect(selectedIndex);
        break;
      case 'lockRatio':
        let element = $(`div[data-id="${event.id}"]`);
        let options = element.resizable('option');
        options.aspectRatio = event.isLockRatio;
        element.resizable('destroy');
        element.resizable(options);
        selectedIndex.isLockRatio = event.isLockRatio;
        break;
      case 'audioLoop':
        selectedIndex.audio_loop = event.audioLoop;
        break;
      case 'browseAudio':
      case 'audio':
        selectedIndex.audio_url = event.url;
        selectedIndex.audio_ext = event.ext;
        selectedIndex.audio_md5 = event.md5;
        break;
      case 'calcFontSize':
        previewIndex.layer.fontSize = `${this.setRatio(event.fontSize, '*')}px`;
        selectedIndex.text = event.text;
        selectedIndex.fontSize = event.fontSize;
        break;
      case 'gradientColor1':
        selectedIndex.gradient.color1 = event.color1;
        break;
      case 'gradientColor2':
        selectedIndex.gradient.color2 = event.color2;
        break;
      case 'gradientDirection':
        if (event.direction == 'none') {
          previewIndex.layer.background = 'none';
          previewIndex.layer.textIndent = 0;
          selectedIndex.gradient.color1 = null;
          selectedIndex.gradient.color2 = null;
          selectedIndex.gradient.direction = null;
        } else {
          previewIndex.layer.background = `linear-gradient(to ${event.direction}, ${selectedIndex.gradient.color1}, ${selectedIndex.gradient.color2})`;
          previewIndex.layer.textIndent = '-9999px';
          selectedIndex.gradient.direction = event.direction;
        }
        break;
      case 'editLyric':
        $('#lyricModal').modal('show');
        break;
      case 'fullSizeLayer':
        previewIndex.layer.left = 0;
        previewIndex.layer.top = 0;
        previewIndex.layer.width = `${this.setRatio(this.outputWidth, '*')}px`;
        previewIndex.layer.height = `${this.setRatio(this.outputHeight, '*')}px`;
        selectedIndex.position.x = 0;
        selectedIndex.position.y = 0;
        selectedIndex.position.width = this.outputWidth;
        selectedIndex.position.height = this.outputHeight;
        break;
      case 'rateSummon':
        selectedIndex.rate_summon = event.rateSummon;
        break;
      case 'summonTemplate':
        selectedIndex.arr_summon_template = event.summonTemplates;
        break;
      // case 'rangLocX1':
      //   previewIndex.layer.left = `${this.setRatio(event.rangLocX1, '*')}px`;
      //   selectedIndex.position.x = event.rangLocX1;
      //   selectedIndex.rang_locx[0] = event.rangLocX1;
      //   break;
      // case 'rangLocX2':
      //   previewIndex.layer.width = `${this.setRatio(event.rangLocX2, '*')}px`;
      //   selectedIndex.position.width = event.rangLocX2;
      //   selectedIndex.rang_locx[1] = event.rangLocX2;
      //   break;
      // case 'rangLocY1':
      //   previewIndex.layer.top = `${this.setRatio(event.rangLocY1, '*')}px`;
      //   selectedIndex.position.width = event.rangLocY1;
      //   selectedIndex.rang_locy[0] = event.rangLocY1;
      //   break;
      // case 'rangLocY2':
      //   previewIndex.layer.height = `${this.setRatio(event.rangLocY2, '*')}px`;
      //   selectedIndex.position.height = event.rangLocY2;
      //   selectedIndex.rang_locy[1] = event.rangLocY2;
      //   break;
      case 'rangSpeedX1':
        selectedIndex.rang_speedx[0] = event.rangSpeedX1;
        break;
      case 'rangSpeedX2':
        selectedIndex.rang_speedx[1] = event.rangSpeedX2;
        break;
      case 'rangSpeedY1':
        selectedIndex.rang_speedy[0] = event.rangSpeedY1;
        break;
      case 'rangSpeedY2':
        selectedIndex.rang_speedy[1] = event.rangSpeedY2;
        break;
      case 'rangOpacity1':
        selectedIndex.rang_opacity[0] = event.rangOpacity1;
        break;
      case 'rangOpacity2':
        selectedIndex.rang_opacity[1] = event.rangOpacity2;
        break;
      case 'delay':
        selectedIndex.delay = event.delay;
        break;
      case 'rangSize1':
        selectedIndex.rang_size[0] = event.rangSize1;
        break;
      case 'rangSize2':
        selectedIndex.rang_size[1] = event.rangSize2;
        break;
      case 'summonColor':
        selectedIndex.arr_color = event.summonColors;
        break;
      case 'isFadeIn':
        selectedIndex.is_fade_in = event.isFadeIn;
        if (event.isFadeIn) selectedIndex.fade_in = 0.1;
        else selectedIndex.fade_in = 0;
        break;
      case 'fadeIn':
        selectedIndex.fade_in = event.fadeIn;
        break;
      case 'isFadeOut':
        selectedIndex.is_fade_out = event.isFadeOut;
        if (event.isFadeOut) selectedIndex.fade_out = 0.1;
        else selectedIndex.fade_out = 0;
        break;
      case 'fadeOut':
        selectedIndex.fade_out = event.fadeOut;
        break;
      case 'lyricMoving':
        selectedIndex.lyric_moving = event.lyricMoving;
        break;
      case 'lyricLines':
        selectedIndex.lyric_lines = event.lyricLines;
        break;
      case 'isLyricOutro':
        selectedIndex.is_lyric_outro = event.isLyricOutro;
        if (event.isLyricOutro) {
          selectedIndex.lyric_outro_repeat = 2;
          selectedIndex.is_keeped = false;
        }
        break;
      case 'isKeeped':
        selectedIndex.is_keeped = event.isKeeped;
        break;
      case 'lyricOutroRepeat':
        selectedIndex.lyric_outro_repeat = event.lyricOutroRepeat;
        break;
      case 'deezerArtistId':
        selectedIndex.deezer_artist_id = event.deezerArtistId;
        break;
      case 'isOutroClaim':
        selectedIndex.is_outro_claim = event.isOutroClaim;
        break;
      case 'outroClaimTopic':
        selectedIndex.outro_claim_topic = event.outroClaimTopic;
        break;
      case 'outroClaimMusic':
        selectedIndex.outro_claim_music = event.outroClaimMusic;
        break;
      case 'compilation':
        selectedIndex.music_data = event.musicData;
        selectedIndex.comp_data = event.compData;
        selectedIndex.source_id = null;
        selectedIndex.meta = event.meta;
        selectedIndex.text = `${event.musicData.length} tracks - SFX ${selectedIndex.sound_effect_id || 'empty'}`;
        if (event.musicData.length) {
          let firstItem = event.musicData[0];
          this.projectName = `${firstItem.artist_name || ''} - ${firstItem.song_name || ''}`;
        }
        break;
      case 'mix_lyric':
        selectedIndex.mix_data = event.mixData;
        selectedIndex.comp_data = event.compData;
        selectedIndex.meta = event.meta;
        selectedIndex.text = `${event.mixData.length} tracks`;
        if (event.mixData.length) {
          let firstItem = event.mixData[0];
          selectedIndex.lyric_sync = firstItem.lyric_sync;
          selectedIndex.audio_url = firstItem.audio_url;
          let parts = firstItem.audio_url ? firstItem.audio_url.split('.') : '';
          selectedIndex.audio_ext = parts[parts.length - 1];
          this.projectName = `${firstItem.artist_name} - ${firstItem.song_name}`;
        }
        break;
      case 'msSourceUsers':
        if (event.sourceUsers?.length === 0 && selectedIndex.type?.includes('video')) {
          delete selectedIndex.source_users;
          delete selectedIndex.source_id;
        } else {
          selectedIndex.source_users = event.sourceUsers;
          selectedIndex.source_id = event.sourceUsers?.map(e => e?.id)?.join(',') ?? null;
        }
        if (selectedIndex.type?.includes('video')) {
          selectedIndex.md5 = null;
          selectedIndex.ext = 'mp4';
        }
        if (selectedIndex.type == 'footage') {
          let oldIndex = this.layers.findIndex(x => x.index == 0 && x.type != 'footage');
          if (oldIndex !== -1) {
            let oldSelectedIndex = this.layers[oldIndex];
            let oldPreviewIndex = this.previews[oldIndex];
            oldPreviewIndex.layer['z-index'] = previewIndex.layer['z-index'];
            oldSelectedIndex.index = selectedIndex.index;
          }

          previewIndex.layer.left = 0;
          previewIndex.layer.top = 0;
          previewIndex.layer.width = `${this.setRatio(this.outputWidth, '*')}px`;
          previewIndex.layer.height = `${this.setRatio(this.outputHeight, '*')}px`;
          previewIndex.layer['z-index'] = 0;
          selectedIndex.position.x = 0;
          selectedIndex.position.y = 0;
          selectedIndex.position.width = this.outputWidth;
          selectedIndex.position.height = this.outputHeight;
          selectedIndex.index = 0;

          if (oldIndex !== -1) {
            this.layers.sort((a, b) => a.index - b.index);
            this.previews.sort((a, b) => a.layer['z-index'] - b.layer['z-index']);
          }
        }
        break;
      case 'motion':
        if (event.compData) selectedIndex.comp_data = event.compData;
        if (event.renderData) selectedIndex.render_data = event.renderData;
        break;
      case 'hubItem':
        this.currentHub.is_saved = false;
        selectedIndex.isCanva = false;
        selectedIndex.is_hub = true;
        selectedIndex.last_drive_link = event.lastDriveLink;
        const hubIndex = this.autoTemplate.hub.findIndex(x => x.layer_id == event.hubItem.layer_id);
        if (hubIndex == -1) this.autoTemplate.hub.push(event.hubItem);
        else Object.assign(this.autoTemplate.hub[hubIndex], event.hubItem);
        this.saveStorage({ autoTemplate: this.autoTemplate });
        break;
      case 'sourceItem':
        this.currentHub.is_saved = false;
        if (event.sourceItem) {
          selectedIndex.is_hub = true;
          const sourceIndex = this.autoTemplate.hub.findIndex(x => x.layer_id == event.sourceItem.layer_id);
          if (sourceIndex == -1) this.autoTemplate.hub.push(event.sourceItem);
          else Object.assign(this.autoTemplate.hub[sourceIndex], event.sourceItem);
          layerText = `Source ${event.sourceItem.source_id}`;
          if (selectedIndex.type == 'lyric') this.autoTemplate.type = 1;
          else if (selectedIndex.type == 'compilation') {
            this.autoTemplate.type = 2;
            selectedIndex.music_data = event.sourceItem.music_data;
            layerText += ` - SFX ${selectedIndex.sound_effect_id || 'empty'}`;
          } else if (selectedIndex.type == 'mix_lyric') {
            this.autoTemplate.type = 4;
            selectedIndex.music_data = event.sourceItem.music_data;
          }
          selectedIndex.source_id = event.sourceItem.source_id;
          selectedIndex.text = layerText;
          this.saveStorage({ autoTemplate: this.autoTemplate });
        } else {
          selectedIndex.is_hub = false;
          layerText = `Source empty`;
          if (selectedIndex.type == 'compilation') {
            selectedIndex.music_data = [];
            layerText += ` - SFX ${selectedIndex.sound_effect_id || 'empty'}`;
          } else if (selectedIndex.type == 'mix_lyric') selectedIndex.music_data = [];
          selectedIndex.source_id = null;
          selectedIndex.text = layerText;
        }
        break;
      case 'soundEffect':
        this.currentHub.is_saved = false;
        layerText = selectedIndex.source_id ? `Source ${selectedIndex.source_id}` : `${selectedIndex.music_data.length} tracks`;
        if (event.soundEffect) {
          selectedIndex.is_hub = true;
          const sfxIndex = this.autoTemplate.hub.findIndex(x => x.layer_id == event.soundEffect.layer_id);
          if (sfxIndex == -1) this.autoTemplate.hub.push(event.soundEffect);
          else Object.assign(this.autoTemplate.hub[sfxIndex], event.soundEffect);
          selectedIndex.sound_effect = event.soundEffect.sound_effect;
          selectedIndex.sound_effect_id = event.soundEffect.sound_effect_id;
          selectedIndex.text = layerText + ` - SFX ${event.soundEffect.sound_effect_id}`;
          this.saveStorage({ autoTemplate: this.autoTemplate });
        } else {
          selectedIndex.is_hub = false;
          selectedIndex.sound_effect = [];
          selectedIndex.sound_effect_id = null;
          selectedIndex.text = layerText + ` - SFX empty`;
        }
        break;
      case 'canvaHub':
        selectedIndex.isCanva = false;
        selectedIndex.is_hub = true;
        break;
      case 'effect':
        if (!selectedIndex.hasOwnProperty('effect')) selectedIndex.effect = { data: [] };
        selectedIndex.effect.type = event.effect.type;
        let position = Object.assign({}, selectedIndex.position);
        let position2 = Object.assign({}, selectedIndex.position);
        let currentX = selectedIndex.position.x;
        let currentY = selectedIndex.position.y;
        let [r, g, b] = previewIndex.layer.color ? previewIndex.layer.color.match(/\d+/g) : [0, 123, 255];
        let a = event.effect.opacity;
        let rgba = `rgba(${r}, ${g}, ${b}, ${a / 100})`;
        let offsetX = event.effect.offsetX;
        let offsetY = event.effect.offsetY;
        if (event.effect.type == 'splice') {
          let strokeWidth = a / 2 / 10;
          previewIndex.layer.textShadow = `${rgba} ${this.setRatio(offsetX, '*')}px ${this.setRatio(offsetY, '*')}px 0px`;
          previewIndex.layer['-webkit-text-stroke'] = `${strokeWidth}px rgb(${r} ${g} ${b})`;
          previewIndex.layer['-webkit-text-fill-color'] = 'transparent';
          selectedIndex.stroke_color = `rgba(${r}, ${g}, ${b}, 1)`;
          selectedIndex.stroke_width = strokeWidth;
          selectedIndex.color = 'rgba(255, 255, 255, 0)';
          position.x = currentX + offsetX;
          position.y = currentY + offsetY;
          selectedIndex.effect.data = [{ color: rgba, position: position, stroke_color: null, stroke_width: null }];
        } else {
          switch (event.effect.type) {
            case 'shadow':
              previewIndex.layer.textShadow = `${rgba} ${this.setRatio(offsetX, '*')}px ${this.setRatio(offsetY, '*')}px 0px`;
              position.x = currentX + offsetX;
              position.y = currentY + offsetY;
              selectedIndex.effect.data = [{ color: rgba, position: position }];
              break;
            case 'echo':
              let offsetX2 = offsetX * 2;
              let offsetY2 = offsetY * 2;
              let a2 = a - 20 < 0 ? 0 : a - 20;
              previewIndex.layer.textShadow = `${rgba} ${this.setRatio(offsetX, '*')}px ${this.setRatio(offsetY, '*')}px 0px,
                rgb(${r} ${g} ${b} / ${a2}%) ${this.setRatio(offsetX2, '*')}px ${this.setRatio(offsetY2, '*')}px 0px`;
              position.x = currentX + offsetX;
              position.y = currentY + offsetY;
              position2.x = currentX + offsetX2;
              position2.y = currentY + offsetY2;
              selectedIndex.effect.data = [
                { color: rgba, position: position },
                { color: `rgba(${r}, ${g}, ${b}, ${a2 / 100})`, position: position2 }
              ];
              break;
            case 'glitch':
              let offsetX_1 = offsetX * -1;
              let offsetY_1 = offsetY * -1;
              previewIndex.layer.textShadow = `rgb(0 255 255) ${this.setRatio(offsetX_1, '*')}px ${this.setRatio(offsetY_1, '*')}px 0px,
            rgb(255 0 255) ${this.setRatio(offsetX, '*')}px ${this.setRatio(offsetY, '*')}px 0px`;
              position2.x = currentX + offsetX_1;
              position2.y = currentY + offsetY_1;
              position.x = currentX + offsetX;
              position.y = currentY + offsetY;
              selectedIndex.effect.data = [
                { color: 'rgba(0, 255, 255, 1)', position: position2 },
                { color: 'rgba(255, 0, 255, 1)', position: position }
              ];
              break;
            case 'none':
              delete previewIndex.layer.textShadow;
              selectedIndex.effect.data = [];
              break;
          }
          delete previewIndex.layer['-webkit-text-stroke'];
          delete previewIndex.layer['-webkit-text-fill-color'];
          selectedIndex.stroke_color = null;
          selectedIndex.stroke_width = null;
          selectedIndex.color = `rgba(${r}, ${g}, ${b}, 1)`;
        }
    }
    this.saveStorage({ layers: this.layers, previews: this.previews }, false, true);
  }

  changedLayer(event: any) {
    if (event.type == 'drop') {
      this.saveStorage({ layers: this.layers, previews: this.previews }, false, true);
      return;
    }
    const index = this.layers.findIndex(x => x.id == event.id);
    if (index == -1) return;
    let selectedIndex = this.layers[index];
    let previewIndex = this.previews[index];

    switch (event.type) {
      case 'clickLayer':
        this.controlType = selectedIndex.type;
        this.layerData = selectedIndex;
        break;
      case 'hideLayer':
        previewIndex.layer.display = previewIndex.layer.display == 'none' ? 'inherit' : 'none';
        selectedIndex.isHidden = previewIndex.layer.display == 'none' ? true : false;
        break;
      case 'textLayer':
        selectedIndex.text = event.text;
        break;
    }
    this.saveStorage({ layers: this.layers, previews: this.previews });
  }

  async save(event: any) {
    let tplStudio = localStorage.getItem(this.storageKey);
    let renderLayers = this.layers.filter(e => !e.isHidden);
    let elementLayer = renderLayers.find(e => e.type == 'element');
    let fontLayers = renderLayers.filter(e => e.type == 'text' || e.type == 'text_list' || e.type == 'lyric' || e.type == 'mix_lyric');
    if (!renderLayers.length) this.openSnackBar('No data to save');
    else if (renderLayers.some(x => x.type == 'image' && !x.image_url)) this.openSnackBar('Please select a image');
    else if (renderLayers.some(x => x.type == 'image' && x.image_url && x.isBackground && (x.position.width != this.outputWidth || x.position.height != this.outputHeight))) this.openSnackBar('Please set bg size to 1920 x 1080');
    else if (renderLayers.some(x => x.type.includes('video') && !x.video_url)) this.openSnackBar('Please select a video');
    else if (renderLayers.some(x => x.type == 'lyric' && !x.lyric_sync)) this.openSnackBar('Please select a lyric');
    else if (renderLayers.some(x => x.type == 'lyric' && elementLayer && x.index < elementLayer.index)) this.openSnackBar('Bring Lyric layer forward Animation layer');
    else if (renderLayers.filter(x => { return x.type == 'video_background' || x.type == 'footage' }).length > 1) this.openSnackBar("Can haven't Video Background and Footage layer at the same time");
    else if (fontLayers.some(x => !x.font_url)) this.openSnackBar('Please choose a font');
    else if (fontLayers.some(x => !this.defaultFonts.find(y => y.direct_link == x.font_url))) this.openSnackBar('Please update a new font of Text or Lyric layer');
    else if (!this.projectName.trim().length) this.openSnackBar('Project name is required');
    else if (!tplStudio) this.openSnackBar('Please choose a channel');
    else {
      const that = this;
      let formData = new FormData();
      if (renderLayers.some(x => x.type == 'motion')) {
        formData.append('status', '10');
        for (const renderLayer of renderLayers) {
          if (renderLayer.type != 'motion') continue;
          if (renderLayer.comp_data?.collection?.id) {
            let uri = encodeURIComponent(`${environment.magic}/collection/load/${renderLayer.comp_data.collection.id}`);
            let response = await axios.get(`/pass/${uri}`);
            let obj = JSON.parse(response.data.data);
            if (renderLayer.comp_data.collection.type == 1) {
              let imageUrls = obj.data.map(e => e.poster);
              renderLayer.render_data.data[renderLayer.comp_data.field] = this.editorService.shuffle(imageUrls, renderLayer.render_data.data?.imageCount || 10);
            }
          }
        }
      }
      let mixLyric = renderLayers.find(x => x.type == 'mix_lyric' || x.type == 'compilation');
      if (mixLyric) {
        let mixMeta = Object.assign({}, mixLyric.meta);
        if (mixMeta && mixMeta.schedule) {
          mixMeta.schedule = mixMeta.schedule[0];
          if (mixMeta.schedule?.time_random?.length) {
            const randomIndex = Math.floor(Math.random() * mixMeta.schedule.time_random.length);
            mixMeta.schedule.time = mixMeta.schedule.time_random[randomIndex];
          }
        }
        let formReplacer = new FormData();
        formReplacer.append('reup_config', JSON.stringify(mixMeta));
        formReplacer.append('j_render', JSON.stringify(renderLayers));
        let mixData = mixLyric.type == 'mix_lyric' ? mixLyric.mix_data : mixLyric.music_data;
        if (mixData.length) {
          let firstItem = mixData[0];
          formReplacer.append('name', firstItem.song_name || '');
          formReplacer.append('artist_name', firstItem.artist_name || '');
          if (mixLyric.type == 'mix_lyric') formReplacer.append('lyric_sync', firstItem.lyric_sync);
          formReplacer.append('mix_data', JSON.stringify(mixData.map(e => { return { name: e.song_name || '', artist_name: e.artist_name || '', duration_ms: e.duration_ms || 180000 } })));
        }
        let uri = encodeURIComponent(`${environment.magic}/mix-lyric/data/replace`);
        await axios.post(`/pass/${uri}`, formReplacer)
          .then((response) => {
            if (mixLyric.meta && mixLyric.meta.auto_upload) formData.append('type', '3');
            else formData.append('type', '1');
            formData.append('reup_config', JSON.stringify(response.data.reup_config));
            formData.append('content', JSON.stringify(response.data.j_render));
          })
          .catch((error) => console.log(error));
        if (mixLyric.comp_data && ((mixLyric.comp_data.claims && mixLyric.comp_data.claims.length) || (mixLyric.comp_data.promos && mixLyric.comp_data.promos.length)))
          formData.append('auto_submit', '1');
      } else {
        formData.append('type', '1');
        formData.append('content', JSON.stringify(renderLayers));
      }
      if (formData.get('content').toString().length > 65000) {
        this.openSnackBar('Too many tracks');
        return;
      }
      formData.append('name', this.projectName);
      formData.append('channel_id', this.channel.id);
      formData.append('channel_name', this.channel.name);
      formData.append('template', tplStudio);
      formData.append('user_name', this.username);
      formData.append('thumbnail_seconds', this.thumbnailSeconds);
      let uri = encodeURIComponent(`${environment.magic}/job/add`);
      axios.post(`/pass/${uri}`, formData)
        .then((response) => {
          that.openSnackBar('Saved', 1000);
          $('#saveModal').modal('hide');
        })
        .catch((error) => console.log(error));
    }
    event.srcElement.setAttribute('disabled', true);
    setTimeout(() => {
      event.srcElement.removeAttribute('disabled');
    }, 10000);
  }

  saveAs(uri: any, filename: any = '') {
    let link = document.createElement('a');
    if (typeof link.download === 'string') {
      link.href = uri;
      if (filename) link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else window.open(uri);
  }

  genThumb(event: any) {
    let renderLayers = this.layers.filter(e => !e.isHidden);
    let fontLayers = renderLayers.filter(e => e.type == 'text' || e.type == 'text_list' || e.type == 'lyric');
    if (!renderLayers.length) this.openSnackBar('No data to generate thumbnails');
    else if (renderLayers.some(x => x.type == 'image' && !x.image_url)) this.openSnackBar('Please select a image');
    else if (renderLayers.some(x => x.type == 'image' && x.image_url && x.isBackground && (x.position.width != this.outputWidth || x.position.height != this.outputHeight))) this.openSnackBar('Please set bg size to 1920 x 1080');
    else if (renderLayers.some(x => x.type.includes('video') && !x.video_url)) this.openSnackBar('Please select a video');
    else if (fontLayers.some(x => !x.font_url)) this.openSnackBar('Please choose a font');
    else if (fontLayers.some(x => !this.defaultFonts.find(y => y.direct_link == x.font_url))) this.openSnackBar('Please update a new font of Text or Lyric layer');
    else {
      const that = this;
      this.isSpinner = 'genThumb';
      let uri = encodeURIComponent(`http://65.21.242.170:5001/create-bg`);
      axios.post(`/pass-json/${uri}`, { content: renderLayers }, {
        headers: { 'Content-Type': 'application/json' }
      })
        .then((response) => {
          if (response.data.bg) {
            that.saveAs(`https://drive.google.com/uc?export=download&id=${response.data.bg.split(';;').slice(-1)}`);
            that.openSnackBar('Generated thumbnails', 1000);
          } else if (response.data.error == 1) {
            that.openSnackBar('Error, please check image|video|font url again');
          }
        })
        .catch((error) => console.log(error))
        .finally(() => that.isSpinner = null);
    }
    event.srcElement.setAttribute('disabled', true);
    setTimeout(() => {
      event.srcElement.removeAttribute('disabled');
    }, 10000);
  }

  getTemplate() {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/template/list/${this.channel.id}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        that.templateList = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadTemplate() {
    return new Promise((resolve, reject) => {
      if (this.currentTemplate.id == null || this.currentTemplate.id == -1) {
        resolve(false);
        return;
      }
      const that = this;
      this.isLoading = true;
      let uri = encodeURIComponent(`${environment.magic}/template/load/${this.currentTemplate.id}`);
      axios.get(`/pass/${uri}`)
        .then((response) => {
          const data = response.data;
          if (!data.tpl_studio) {
            resolve(false);
            return;
          }
          let state = JSON.parse(data.tpl_studio);
          if (state && Object.keys(state).length) {
            that.username = state.username;
            that.channel = state.channel;
            that.layers = state.layers;
            that.previews = state.previews;
            that.outputWidth = state.outputWidth;
            that.outputHeight = state.outputHeight;
            that.dimensions = state.dimensions;
            that.calculateWorkspace();
            that.defaultStep = state.defaultStep;
            that.thumbnailSeconds = state.thumbnailSeconds;
            that.autoTemplate = state.autoTemplate;
            that.normalizeAutoMeta(that.autoTemplate?.meta);
            that.projectName = state.projectName;
            that.addedFonts = state.addedFonts;
            that.lyricData = state.lyricData;
            that.lyricSource = state.lyricSource;

            if (data.type === 'remotion' && state.design && !state.layers.length) {
              const replaceableItems = that.getReplaceableItems(state.design);
              const sortedItems = replaceableItems.sort((a: any, b: any) => {
                const order: any = { audio: 4, image: 0, video: 1, caption: 2, text: 3 };
                return (order[a.type] ?? 5) - (order[b.type] ?? 5);
              });
              for (const item of sortedItems) {
                that.convertLayer(item);
              }
            }
            if (that.layers.length > 0) that.layerIndex = that.layers.slice(-1)[0].index + 1;

            that.storageKey = `state_${state.username}_${state.channel.id}_${that.currentTemplate.id}`;
            localStorage.setItem(that.storageKey, JSON.stringify({
              username: state.username,
              channel: state.channel,
              layers: state.layers,
              previews: state.previews,
              outputWidth: state.outputWidth,
              outputHeight: state.outputHeight,
              dimensions: state.dimensions,
              defaultStep: state.defaultStep,
              thumbnailSeconds: state.thumbnailSeconds,
              autoTemplate: state.autoTemplate,
              projectName: state.projectName,
              addedFonts: state.addedFonts,
              lyricData: state.lyricData,
              lyricSource: state.lyricSource,
              design: state.design,
            }));
            resolve(true);
          } else {
            that.storageKey = `state_${that.username}_${that.channel.id}_${that.currentTemplate.id}`;
            localStorage.setItem(that.storageKey, JSON.stringify({
              username: that.username,
              channel: that.channel,
              layers: [],
              previews: [],
              outputWidth: that.outputWidth,
              outputHeight: that.outputHeight,
              dimensions: that.dimensions,
              defaultStep: 10,
              thumbnailSeconds: 0,
              autoTemplate: that.defaultAutoTemplate,
              projectName: 'Untitled project',
              addedFonts: [],
              lyricData: null,
              lyricSource: 'deezer'
            }));
            resolve(false);
          }
          that.getDefaultFonts();
          that.addWidget();
        })
        .catch((error) => {
          console.log(error);
          resolve(false);
        })
        .then(() => {
          that.isLoading = false;
          $('#templateModal').modal('hide');
        });
    });
  }

  templateChange(event: any) {
    if (this.currentTemplate.id != null && this.currentTemplate.id != -1 && !this.currentTemplate.is_saved) {
      this.templateType = 'isSavedTemplate';
      $('#templateModal').modal('show');
    } else if (this.currentHub.id != null && this.currentHub.id != -1 && !this.currentHub.is_saved) {
      this.templateType = 'isSavedHub';
      $('#templateModal').modal('show');
    } else {
      let selectedOption = event.target.options[event.target.selectedIndex];
      let name = selectedOption.getAttribute('name');
      this.currentTemplate = { id: selectedOption.value, name: name, is_saved: true };
      this.loadTemplate().then(result => {
        if (result) {
          localStorage.setItem('currentTemplate', JSON.stringify(this.currentTemplate));
          this.getHub().then(result => {
            if (this.hubList.length) {
              if (!this.hubList.some(x => x.type == 2)) this.alertMessage = 'Mix hub is required';
              this.currentHub = { id: this.hubList[0].id, name: this.hubList[0].name, is_saved: true };
              localStorage.setItem('currentHub', JSON.stringify(this.currentHub));
              this.loadHub();
            }
          });
        }
      });
    }
  }

  getReplaceableItems(design: any) {
    return Object.entries(design.trackItemsMap)
      .filter(([_, item]: any) => item.details?.replaceable)
      .map(([id, item]: any) => ({
        id,
        type: item.type,
        item,
        itemDetails: design.trackItemDetailsMap[id],
      }));
  }

  convertLayer(itemInfo: any) {
    const { id, type, item } = itemInfo;
    if (['caption'].includes(type)) return;
    if (this.layers.length == 0) this.layerIndex = 0;
    const left = Math.max(0, parseInt(item.details.left) || item.details.left || 0);
    const top = Math.max(0, parseInt(item.details.top) || item.details.top || 0);
    const width = Math.min(item.details.width || 256, this.outputWidth);
    const height = Math.min(item.details.height || 144, this.outputHeight);
    let preview: any = {
      id,
      layer: {
        color: 'rgba(255, 255, 255, 1)',
        fontFamily: this.defaultFonts[0]?.file_name || 'inherit',
        left: `${this.setRatio(left, '*')}px`,
        top: `${this.setRatio(top, '*')}px`,
        width: `${this.setRatio(width, '*')}px`,
        height: `${this.setRatio(height, '*')}px`,
        position: 'absolute',
        'z-index': this.layerIndex
      },
      image: {},
      video: {}
    };
    let layer: any = {
      id,
      type,
      text: type,
      position: {
        x: left,
        y: top,
        width,
        height,
        rotation: 0
      },
      startTime: 0,
      duration: -1,
      isLockRatio: false,
      audio_url: null,
      audio_ext: null,
      audio_loop: false,
      index: this.layerIndex,
      isHidden: false,
      is_hub: false
    };
    this.layerIndex++;

    switch (type) {
      case 'text':
        preview.layer.fontSize = `${this.setRatio(item.details.fontSize, '*')}px`;
        layer = {
          ...layer,
          text: item.details.text,
          font_url: item.details.fontUrl,
          color: 'rgba(255, 255, 255, 1)',
          fontSize: item.details.fontSize,
          stroke_width: null,
          stroke_color: null,
          backgroundColor: null,
          mapType: null,
          lang_code: null,
          link_layer: '',
          effect: { data: [] },
          wrap_width: 30,
        };
        break;
      case 'image':
        preview.image = {
          backgroundImage: `url('${item.details.src}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          position: 'absolute',
          width: '100%',
          height: '100%',
        };
        layer = {
          ...layer,
          directUrl: item.details.src,
          image_url: item.details.src,
          ext: 'jpg',
          isBackground: false,
          isMask: false,
          maskColor: [],
          smart_crop: false,
          gradient: { color1: null, color2: null, direction: null },
          opacity: 1,
          isCanva: false,
        };
        break;
      case 'video':
        preview.video = {
          objectFit: 'cover',
          position: 'absolute',
          width: '100%',
          height: '100%',
          left: 0,
          top: 0,
        };
        layer = {
          ...layer,
          directUrl: item.details.src,
          video_url: item.details.src,
          ext: 'mp4',
          isMute: false,
          isLoop: true,
          isBackground: false,
          isSmoothLoop: false,
          isMask: false,
          maskColor: [],
          smart_crop: false,
          opacity: 1,
          isCanva: false,
        };
        break;
      case 'audio':
        layer = {
          ...layer,
          type: 'mix_lyric',
          mix_data: [],
          music_data: [],
          comp_data: {},
          source_id: null,
          meta: { boommix_update_title: true, public_x: true },
          font_url: this.defaultFonts[0]?.direct_link || null,
          color: 'rgba(255, 255, 255, 1)',
          stroke_width: null,
          stroke_color: null,
          backgroundColor: null,
          fontSize: this.setRatio(20, '/'),
          lyric_sync: null,
          lyric_lines: 2,
          wrap_width: 30,
          fade_in: 0.1,
          fade_out: 0.1,
          lyric_moving: false,
        };
        break;
    }

    this.layers.push(layer);
    this.previews.push(preview);
  }

  template: any = { example: { results: [], template_id: '' }, clone: { template_id: '' } };

  getTemplateEx() {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/template-ex/get-all`);
    axios.get(`/pass/${uri}`)
      .then((response) => {
        that.template.example.results = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  newTemplate() {
    if (this.currentTemplate.id != null && this.currentTemplate.id != -1 && !this.currentTemplate.is_saved) {
      this.templateType = 'isSavedTemplate';
    } else if (this.currentHub.id != null && this.currentHub.id != -1 && !this.currentHub.is_saved) {
      this.templateType = 'isSavedHub';
    } else {
      this.templateType = 'newTemplate';
      this.getTemplateEx();
    }
    $('#templateModal').modal('show');
  }

  async saveNewTemplate(event: any) {
    const that = this;
    let formData = new FormData();
    formData.append('channel_id', this.channel.id);
    formData.append('name', this.currentTemplate.name);
    let uri = encodeURIComponent(`${environment.magic}/template/create`);
    await axios.post(`/pass/${uri}`, formData)
      .then(async (response) => {
        that.currentTemplate.id = response.data.id;
        that.currentTemplate.is_saved = true;
        localStorage.setItem('currentTemplate', JSON.stringify(that.currentTemplate));
        that.storageKey = `state_${that.username}_${that.channel.id}_${that.currentTemplate.id}`;
        let state = JSON.parse(localStorage.getItem(that.storageKey));
        if (!state) {
          let obj = {
            username: that.username,
            channel: that.channel,
            layers: [],
            previews: [],
            outputWidth: that.outputWidth,
            outputHeight: that.outputHeight,
            dimensions: that.dimensions,
            defaultStep: 10,
            thumbnailSeconds: 0,
            autoTemplate: that.defaultAutoTemplate,
            projectName: 'Untitled project',
            addedFonts: [],
            lyricData: null,
            lyricSource: 'deezer'
          };
          let src_tpl_id = '';
          if (that.template.example.template_id) src_tpl_id = that.template.example.template_id;
          else if (that.template.clone.template_id) src_tpl_id = that.template.clone.template_id;
          if (src_tpl_id) {
            uri = encodeURIComponent(`${environment.magic}/template/load/${src_tpl_id}`);
            let result = await axios.get(`/pass/${uri}`);
            let data = result.data;
            if (data.id != 0) {
              state = JSON.parse(data.tpl_studio);
              Object.assign(obj, { layers: state.layers, previews: state.previews, outputWidth: state.outputWidth, outputHeight: state.outputHeight, dimensions: state.dimensions, thumbnailSeconds: state.thumbnailSeconds });
            }
          }
          localStorage.setItem(that.storageKey, JSON.stringify(obj));
        }
        that.openSnackBar(`Created Template ${response.data.id}`, 1000);
        localStorage.removeItem('currentHub');
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => $('#templateModal').modal('hide'));
  }

  async saveTemplate(event: any = null) {
    let tplStudio = localStorage.getItem(this.storageKey);
    let tplRender = this.layers.filter(e => !e.isHidden);
    let fontLayers = tplRender.filter(e => e.type == 'text' || e.type == 'text_list' || e.type == 'lyric');
    if (this.currentTemplate.id == null || this.currentTemplate.id == -1 || !tplStudio) this.openSnackBar('Please choose a template');
    else if (tplRender.some(x => x.type == 'image' && x.image_url && x.isBackground && (x.position.width != this.outputWidth || x.position.height != this.outputHeight))) this.openSnackBar('Please set bg size to 1920 x 1080');
    else if (!tplRender.some(x => x.type == 'lyric') && this.autoTemplate.type == 1) this.openSnackBar('No Lyric layer');
    else if (!tplRender.some(x => x.type == 'compilation') && this.autoTemplate.type == 2) this.openSnackBar('No Compilation layer');
    else if (!tplRender.some(x => x.type == 'mix_lyric') && this.autoTemplate.type == 4) this.openSnackBar('No Mix lyric layer');
    else if (tplRender.filter(x => { return x.type == 'compilation' || x.type == 'lyric' || x.type == 'mix_lyric' }).length > 1) this.openSnackBar("Can haven't Compilation, Lyric and Mix lyric layer at the same time");
    else if (tplRender.filter(x => { return x.type == 'video_background' || x.type == 'footage' }).length > 1) this.openSnackBar("Can haven't Video Background and Footage layer at the same time");
    else if (fontLayers.some(x => !this.defaultFonts.find(y => y.direct_link == x.font_url))) this.openSnackBar('Please update a new font of Text or Lyric layer');
    else {
      const that = this;
      let formData = new FormData();
      formData.append('id', this.currentTemplate.id);
      formData.append('channel_id', this.channel.id);
      formData.append('channel_name', this.channel.name);
      formData.append('tpl_render', JSON.stringify(tplRender));
      formData.append('tpl_studio', tplStudio);
      formData.append('thumbnail_seconds', this.thumbnailSeconds);
      formData.append('name', this.currentTemplate.name);
      formData.append('user_name', this.username);
      let uri = encodeURIComponent(`${environment.magic}/template/update`);
      await axios.post(`/pass/${uri}`, formData)
        .then(function (response) {
          that.currentTemplate.is_saved = true;
          that.openSnackBar(`Saved Template ${that.currentTemplate.id}`, 3000);
          that.getTemplate();
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(() => {
          that.channelInput.nativeElement.value = that.channel.name;
          $('#templateModal').modal('hide');
        });
    }
  }

  alertMessage: any = null;

  getHub() {
    return new Promise((resolve, reject) => {
      const that = this;
      let uri = encodeURIComponent(`${environment.magic}/hub/list/${this.currentTemplate.id}`);
      axios.get(`/pass/${uri}`)
        .then(function (response) {
          that.hubList = response.data;
          resolve(true);
        })
        .catch(function (error) {
          console.log(error);
          resolve(false);
        });
    });
  }

  loadHub() {
    if (this.currentHub.id == null || this.currentHub.id == -1) {
      this.autoTemplate = this.defaultAutoTemplate;
      this.hubLog = '';
    } else {
      const that = this;
      this.isLoading = true;
      this.hubLog = '';
      let uri = encodeURIComponent(`${environment.magic}/hub/load/${this.currentHub.id}`);
      axios.get(`/pass/${uri}`)
        .then(async (response) => {
          if (response.data.tpl_meta != undefined) {
            that.autoTemplate.meta = JSON.parse(response.data.tpl_meta);
            // if (!that.autoTemplate.meta.hasOwnProperty('tiktok_title')) that.autoTemplate.meta.tiktok_title = '';
            // if (!that.autoTemplate.meta.hasOwnProperty('tiktok_desc')) that.autoTemplate.meta.tiktok_desc = '';
            // if (!that.autoTemplate.meta.hasOwnProperty('tiktok_start_time_hours')) that.autoTemplate.meta.tiktok_start_time_hours = 0;
            // if (!that.autoTemplate.meta.hasOwnProperty('tiktok_start_time_minutes')) that.autoTemplate.meta.tiktok_start_time_minutes = 0;
            // if (!that.autoTemplate.meta.hasOwnProperty('tiktok_start_time_seconds')) that.autoTemplate.meta.tiktok_start_time_seconds = 30;
            // if (!that.autoTemplate.meta.hasOwnProperty('tiktok_duration_hours')) that.autoTemplate.meta.tiktok_duration_hours = 0;
            // if (!that.autoTemplate.meta.hasOwnProperty('tiktok_duration_minutes')) that.autoTemplate.meta.tiktok_duration_minutes = 0;
            // if (!that.autoTemplate.meta.hasOwnProperty('tiktok_duration_seconds')) that.autoTemplate.meta.tiktok_duration_seconds = 30;
            // if (!that.autoTemplate.meta.hasOwnProperty('tiktok_transpose')) that.autoTemplate.meta.tiktok_transpose = true;
            that.normalizeAutoMeta(that.autoTemplate.meta);
          }
          if (response.data.hub != undefined) {
            that.autoTemplate.hub = JSON.parse(response.data.hub);
            let sourceLayer = that.layers.find(x => (x.type == 'lyric' || x.type == 'compilation' || x.type == 'mix_lyric'));
            if (sourceLayer) {
              let item = that.autoTemplate.hub?.find(x => x.layer_id == sourceLayer.id);
              if (item) {
                let layerText = `Source ${item.source_id || 'empty'}`;
                if (sourceLayer.type == 'compilation' || sourceLayer.type == 'mix_lyric') {
                  sourceLayer.music_data = item.music_data;
                  if (sourceLayer.type == 'compilation' && item.sound_effect_id) {
                    sourceLayer.sound_effect = item.sound_effect;
                    sourceLayer.sound_effect_id = item.sound_effect_id;
                    layerText += ` - SFX ${item.sound_effect_id}`;
                  }
                }
                if (!item.source_id && item.collection_id) layerText = `Collection ${item.collection_id}`;
                sourceLayer.source_id = item.source_id;
                sourceLayer.text = layerText;
              }
              // else {
              //   if (sourceLayer.type == 'compilation' || sourceLayer.type == 'mix_lyric') {
              //     sourceLayer.music_data = [];
              //     if (sourceLayer.type == 'compilation') {
              //       sourceLayer.sound_effect = [];
              //       sourceLayer.sound_effect_id = null;
              //     }
              //   }
              //   sourceLayer.source_id = null;
              //   sourceLayer.text = sourceLayer.type;
              // }
              if (sourceLayer.type == 'compilation' || sourceLayer.type == 'mix_lyric') {
                sourceLayer.comp_data = {};
                if (sourceLayer.type == 'mix_lyric') sourceLayer.mix_data = [];
              }
              that.saveStorage({ layers: that.layers });
            }
          }
          if (response.data.env != undefined) {
            that.autoTemplate.env = JSON.parse(response.data.env);
            for (let item of that.autoTemplate.env) {
              if (item.code == 'collection') {
                uri = encodeURIComponent(`${environment.magic}/collection/load/${item.value}`);
                let response = await axios.get(`/pass/${uri}`);
                let results = JSON.parse(response.data.data);
                for (let el of results) {
                  const index = that.langCodeList.findIndex(x => x.code == el.code);
                  if (index == -1) that.langCodeList.push(el);
                }
              } else {
                const index = that.langCodeList.findIndex(x => x.code == item.code);
                if (index == -1) that.langCodeList.push(item);
                that.addEnvTags(item);
              }
            }
            that.convertCodeToEnv();
            that.setMentionConfig();
            if (!that.autoTemplate.env.length) that.autoTemplate.env = [{ name: null, value: null }];
          }
          that.hubLog = that.parseHubLog(response.data.log);
          that.autoTemplate.status = response.data.status == 3 ? true : false;
          that.autoTemplate.is_schedule = response.data.is_schedule == 1 ? true : false;
          that.autoTemplate.time_start = parseFloat(response.data.time_start);
          that.autoTemplate.time_stop = parseFloat(response.data.time_stop);
          that.autoTemplate.type = response.data.type;
          that.autoTemplate.post_type = response.data.post_type;
          if (response.data.supc_id) {
            that.autoTemplate.supc_id = response.data.supc_id;
            uri = encodeURIComponent(`${environment.magic}/collection/load/${response.data.supc_id}`);
            let resCollection = await axios.get(`/pass/${uri}`);
            let result = JSON.parse(resCollection.data.data);
            that.applySpcVariables(result?.fields || []);
          } else that.applySpcVariables([]);
          that.saveStorage({ autoTemplate: that.autoTemplate });
        })
        .catch((error) => console.log(error))
        .then(() => that.isLoading = false);
    }
  }

  parseHubLog(log: any) {
    if (!log) return '';
    return log.split('\n').filter((x: any) => x.trim()).slice(-10).reverse().join('\n');
  }

  refreshHubLog() {
    if (this.currentHub.id == null || this.currentHub.id == -1) return;
    const that = this;
    this.isLoadingHubLog = true;
    let uri = encodeURIComponent(`${environment.magic}/hub/load/${this.currentHub.id}`);
    axios.get(`/pass/${uri}`)
      .then((response) => that.hubLog = that.parseHubLog(response.data.log))
      .catch((error) => console.log(error))
      .then(() => that.isLoadingHubLog = false);
  }

  hubChange(event: any) {
    if (this.currentHub.id != null && this.currentHub.id != -1 && !this.currentHub.is_saved) {
      this.templateType = 'isSavedHub';
      $('#templateModal').modal('show');
    } else {
      let selectedOption = event.target.options[event.target.selectedIndex];
      let name = selectedOption.getAttribute('name');
      this.currentHub = { id: selectedOption.value, name: name, is_saved: true };
      localStorage.setItem('currentHub', JSON.stringify(this.currentHub));
      this.loadHub();
    }
  }

  newHub() {
    if (this.currentHub.id != null && this.currentHub.id != -1 && !this.currentHub.is_saved) {
      this.templateType = 'isSavedHub';
    } else {
      this.templateType = 'newHub';
    }
    $('#templateModal').modal('show');
  }

  saveNewHub(event: any) {
    if (this.currentTemplate.id == null || this.currentTemplate.id == -1) this.openSnackBar('Please choose a template');
    else if (!this.autoTemplate.type || this.autoTemplate.type == 0) this.openSnackBar('Please choose a hub type');
    else {
      const that = this;
      let formData = new FormData();
      formData.append('channel_id', this.channel.id);
      formData.append('template_id', this.currentTemplate.id);
      formData.append('name', this.currentHub.name);
      formData.append('type', this.autoTemplate.type);
      formData.append('user_name', this.username);
      let uri = encodeURIComponent(`${environment.magic}/hub/create`);
      axios.post(`/pass/${uri}`, formData)
        .then(function (response) {
          that.currentHub.id = response.data.id;
          that.currentHub.is_saved = true;
          localStorage.setItem('currentHub', JSON.stringify(that.currentHub));
          that.openSnackBar(`Created Hub ${response.data.id}`, 1000);
          that.getHub();
          that.hubLog = '';
          that.autoTemplate = that.defaultAutoTemplate;
          that.autoTemplate.type = response.data.type;
          that.convertCodeToEnv();
          that.setMentionConfig();
          let sourceLayer = that.layers.find(x => (x.type == 'lyric' || x.type == 'compilation' || x.type == 'mix_lyric'));
          if (sourceLayer) {
            if (sourceLayer.type == 'compilation') {
              sourceLayer.music_data = [];
              sourceLayer.comp_data = {};
              sourceLayer.sound_effect = [];
              sourceLayer.sound_effect_id = null;
            } else if (sourceLayer.type == 'mix_lyric') {
              sourceLayer.music_data = [];
              sourceLayer.mix_data = [];
              sourceLayer.comp_data = {};
            }
            sourceLayer.source_id = null;
            sourceLayer.text = sourceLayer.type;
            that.saveStorage({ layers: that.layers });
          }
        })
        .catch(function (error) { console.log(error) })
        .then(() => $('#templateModal').modal('hide'));
    }
  }

  saveHubClick() {
    this.templateType = 'saveHub';
    this.addTags(['title', 'description', 'tags', 'comment', 'tiktok_title', 'tiktok_desc']);
  }

  async saveHub(event: any = null) {
    if (this.currentHub.id == null || this.currentHub.id == -1) this.openSnackBar('Please choose a hub');
    else if (!this.autoTemplate.type || this.autoTemplate.type == 0) this.openSnackBar('Please choose a hub type');
    else if (this.autoTemplate.meta.schedule != null && this.autoTemplate.meta.schedule.some(x => x.date == null || x.time == null || x.time_zone == null)) this.openSnackBar('Please fill in all schedule fields');
    else if (!this.autoTemplate.meta.title || (!this.autoTemplate.meta.description && !this.autoTemplate.meta.is_desc_empty) || (!this.autoTemplate.meta.tags && !this.autoTemplate.meta.is_tags_empty)) this.openSnackBar('Please fill in all meta fields');
    else if (this.autoTemplate.meta.auto_card && !this.autoTemplate.meta.auto_card.target_video_id) this.openSnackBar('Please fill in all card fields');
    else if (this.autoTemplate.meta.auto_endscreen && !this.autoTemplate.meta.auto_endscreen.target_video_id) this.openSnackBar('Please fill in all endscreen fields');
    else {
      await this.saveTemplate();
      const that = this;
      let formData = new FormData();
      formData.append('id', this.currentHub.id);
      formData.append('tpl_meta', JSON.stringify(this.autoTemplate.meta));
      formData.append('hub', JSON.stringify(this.autoTemplate.hub));
      formData.append('env', JSON.stringify(this.autoTemplate.env));
      formData.append('status', this.autoTemplate.status ? '3' : '1');
      formData.append('is_schedule', this.autoTemplate.is_schedule ? '1' : '0');
      formData.append('time_start', this.autoTemplate.time_start || 0);
      formData.append('time_stop', this.autoTemplate.time_stop || 0);
      formData.append('name', this.currentHub.name);
      formData.append('type', this.autoTemplate.type);
      formData.append('post_type', this.autoTemplate.post_type);
      formData.append('supc_id', this.autoTemplate.supc_id);
      if (event == 'rerender') formData.append('next_time_scan', '0');
      let uri = encodeURIComponent(`${environment.magic}/hub/update`);
      axios.post(`/pass/${uri}`, formData)
        .then(function (response) {
          that.currentHub.is_saved = true;
          that.openSnackBar(`Updated Hub ${that.currentHub.id}`, 3000);
          that.getHub();
          let currentOff = that.autoTemplate.status ? 3 : 1;
          let isHubOn = that.hubList.some(x => Number(x.id == that.currentHub.id ? currentOff : x.status) != 3);
          let hubForm = new FormData();
          hubForm.append('channel_id', that.channel.id);
          hubForm.append('hub', isHubOn ? '1' : '0');
          axios.post(`/pass/${encodeURIComponent(`${environment.music}/api/studio/updateHub`)}`, hubForm).catch(error => console.log(error));
        })
        .catch(function (error) { console.log(error) })
        .then(() => {
          that.channelInput.nativeElement.value = that.channel.name;
          $('#templateModal').modal('hide');
        });
      this.saveStorage({ autoTemplate: this.autoTemplate });

      if (this.autoTemplate.status) {
        let schedUri = encodeURIComponent(`${environment.magic}/job/get/scheduling-by-hub/${this.currentHub.id}`);
        axios.get(`/pass/${schedUri}`)
          .then((response) => {
            const promises = response.data.map((jobId) => this.editorService.stopJob(jobId));
            Promise.all(promises).catch((error) => { console.error(error) });
          })
          .catch((error) => { console.error(error) });
      }
    }
  }

  convertCodeToEnv() {
    let textLayers = this.layers.filter(x => x.type == 'text' && x.lang_code);
    if (textLayers.length) {
      for (let item of textLayers) {
        for (let match of item.lang_code.matchAll(/@@env_(.*?)@@/g)) {
          let obj = { code: match[0], name: `env_${match[1]}`, value: null };
          let index = this.langCodeList.findIndex(x => x.code == obj.code);
          if (index == -1) this.langCodeList.push(obj);
          index = this.autoTemplate.env.findIndex(x => x.code == obj.code);
          if (index == -1) this.autoTemplate.env.unshift(obj);
        }
      }
      this.saveStorage({ autoTemplate: this.autoTemplate });
    }
  }

  btnShowEnv() {
    let state = JSON.parse(localStorage.getItem(this.storageKey));
    if (state) this.autoTemplate.env = state.autoTemplate.env;
    else this.autoTemplate.env = [{ name: null, value: null }];
    $('#envModal').modal({ backdrop: 'static' });
  }

  btnExtendEnv() {
    Object.assign(this.collectionData, { isExtend: true, filterType: 4 });
    this.getCollections(1, null, 4);
    $('#envModal').css({ 'z-index': 990 });
    $('#collectionModal').css({ 'z-index': 990 });
    $('#collectionModal').modal('show');
  }

  addVar() {
    for (let item of this.autoTemplate.env) {
      if (!item.name?.startsWith('env_')) item.name = `env_${item.name}`;
      let obj = { code: item.code == 'collection' ? item.code : `@@${item.name}@@`, name: item.name, value: item.value };
      const index = this.langCodeList.findIndex(x => x.code == obj.code);
      if (index == -1 && obj.code != 'collection') this.langCodeList.push(obj);
    }
    this.setMentionConfig();
    this.autoTemplate.env.push({ name: null, value: null });
  }

  validVarName(event: any) {
    return new RegExp(/\w/).test(event.key);
  }

  varNameChange(value: any, index: any) {
    this.autoTemplate.env[index].name = value.replace(/\W+/g, '_');
  }

  varValueChange(value: any, index: any) {
    let item = this.autoTemplate.env[index];
    item.value = value;
    this.addEnvTags(item);
  }

  deleteVar(currentIndex: any) {
    if (this.autoTemplate.env.length > 1) {
      const index = this.langCodeList.findIndex(x => x.code == this.autoTemplate.env[currentIndex].code);
      if (index != -1) {
        this.langCodeList.splice(index, 1);
        this.setMentionConfig();
      }
      this.autoTemplate.env.splice(currentIndex, 1);
    };
  }

  fancyFont: any = {};

  isEnvFontChanged(checked: any, index: any) {
    let item = this.autoTemplate.env[index];
    this.fancyFont[`is_env_${item.name}`] = checked;
    if (checked) this.fancyFont[`env_${item.name}_ori_text`] = item.value;
    else item.value = this.fancyFont[`env_${item.name}_ori_text`]
  }

  envApplyClicked(event: any, index: any) {
    let item = this.autoTemplate.env[index];
    let fonts = this.fancyFont[`env_${item.name}_fonts`];
    if (item.value.includes('@@') || item.code == 'collection') this.openSnackBar('Just apply font for text only');
    else if (!fonts || (fonts && !fonts.length)) this.openSnackBar('Please choose some fonts');
    else {
      let replaced_text = '';
      let pattern = /\w/g;
      if (this.fancyFont[`env_${item.name}_first_letter`]) pattern = /\b\w/g;
      if (item.value.includes('|')) {
        let parts = item.value.split('|');
        let replaced_parts: any = [];
        for (let part of parts) {
          let font = fonts[Math.floor(Math.random() * fonts.length)];
          let rules = JSON.parse(font.rules);
          replaced_parts.push(part.replace(pattern, (match) => {
            let result = rules.find(x => x.in == match);
            return result ? result.out : match;
          }));
        }
        replaced_text = replaced_parts.join('|');
      } else {
        let rules = JSON.parse(fonts[0].rules);
        replaced_text = item.value.replace(pattern, (match) => {
          let result = rules.find(x => x.in == match);
          return result ? result.out : match;
        });
      }
      item.value = replaced_text;
    }
  }

  async saveEnv(event: any) {
    let mappedEnv: any = [];
    for (let item of this.autoTemplate.env) {
      let obj;
      if (item.code == 'collection') {
        obj = item;
        let uri = encodeURIComponent(`${environment.magic}/collection/load/${item.value}`);
        let response = await axios.get(`/pass/${uri}`);
        let results = JSON.parse(response.data.data);
        for (let el of results) {
          const index = this.langCodeList.findIndex(x => x.code == el.code);
          if (index == -1) this.langCodeList.push(el);
        }
      } else {
        if (!item.name?.startsWith('env_')) item.name = `env_${item.name}`;
        obj = { code: `@@${item.name}@@`, name: item.name, value: item.value };
        const index = this.langCodeList.findIndex(x => x.code == obj.code);
        if (index == -1) this.langCodeList.push(obj);
      }
      mappedEnv.push(obj);
    }
    if (this.controlType.includes('collection:env')) {
      let collectionId = this.controlType.split(':')[2];
      let formData = new FormData();
      formData.append('id', collectionId);
      formData.append('data', JSON.stringify(mappedEnv));
      let uri = encodeURIComponent(`${environment.magic}/collection/update`);
      await axios.post(`/pass/${uri}`, formData);
    } else {
      this.setMentionConfig();
      this.autoTemplate.env = mappedEnv;
      if (this.currentHub.id == null || this.currentHub.id == -1) this.openSnackBar('Please choose a hub');
      else {
        let formData = new FormData();
        formData.append('id', this.currentHub.id);
        formData.append('env', JSON.stringify(this.autoTemplate.env));
        let uri = encodeURIComponent(`${environment.magic}/hub/update`);
        await axios.post(`/pass/${uri}`, formData);
        this.openSnackBar(`Updated Env of Hub ${this.currentHub.id}`, 1000);
        this.saveStorage({ autoTemplate: this.autoTemplate });
      }
    }
    $('#envModal').modal('hide');
  }

  getLyric(value: any) {
    return new Promise((resolve, reject) => {
      const that = this;
      let results: any = [];
      let isRequestLyric = false;
      this.isLoading = true;
      if (this.lyricSource == 'deezer') {
        let uri = encodeURIComponent(`${environment.track}/tracks/?deezer_id=${value}`);
        axios.get(`/pass/${uri}`)
          .then(async (response) => {
            if (response.data.count > 0) {
              results = response.data.results;
              uri = encodeURIComponent(`${environment.music}/api/get/ignore/artists?deezer_artist_id=${value}`);
              await axios.get(`/pass/${uri}`)
                .then((response) => {
                  if (response.data == 0) {
                    that.openSnackBar('DO NOT UPLOAD THIS TRACK');
                    results = [];
                  }
                })
                .catch((error) => console.log(error));
            } else isRequestLyric = true;
            if (that.outputHeight > that.outputWidth) {
              uri = encodeURIComponent(`${environment.music}/api/bom/getHighlight?deezer_id=${value}`);
              await axios.get(`/pass/${uri}`)
                .then((response) => {
                  if (response.data?.status !== 'error' && response.data?.highlight && results.length) {
                    results = results.map((item: any) => {
                      if (item.deezer_id == value) {
                        item.highlights = response.data.highlight.highlights.map((x: any) => ({
                          section_name: x.section_name,
                          start_ms: x.start_ms,
                          end_ms: x.end_ms,
                          priority: x.priority
                        }));
                      }
                      return item;
                    });
                  }
                })
                .catch((error) => console.log(error));
            }
            resolve(results);
          })
          .catch((error) => console.log(error))
          .then(() => {
            if (isRequestLyric) {
              uri = encodeURIComponent(`${environment.track}/tracks/?request_music=&deezer_id=${value}`);
              axios.get(`/pass/${uri}`)
                .then((response) => {
                  that.openSnackBar('This track has been requested');
                })
                .catch((error) => console.log(error));
            }
            that.isLoading = false;
          });
      } else {
        let uri = encodeURIComponent(`${environment.timestamp}/timestamp/${value}/`);
        axios.get(`/pass/${uri}`)
          .then((response) => {
            if (response.data.id != undefined) results.push(response.data);
            resolve(results);
          })
          .catch((error) => console.log(error))
          .then(() => that.isLoading = false);
      }
      this.saveStorage({ lyricSource: this.lyricSource });
    });
  }

  lyricSearchChange(value: any) {
    this.lyricList = [];
    this.getLyric(value).then(response => {
      this.lyricList = response;
    });
  }

  async getDeezerArtistId(deezerId: any) {
    let result = null;
    let uri = encodeURIComponent(`${environment.magic}/lyric/deezer/artist/find/${deezerId}`);
    await axios.get(`/pass/${uri}`)
      .then((response) => {
        result = response.data;
      })
      .catch((error) => {
        console.log(error);
        result = null;
      });
    return result;
  }

  async selectedLyric(item: any, highlight?: any) {
    const index = this.layers.findIndex(x => x.id == this.layerData.id);
    if (index == -1) return;
    this.lyricData = item;
    this.projectName = `${item.artist} - ${item.title}`;
    this.layers.forEach(e => {
      if (e.mapType == 'title') e.text = item.title;
      if (e.mapType == 'artist') e.text = item.artist;
    });
    let duration = 0;
    let selectedIndex = this.layers[index];
    let parts = item.url_128 != null ? item.url_128.split('.') : '';
    selectedIndex.lyric_sync = item.lyric_sync;
    selectedIndex.audio_url = item.url_128;
    if ('duration' in item) duration = item.duration;
    selectedIndex.audio_duration = duration;
    selectedIndex.audio_ext = parts[parts.length - 1];
    try {
      let lyricSync = JSON.parse(item.lyric_sync);
      if (lyricSync.length > 0) {
        selectedIndex.startLyric = Math.round((parseInt(lyricSync[0]['milliseconds']) / 1000) % 60);
        lyricSync.forEach(e => {
          if (e['line'].length >= selectedIndex.wrap_width) {
            selectedIndex.text = e['line'].slice(0, selectedIndex.wrap_width);
            return;
          }
        });
      }
    } catch (err) {
      console.log(err);
      this.openSnackBar('This song has no lyrics');
    }
    if (item.deezer_id) {
      let artistId = await this.getDeezerArtistId(item.deezer_id);
      if (artistId) selectedIndex.deezer_artist_id = artistId;
    } else if (item.deezer_artist_id) selectedIndex.deezer_artist_id = item.deezer_artist_id;
    if (highlight) {
      selectedIndex.highlight_start_ms = highlight.start_ms;
      selectedIndex.highlight_end_ms = highlight.end_ms;
    }
    $('#lyricModal').modal('hide');
    this.saveStorage({ lyricData: this.lyricData, layers: this.layers, projectName: this.projectName }, false, true);
    // let _queryParams = {};
    // if (this.lyricSource == 'deezer') _queryParams = { deezerId: item.deezer_id };
    // else _queryParams = { localId: item.id };
    // this.route.navigate([], {
    //   queryParams: _queryParams,
    //   queryParamsHandling: 'merge',
    //   relativeTo: this.activatedRoute
    // });
  }

  audioElement: HTMLAudioElement | null = null;
  currentPlayingHighlight: any = null;

  playHighlight(lyric: any, highlight: any) {
    if (this.audioElement) {
      this.audioElement.pause();
    }
    this.audioElement = new Audio(lyric.url_128);
    this.currentPlayingHighlight = highlight;
    this.audioElement.currentTime = highlight.start_ms / 1000;
    this.audioElement.play();
    this.audioElement.addEventListener('timeupdate', () => {
      if (this.audioElement && this.audioElement.currentTime >= highlight.end_ms / 1000) {
        this.audioElement.pause();
        this.currentPlayingHighlight = null;
      }
    });
    this.audioElement.addEventListener('ended', () => {
      this.currentPlayingHighlight = null;
    });
  }

  stopHighlight() {
    if (this.audioElement) {
      this.audioElement.pause();
      this.audioElement = null;
      this.currentPlayingHighlight = null;
    }
  }

  isPlaying(highlight: any): boolean {
    return this.currentPlayingHighlight === highlight;
  }

  directionClick(direction: any) {
    const index = this.layers.findIndex(x => x.id == this.layerData.id);
    if (index == -1) return;
    let selectedIndex = this.layers[index];
    const directionIndex = selectedIndex.arr_direction.findIndex(x => x == direction);
    if (directionIndex == -1) selectedIndex.arr_direction.push(direction);
    else selectedIndex.arr_direction.splice(directionIndex, 1);
    this.saveStorage({ layers: this.layers }, false, true);
  }

  logout() {
    localStorage.removeItem('_');
    this.route.navigate(['/login'], { queryParams: this.activatedRoute.snapshot.queryParams, queryParamsHandling: 'merge' });
    return;
  }

  testJob: any = {};
  testLayers: any = null;
  isSpinner: any = null;

  async renderTest() {
    if (this.currentHub.id == null || this.currentHub.id == -1) this.openSnackBar('Please choose a hub');
    else {
      try {
        this.isSpinner = 'test';
        await this.saveHub();
        let uri = encodeURIComponent(`${environment.magic}/hub/debug/${this.currentHub.id}`);
        let response = await axios.get(`/pass/${uri}`, { timeout: 60000 });
        let data = response.data;
        if (data.length) {
          this.testJob.id = data[0];
          uri = encodeURIComponent(`${environment.magic}/job/loadx/${this.testJob.id}`);
          response = await axios.get(`/pass/${uri}`);
          data = response.data;
          if (data.id != 0) {
            let meta = JSON.parse(data.reup_config);
            if (!meta) this.testJob.meta = {};
            else {
              this.testJob.meta = {
                title: meta.title,
                description: meta.description,
                tags: meta.tags
              };
            }
            let content = JSON.parse(data.content);
            this.testLayers = content.filter(x => !x.hasOwnProperty('effect_render'));
            this.showPreview();
            for (let item of this.testLayers) {
              switch (item.type) {
                case 'image':
                  $(`${this.parentClass} #${item.id}_${item.type}`).css({ backgroundImage: `url("${item.directUrl}")` });
                  break;
                case 'video':
                case 'video_background':
                  $(`${this.parentClass} #${item.id}_video`).attr('poster', item.poster);
                  $(`${this.parentClass} #${item.id}_videosource`).attr('src', item.directUrl);
                  break;
                case 'text':
                  $(`${this.parentClass} #${item.id}_${item.type}_text`).text(item.text);
                  $(`${this.parentClass} div[data-id="${item.id}"]`).css({
                    fontSize: `${this.setRatio(item.fontSize, '*')}px`,
                    width: `${this.setRatio(item.position.width, '*') + 5}px`,
                    height: `${this.setRatio(item.position.height, '*')}px`,
                    top: `${this.setRatio(item.position.top, '*')}px`,
                    left: `${this.setRatio(item.position.left, '*')}px`,
                  });
                  break;
                case 'lyric':
                  $(`${this.parentClass} #${item.id}_audiosource`).attr('src', item.audio_url);
                  break;
              }
            }
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.isSpinner = null;
      }
    }
  }

  async submitRenderTestJob() {
    try {
      this.isSpinner = 'render-test';
      const uri = encodeURIComponent(`${environment.magic}/job/update`);
      await axios.post(`/pass-json/${uri}`, { id: this.testJob.id, type: 4, status: 0 }, {
        headers: { 'Content-Type': 'application/json' }
      });
      this.openSnackBar(`Render test job ${this.testJob.id} success`, 3000);
    } catch (err) {
      console.log(err);
      this.openSnackBar(`Render test job ${this.testJob.id} failed`);
    } finally {
      this.isSpinner = null;
    }
  }

  showPreview() {
    $(".workspace").clone().appendTo(".modal-preview-body");
    $(this.parentClass + " .element").remove();
    $('#modal-preivew').modal({ backdrop: 'static' });
    $(this.parentClass + " .canvas").css({ "outline": "none" });
    $(this.parentClass + " .canvasActive").css({ "outline": "none" });
    $(this.parentClass + " .ui-icon").css({ "background-image": "none" });
  }

  closePreviewModal() {
    const that = this;
    $("#modal-preivew").on('hide.bs.modal', function () {
      that.testJob = {};
      $(".modal-preview-body").html("");
      $("#playpausebtnsvg").html('<path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>');
      $("#playpausebtn").val(1);
    });
  }

  preview(event: any) {
    let that = this;
    var play = $("#playpausebtn").val();
    let layers = [];
    if (this.testLayers) {
      layers = this.testLayers;
    } else {
      layers = this.layers;
    }
    var lyric_id: any;
    var audioplayer: any;
    var lyric_sync = Array();
    var listlayer = Array();
    var videos = Array();
    var audio: any;
    var seekslider = $("#seekslider");
    var currentLine: any;
    var count = 0;

    layers.forEach(function (value: any) {
      if (value.type.includes('video')) {
        videos.push(value);
      } else if (value.type == 'lyric') {
        var temp = JSON.parse(value.lyric_sync);
        temp.forEach((item: { milliseconds: any; }) => {
          if (item.milliseconds != undefined) {
            lyric_sync.push(item);
          }
        });
        audio = value;
        audioplayer = $(that.parentClass + ' #' + value.id + '_player');
        lyric_id = that.parentClass + ' #' + value.id + '_' + value.type + '_text';
        if (value.startLyric != 0) {
          $(lyric_id).html("");
        }
      }
      if (value.type == 'text' || value.type == 'image' || value.type.includes('video')) {
        listlayer.push(value);
      }
      if (value.type.includes('video') || value.type == 'image') {
        $(that.parentClass + ' #' + value.id + '_' + value.type + '_text').hide();
      }
      if (value.startTime > 0) {
        that.getIdControl(value).hide();
      }
    });

    if (audio == null) {
      this.openSnackBar("You have to add lyric first");
      return;
    }
    var duration = audioplayer[0].duration + audio.startTime;
    videos.forEach(video => {
      if (video.startTime == 0) {
        that.playPause(video);
      }
    });
    if (audio.startTime == 0) {
      this.playPause(audio);
    } else {
      if (play == 0) {
        audioplayer[0].pause();
      } else {
        var i = 1;
        if (audio.startTime > 0 && audio.startTime > that.currentTime) {
          var mainLoopId = setInterval(function () {
            if (i < audio.startTime) {
              that.updatePlayerTime(i, duration, 0);
            }
            that.changeStylePlayPause(play);
            if (play == 1) {
              $("#playpausebtn").val(0);
            } else {
              $("#playpausebtn").val(1);
            }
            listlayer.forEach(item => {
              if (item.startTime <= audio.startTime) {
                that.showHide(item, audio, i, true);
              }
            });
            if (i == audio.startTime) {
              // clearInterval(mainLoopId);
              that.playPause(audio);
            }
            i++;
          }, 1000);
        }
      }
    }

    that.audioTimeUpdate(audioplayer, that.currentTime, seekslider, listlayer, lyric_sync, count, currentLine, lyric_id, audio, duration, play);
  }

  playPause(data) {
    var player;
    if (data.type == 'lyric') {
      player = $(this.parentClass + ' #' + data.id + '_player')[0];
      this.changeStylePlayPause(player.paused);
    } else {
      player = $(this.parentClass + ' #' + data.id + '_' + data.type)[0];
      if (player) {
        if (data.isLoop || data.isBackground) {
          player.loop = true;
        }
        if (data.isMute || data.isBackground) {
          player.muted = true;
        }
      }
    }
    if (player) {
      if (player.paused) {
        player.play();
      } else {
        player.pause();
      }
    }
  }

  showHide(item, audio, currentTime, isBeforePlaymusic) {
    var startTimeLyric = audio.startTime;
    if (isBeforePlaymusic) {
      startTimeLyric = 0;
    }
    if (item.startTime + startTimeLyric == 0) {
      if (item.duration != -1) {
        if (currentTime + startTimeLyric >= item.duration) {
          if (this.getIdControl(item).is(":visible")) {
            this.getIdControl(item).fadeOut();
            if (item.type.includes("video")) {
              this.getIdControl(item)[0].pause();
            }
          }
        } else {
          if (this.getIdControl(item).is(":hidden")) {
            this.getIdControl(item).fadeIn();
            if (item.type.includes("video")) {
              this.playPause(item);
            }
          }
        }
      }
    } else {
      if (currentTime + startTimeLyric >= item.startTime && (currentTime + startTimeLyric <= (item.startTime + item.duration) || item.duration == -1)) {
        if (this.getIdControl(item).is(":hidden")) {
          this.getIdControl(item).fadeIn();
          if (item.type.includes("video")) {
            this.playPause(item);
          }
        }
      } else if (currentTime + startTimeLyric > (item.startTime + item.duration) && item.duration != -1) {
        if (this.getIdControl(item).is(":visible")) {
          this.getIdControl(item).fadeOut();
          if (item.type.includes("video")) {
            this.getIdControl(item)[0].pause();
          }
        }
      }
    }
  }

  updatePlayerTime(currentTime, duration, lyricStartTime) {
    var curmins = Math.floor((currentTime + lyricStartTime) / 60);
    var cursecs = Math.floor((currentTime + lyricStartTime) - curmins * 60);
    var durmins = Math.floor(duration / 60);
    var dursecs = Math.floor(duration - durmins * 60);
    $("#cur").html(String(curmins).padStart(2, '0') + ":" + String(cursecs).padStart(2, '0'));
    $("#dur").html(String(durmins).padStart(2, '0') + ":" + String(dursecs).padStart(2, '0'));
  }

  changeStylePlayPause(flag: any) {
    if (flag == 1 || flag == true) {
      $("#playpausebtnsvg").html('<path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>');
    } else {
      $("#playpausebtnsvg").html('<path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>');
    }
  }

  audioTimeUpdate(audioplayer, currentTime, seekslider, listlayer, lyric_sync, count, currentLine, lyric_id, audio, duration, play) {
    let that = this;
    $(document).ready(function () {
      audioplayer.on('timeupdate', function (e) {
        currentTime = this.currentTime;
        seekslider.val((currentTime + audio.startTime) * (100 / duration));
        that.updatePlayerTime(currentTime, duration, audio.startTime);

        if (listlayer.length > 0) {
          listlayer.forEach(item => {
            if (item.startTime >= audio.startTime) {
              that.showHide(item, audio, currentTime, false);
            }
            if (currentTime + audio.startTime == duration) {
              $("#playpausebtnsvg").html('<path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>');
              if (item.type.includes("video")) {
                that.getIdControl(item)[0].pause();
              }
            }
          });
        }

        var past = lyric_sync.filter(function (item) {
          return ((item.milliseconds / 1000) < currentTime && item.milliseconds != undefined);
        });

        if (past.length > count) {
          count = past.length;
          currentLine = past[past.length - 1];
          $(lyric_id).hide().html(currentLine.line).fadeIn();
        }
      });

      seekslider.on('change', function (e) {
        let seekto = duration * (this.value / 100) + audio.startTime;
        audioplayer[0].currentTime = seekto;
      });
    });
  }

  getIdControl(data) {
    if (data.type == 'lyric' || data.type == 'text') {
      return $(this.parentClass + ' #' + data.id + '_' + data.type + '_text');
    } else {
      return $(this.parentClass + ' #' + data.id + '_' + data.type);
    }
  }

  spcDefault: any = { fields: [{ field: 'spc_title', type: 'string', meta: {} }, { field: 'spc_description', type: 'text', meta: {} }, { field: 'spc_tags', type: 'text', meta: {} }], data: [{ spc_title: '', spc_description: '', spc_tags: '', count: 0, status: 1 }] };
  collectionData: any = { type: 1, name: 'Untitled folder', results: [], page: 1, isLoading: false, hasError: false, isExtend: false, searchText: null, filterType: '', filterGroup: 'all', al: 'random-order', warning_threshold: 15, youtube: { al: 'random' }, shorts: { selects: [], topics: [], videos: [] }, super: JSON.parse(JSON.stringify(this.spcDefault)) };
  currentCollection: any = {};
  collectionType: any = null;
  collectionLoaded: any = null;
  collectionLinked: any = {};

  mapCollectionData(data: any[]) {
    return data.map(e => {
      e.data = JSON.parse(e.data);
      // if (e.type == 3) e.data.data.map(o => o.uri = o.uri.split(':').pop());
      return e;
    });
  }

  getCollections(page: any = 1, name: any = null, type: any = null, group: string = 'all') {
    if (page == -1) return;
    if (page == 1) Object.assign(this.collectionData, { results: [], page: 1 });
    if (type == '') type = null;
    const that = this;
    let collectionId;
    const result = this.autoTemplate.hub?.find(x => x.layer_id == this.layerData.id);
    if (!name && !type && result?.collection_id) collectionId = result.collection_id;
    else if (this.layerData.comp_data?.collection?.id) collectionId = this.layerData.comp_data.collection.id;
    else if (this.autoTemplate?.supc_id) collectionId = this.autoTemplate.supc_id;
    let uri = this.editorService.collectionListUri(group, type, page, name);
    this.fetchCollectionList(uri, (data) => {
      if (data.length) {
        if (that.collectionData.results.length && this.collectionLinked.id) data = data.filter(x => x.id != this.collectionLinked.id);
        that.collectionData.results = [...that.collectionData.results, ...that.mapCollectionData(data)];
        page++;
        that.collectionData.page = page;
      } else that.collectionData.page = -1;
    });
    if (collectionId) {
      const request = this.collectionRequest;
      let linkedUri = this.editorService.collectionListUri(group, null, 1, String(collectionId));
      axios.get(`/pass/${linkedUri}`)
        .then((response) => {
          if (request == that.collectionRequest && response.data.length) that.collectionLinked = that.mapCollectionData(response.data)[0];
        })
        .catch((error) => console.log(error));
    }
  }

  collectionRequest = 0;

  // Only the latest request may update the list, so an older reload cannot end the loading state or append twice.
  fetchCollectionList(uri: string, apply: (data: { id: number }[]) => void) {
    const request = ++this.collectionRequest;
    Object.assign(this.collectionData, { isLoading: true, hasError: false });
    axios.get(`/pass/${uri}`)
      .then((response) => {
        if (request == this.collectionRequest) apply(response.data);
      })
      .catch((error) => {
        console.log(error);
        if (request != this.collectionRequest) return;
        this.collectionData.hasError = true;
        if (this.collectionData.results.length) this.openSnackBar('Could not load more collections');
      })
      .then(() => {
        if (request == this.collectionRequest) this.collectionData.isLoading = false;
      });
  }

  loadMoreCollections() {
    const { page, searchText, filterType, filterGroup } = this.collectionData;
    // The "Group" placeholder stores '', which page 1 already loads as 'all'.
    this.getCollections(page, searchText, filterType, filterGroup || 'all');
  }

  collectionSearch(query: any) {
    if (!query) return;
    this.collectionData.searchText = query;
    this.getCollections(1, query, this.collectionData.filterType, this.collectionData.filterGroup);
  }

  filterGroupChange(value: any) {
    this.collectionData.filterGroup = value;
    if (!value) this.getCollections(1, this.collectionData.searchText, this.collectionData.filterType);
    else this.getCollections(1, this.collectionData.searchText, this.collectionData.filterType, value);
  }

  filterTypeChange(value: any) {
    const that = this;
    this.collectionData.filterType = value;
    if (!value) this.getCollections(1, this.collectionData.searchText, null, this.collectionData.filterGroup);
    else if (value == 'outdated') {
      this.collectionData.results = [];
      let uri = encodeURIComponent(`${environment.magic}/collection/get-warning/${this.username}`);
      this.fetchCollectionList(uri, (data) => that.collectionData.results = that.mapCollectionData(data));
    } else this.getCollections(1, this.collectionData.searchText, value, this.collectionData.filterGroup);
  }

  btnNewCollection() {
    this.collectionType = 'new';
    this.collectionData.name = 'Untitled folder';
    $('#collectionChildModal').modal('show');
  }

  newCollection() {
    const that = this;
    let formData = new FormData();
    formData.append('type', this.collectionData.type);
    if (this.collectionData.type == 3) formData.append('data', JSON.stringify({ al: 'random-order', data: [] }));
    else if (this.collectionData.type == 5) formData.append('data', JSON.stringify({ al: 'random-order', data: [], static: '' }));
    else if (this.collectionData.type == 6) formData.append('data', '{}');
    else if (this.collectionData.type == 7) formData.append('data', JSON.stringify({ al: 'random-order', topics: [], data: [], static: '' }));
    else if (this.collectionData.type == 8) formData.append('data', JSON.stringify({ al: 'random-order', ...this.spcDefault }));
    formData.append('name', this.collectionData.name);
    formData.append('warning_thres', this.collectionData.warning_threshold);
    formData.append('user', this.username);
    let uri = encodeURIComponent(`${environment.magic}/collection/create`);
    axios.post(`/pass/${uri}`, formData)
      .then((response) => {
        that.currentCollection = that.mapCollectionData([response.data])[0];
        that.openSnackBar('Created Collection', 1000);
        that.reloadCollection();
      })
      .catch((error) => console.log(error))
      .then(() => $('#collectionChildModal').modal('hide'));
  }

  cloneCollection() {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/collection/clone/${this.currentCollection.id}/${this.username}`);
    axios.get(`/pass/${uri}`)
      .then((response) => {
        that.currentCollection = that.mapCollectionData([response.data])[0];
        that.openSnackBar('Cloned Collection', 1000);
        that.reloadCollection();
      })
      .catch((error) => console.log(error));
  }

  btnEditCollection() {
    this.collectionType = 'edit';
    this.collectionData.name = this.currentCollection.name;
    this.collectionData.share_user = this.currentCollection.share_user ? this.currentCollection.share_user.split(',') : [];
    if (['3', '5'].includes(this.currentCollection.type)) this.collectionData.al = this.currentCollection.data.al;
    else if (this.currentCollection.type == 6) this.collectionData.youtube = this.currentCollection.data.data || [];
    else if (this.currentCollection.type == 7) {
      this.collectionData.al = this.currentCollection.data.al;
      this.collectionData.shorts.topics = this.currentCollection.data.topics || [];
    } else if (this.currentCollection.type == 8) {
      this.collectionData.al = this.currentCollection.data.al;
      // Copied so edits closed without Update do not leak into the list item and hide the draft on reopen.
      const { fields, data } = JSON.parse(JSON.stringify(this.currentCollection.data));
      Object.assign(this.collectionData.super, { fields, data });
      this.currentEntry = this.collectionData.super.data.length - 1;
      this.ensureMusicTarget(this.currentEntry);
      this.spcPicks = this.newSpcPicks();
      if (fields.some(f => f.type == 'footage')) this.loadFootageSources();
      this.startSpcDraft();
    }
    $('#collectionChildModal').modal('show');
  }

  async editCollection() {
    if (this.spcDraft.pending) return;
    if (this.currentCollection.type == 8 && !this.validateSpcMusic()) return;
    let formData = new FormData();
    formData.append('id', this.currentCollection.id);
    formData.append('name', this.collectionData.name);
    if (this.collectionData.share_user) formData.append('share_user', this.collectionData.share_user.join(','));
    // Written into the list item only after the update succeeds, so a failed update does not show unsaved data as saved.
    let data: { [key: string]: unknown } | null = null;
    if (['3', '5'].includes(this.currentCollection.type)) {
      data = { ...this.currentCollection.data, al: this.collectionData.al };
      formData.append('data', JSON.stringify(data));
    }
    else if (this.currentCollection.type == 6) formData.append('data', JSON.stringify(this.collectionData.youtube));
    else if (this.currentCollection.type == 7) {
      const videos = this.currentCollection.data.data;
      let diff = this.collectionData.shorts.videos.filter(e => !videos.find(x => x.uri == e.uri));
      const allVideos = videos.concat(diff);
      let dataCount = allVideos.length;
      data = { ...this.currentCollection.data, al: this.collectionData.al, data: allVideos, static: `${dataCount}/${dataCount}`, topics: this.collectionData.shorts.topics };
      formData.append('data', JSON.stringify(data));
      formData.append('avail_cnt', dataCount);
      formData.append('total_cnt', dataCount);
    } else if (this.currentCollection.type == 8) {
      const prefix = 'spc_';
      this.collectionData.super.fields = this.collectionData.super.fields.map(f => ({ ...f, field: f.field?.startsWith(prefix) ? f.field : `${prefix}${f.field}` }));
      const keys = [...this.collectionData.super.fields.map(f => f.field), ...['count', 'status']];
      this.collectionData.super.data = this.collectionData.super.data.map(entry =>
        keys.reduce((acc, key) => {
          const value = key == 'count' ? 0 : entry[key] || entry[key.replace(prefix, '')];
          return { ...acc, ...(value !== undefined && { [key]: value }) };
        }, {}));
      // Backend reads the field type from the value, like image/video values.
      const musicKey = this.musicField?.field;
      if (musicKey) this.collectionData.super.data.forEach(entry => {
        if (entry[musicKey] && typeof entry[musicKey] == 'object') entry[musicKey].type = 'music';
      });
      data = { ...this.currentCollection.data, al: this.collectionData.al, fields: this.collectionData.super.fields, data: this.collectionData.super.data };
      formData.append('data', JSON.stringify(data));
    }
    let uri = encodeURIComponent(`${environment.magic}/collection/update`);
    await axios.post(`/pass/${uri}`, formData);
    if (data) Object.assign(this.currentCollection.data, data);
    if (this.currentCollection.type == 8) {
      this.stopSpcDraft();
      // Not awaited so a stuck IndexedDB cannot hold up a finished update; if it fails, the draft cannot be read back either.
      this.editorService.deleteSpcDraft(this.spcDraftKeyOf(this.currentCollection.id)).catch(() => undefined);
    }
    this.openSnackBar(`Updated Collection ${this.currentCollection.id}`, 1000);
    this.reloadCollection();
    if (['3', '5', '7', '8'].includes(this.currentCollection.type)) this.collectionData.al = 'random-order';
    else if (this.currentCollection.type == 6) this.collectionData.youtube = { al: 'random' };
    $('#collectionChildModal').modal('hide');
  }

  youtubeLinkChange(event: any) {
    let previousLinks = this.collectionData.youtube.links ? this.collectionData.youtube.links.split(/\r?\n/) : [];
    this.collectionData.youtube.links = event.target.value;
    if (!this.collectionData.youtube.data) this.collectionData.youtube.data = [];
    let currentLinks = event.target.value.split(/\r?\n/);
    let diffLinks = previousLinks.filter(x => !currentLinks.includes(x)).concat(currentLinks.filter(x => !previousLinks.includes(x)));
    let validLinks = diffLinks.filter((e, i, self) => e.includes('http') && i == self.findIndex(x => x == e));
    for (let link of validLinks) {
      let obj;
      link = link.trim();
      if (link.includes('youtube.com') || link.includes('youtu.be')) {
        obj = { is_trim: false, start: 10, end: 10, status: 0 };
        if (link.includes('playlist')) obj.uri = `youtube:playlist:${link.match(/list=(.*?)(&|$)/)[1]}`;
        else if (link.includes('channel')) obj.uri = `youtube:channel:${link.split('/').pop()}`;
        else obj.uri = `youtube:video:${link.includes('youtube.com') ? link.match(/v=(.*?)(&|$)/)[1] : link.split('/').pop()}`;
      }
      if (obj) {
        const index = this.collectionData.youtube.data.findIndex(x => x.uri == obj.uri);
        if (index == -1) this.collectionData.youtube.data.push(obj);
        else this.collectionData.youtube.data.splice(index, 1);
      }
    }
  }

  checkboxTrim(checked: any, index: any) {
    this.collectionData.youtube.data[index].is_trim = checked;
    if (checked) {
      this.collectionData.youtube.data[index].start = 10;
      this.collectionData.youtube.data[index].end = 10;
    } else {
      this.collectionData.youtube.data[index].start = 0;
      this.collectionData.youtube.data[index].end = 0;
    }
  }

  trimChange(value: any, index: any, type: any) {
    this.collectionData.youtube.data[index][type] = parseInt(value) || 0;
  }

  getShortsTopics() {
    const that = this;
    let uri = encodeURIComponent(`${environment.music}/api/shorts/topics?username=${this.username}`);
    axios.get(`/pass/${uri}`)
      .then((response) => that.collectionData.shorts.selects = response.data)
      .catch((error) => console.log(error));
  }

  getShortsVideos() {
    const that = this;
    let topic = `topic[]=${this.collectionData.shorts.topics.map(e => e.topic).join('&topic[]=')}`;
    let numFound = this.collectionData.shorts.topics.length > 1 ? this.collectionData.shorts.topics.reduce((a, b) => a.total + b.total) : this.collectionData.shorts.topics[0].total;
    let limit = 1000;
    let numPage = Math.ceil(numFound / limit);
    for (let i = 0; i < numPage; i++) {
      let uri = encodeURIComponent(`${environment.music}/api/shorts/videos?${topic}&limit=${limit}&page=${i}`);
      axios.get(`/pass/${uri}`)
        .then((response) => {
          if (response.data.length) {
            response.data = response.data.map(e => {
              return { uri: `youtube:video:${e.video_id}`, count: 0, status: 1 };
            });
            that.collectionData.shorts.videos = [...that.collectionData.shorts.videos, ...response.data];
          }
        })
        .catch((error) => console.log(error));
    }
  }

  shortsTopicChange(values: any) {
    this.collectionData.shorts.topics = values;
    if (values.length) this.getShortsVideos();
    else this.collectionData.shorts.videos = [];
  }

  async btnUpdateCollection(sourceId: any = '') {
    const layerId = this.layerData.id;
    this.layerData = {};
    $('#collectionModal').css({ 'z-index': 990 });
    if (this.currentCollection.type == 4) {
      this.controlType = `collection:env:${this.currentCollection.id}`;
      let uri = encodeURIComponent(`${environment.magic}/collection/load/${this.currentCollection.id}`);
      let response = await axios.get(`/pass/${uri}`);
      let results = JSON.parse(response.data.data);
      // The env modal edits autoTemplate.env, so the collection env takes its place only while the modal is open.
      const hubEnv = this.autoTemplate.env;
      if (results.length) this.autoTemplate.env = results;
      else this.autoTemplate.env = [{ name: null, value: null }];
      $('#envModal').css({ 'z-index': 995 });
      $('#envModal').one('hidden.bs.modal', () => {
        this.autoTemplate.env = hubEnv;
        this.collectionReselectLayer(layerId);
      });
      $('#envModal').modal({ backdrop: 'static' });
    } else {
      if (this.currentCollection.type == 1) this.controlType = `collection:image:${this.currentCollection.id}`;
      else if (this.currentCollection.type == 2) this.controlType = `collection:video:${this.currentCollection.id}`;
      else if (this.currentCollection.type == 3) this.controlType = `collection:music:${this.currentCollection.id}:${sourceId}`;
      $('#hubModal').css({ 'z-index': 995 });
      $('#hubModal').one('hidden.bs.modal', () => this.collectionReselectLayer(layerId));
      $('#hubModal').modal('show');
    }
  }

  collectionReselectLayer(layerId: string) {
    const layer = this.layers.find(x => x.id == layerId);
    if (layer && this.controlType.startsWith('collection:')) this.selectedLayer(layer);
  }

  btnLinkCollection() {
    this.collectionType = 'link';
    $('#collectionChildModal').modal('show');
  }

  selectCollection() {
    const index = this.layers.findIndex(x => x.id == this.layerData.id);
    if (index == -1) return;
    let selectedIndex = this.layers[index];
    if (!selectedIndex.comp_data.collection) selectedIndex.comp_data.collection = {};
    Object.assign(selectedIndex.comp_data.collection, { id: this.currentCollection.id, type: this.currentCollection.type });
    if (this.currentCollection.type == 1) {
      let imageUrls = this.currentCollection.data.data.map(e => e.poster);
      selectedIndex.render_data.data[selectedIndex.comp_data.field] = this.editorService.shuffle(imageUrls, selectedIndex.render_data.data?.imageCount || 10);
    }
    this.saveStorage({ layers: this.layers }, false, true);
    this.closeCollection();
  }

  async linkCollection() {
    if (this.collectionData.isExtend) {
      let obj = { code: 'collection', name: 'env_collection', value: this.currentCollection.id };
      let index = this.autoTemplate.env.findIndex(x => x.code == obj.code && x.value == obj.value);
      if (index == -1) this.autoTemplate.env.unshift(obj);
      let uri = encodeURIComponent(`${environment.magic}/collection/load/${this.currentCollection.id}`);
      let response = await axios.get(`/pass/${uri}`);
      let results = JSON.parse(response.data.data);
      for (let el of results) {
        const index = this.langCodeList.findIndex(x => x.code == el.code);
        if (index == -1) this.langCodeList.push(el);
      }
      this.setMentionConfig();
    } else if (this.layerData.type == 'image' || this.layerData.type.includes('video')) {
      this.currentHub.is_saved = false;
      this.layerData.isCanva = false;
      this.layerData.is_hub = true;
      let collectionStatic = '0/0';
      if (this.currentCollection.avail_cnt && this.currentCollection.total_cnt) collectionStatic = `${this.currentCollection.avail_cnt}/${this.currentCollection.total_cnt}`;
      const index = this.autoTemplate.hub.findIndex(x => x.layer_id == this.layerData.id);
      if (index == -1) this.autoTemplate.hub.push({ layer_id: this.layerData.id, layer_name: this.layerData.text, collection_id: this.currentCollection.id, collection_static: collectionStatic });
      else Object.assign(this.autoTemplate.hub[index], { collection_id: this.currentCollection.id, collection_static: collectionStatic });
    } else if (this.layerData.type == 'lyric' || this.layerData.type == 'compilation') {
      this.currentHub.is_saved = false;
      this.layerData.is_hub = true;
      const index = this.autoTemplate.hub.findIndex(x => x.layer_id == this.layerData.id);
      if (index == -1) this.autoTemplate.hub.push({ layer_id: this.layerData.id, layer_name: this.layerData.type, collection_id: this.currentCollection.id });
      else Object.assign(this.autoTemplate.hub[index], { collection_id: this.currentCollection.id });
      if (this.layerData.type == 'lyric') this.autoTemplate.type = 1;
      else if (this.layerData.type == 'compilation') {
        this.autoTemplate.type = 2;
        if (!this.layerData.source_id) {
          this.layerData.music_data = [];
          this.layerData.text = `Collection ${this.currentCollection.id}`;
        }
      }
    }
    this.saveStorage({ autoTemplate: this.autoTemplate, layers: this.layers }, false, true);
    $('#collectionChildModal').modal('hide');
    this.closeCollection();
  }

  linkedCollection(collectionId: any) {
    const result = this.autoTemplate.hub?.find(x => x.layer_id == this.layerData.id);
    return (result?.collection_id == collectionId || this.layerData.comp_data?.collection?.id == collectionId || this.autoTemplate.supc_id == collectionId) ? true : false;
  }

  btnDelCollection() {
    this.collectionType = 'del';
    $('#collectionChildModal').modal('show');
  }

  delCollection() {
    const that = this;
    const collectionId = this.currentCollection.id;
    let uri = encodeURIComponent(`${environment.magic}/collection/del/${collectionId}`);
    axios.get(`/pass/${uri}`)
      .then((response) => {
        // A leftover draft is removed by the 7-day cleanup.
        that.editorService.deleteSpcDraft(that.spcDraftKeyOf(collectionId)).catch(() => undefined);
        that.currentCollection = {};
        that.openSnackBar('Deleted Collection', 1000);
        that.reloadCollection();
      })
      .catch((error) => console.log(error))
      .then(() => $('#collectionChildModal').modal('hide'));
  }

  reloadCollection() {
    Object.assign(this.collectionData, { results: [], page: 1, searchText: null, filterType: '', filterGroup: 'all' });
    this.getCollections();
  }

  collectionToggle(item: any) {
    this.collectionLoaded = item.id;
    this.paginator.coll.page = 0;
    this.showUpdateCollectionItem = false;
    const isOpening = !$(`#collapse-${item.id}`).hasClass('show');
    if (item.type == 8 && isOpening) this.getHubBySpc(item);
    $(`#collapse-${item.id}`).collapse('toggle');
  }

  getHubBySpc(item: any) {
    item.spcHubList = undefined;
    let uri = encodeURIComponent(`${environment.magic}/hub/list-by-spc/${item.id}`);
    axios.get(`/pass/${uri}`)
      .then((response) => item.spcHubList = response.data || [])
      .catch((error) => { console.log(error); item.spcHubList = []; });
  }

  addCollectionItem() {
    if (!this.currentCollection?.data?.data) return;
    const newItem: any = { uri: `automusic:source:${this.collectionData.new_source_id}`, count: 0, status: 1 };
    if (this.currentCollection.data.data.some(x => x.uri == newItem.uri)) return;
    this.currentCollection.data.data.push(newItem);
    this.showUpdateCollectionItem = true;
    this.collectionData.new_source_id = '';
  }

  removeCollectionItem(item: any) {
    if (!this.currentCollection?.data?.data) return;
    const index = this.currentCollection.data.data.findIndex(x => (this.currentCollection.type == 3 ? x.uri == item.uri : x.resource_id == item.resource_id));
    if (index === -1) return;
    this.currentCollection.data.data.splice(index, 1);
    item.poster = null;
    this.showUpdateCollectionItem = true;
  }

  showUpdateCollectionItem: boolean = false;

  async updateCollectionItem(collection: any) {
    if (collection.id != this.currentCollection.id) return;
    const that = this;
    let dataCount = this.currentCollection.data.data.length;
    this.currentCollection.data.static = `${dataCount}/${dataCount}`;
    let formData = new FormData();
    formData.append('id', this.currentCollection.id);
    formData.append('data', JSON.stringify(this.currentCollection.data));
    formData.append('avail_cnt', dataCount);
    formData.append('total_cnt', dataCount);
    let uri = encodeURIComponent(`${environment.magic}/collection/update`);
    await axios.post(`/pass/${uri}`, formData)
      .then(() => {
        that.openSnackBar(`Updated Collection Data ${that.currentCollection.id}`, 1000);
        that.reloadCollection();
      })
      .finally(() => that.showUpdateCollectionItem = false);
  }

  closeCollection() {
    if (!this.layerData.hasOwnProperty('id')) this.controlType = '';
    this.currentCollection = {};
    Object.assign(this.collectionData, { isExtend: false, searchText: null, filterType: '', filterGroup: 'all' });
    $('.collapse').collapse('hide');
    $('#collectionModal').modal('hide');
  }

  entryLoading: any = null;
  currentEntry: any = null;
  spcValidationErrors: Set<number> = new Set();
  paginator: any = { entry: { page: 0, limit: 10 }, coll: { page: 0, limit: 18 }, image: { page: 0, limit: 10 }, video: { page: 0, limit: 10 } };

  nextPage(paginator: any, data: any) {
    if ((paginator.page + 1) * paginator.limit < data.length) paginator.page++;
  }

  prevPage(paginator: any) {
    if (paginator.page > 0) paginator.page--;
  }

  entryVisible(paginator: any, index: number) {
    const start = paginator.page * paginator.limit;
    const end = start + paginator.limit;
    return index >= start && index < end;
  }

  simplePaginate(paginator: any, data: any) {
    const startIndex = paginator.page * paginator.limit;
    return data.slice(startIndex, startIndex + paginator.limit);
  }

  btnSuperCollection() {
    Object.assign(this.collectionData, { filterType: 8 });
    this.getCollections(1, null, 8);
    $('#collectionModal').css({ 'z-index': 990 });
    $('#collectionModal').modal('show');
  }

  loadSuperCollection() {
    this.applySpcVariables(this.currentCollection.data.fields);
    this.autoTemplate.supc_id = this.currentCollection.id;
    this.saveStorage({ autoTemplate: this.autoTemplate });
    this.closeCollection();
  }

  spcCopyPrompt() {
    const that = this;
    const field = this.collectionData.super.fields.map(e => e.field).join(', ');
    navigator.clipboard.writeText(`Tạo danh sách JSON gồm các mục, mỗi mục là một object chứa ${field} dưới dạng chuỗi`)
      .then(() => that.openSnackBar('Copied Prompt', 1000));
  }

  spcImportFromFile(event: any) {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const result = reader.result as string;
        const spcJsonData = JSON.parse(result);
        this.collectionData.super.data = [...this.collectionData.super.data, ...spcJsonData.map(e => ({ ...e, count: 0, status: 1 }))];
        this.openSnackBar('Imported from file', 1000);
      } catch (err) {
        this.openSnackBar('Invalid JSON file');
      }
    };
    reader.onerror = () => {
      this.openSnackBar('Error reading file');
    };
    reader.readAsText(file);
  }

  spcImport() {
    try {
      const spcJsonData = JSON.parse(this.collectionData.spc_json_data);
      this.collectionData.super.data = [...this.collectionData.super.data, ...spcJsonData.map(e => ({ ...e, count: 0, status: 1 }))];
      this.openSnackBar('Imported Data', 1000)
    } catch (error) {
      this.openSnackBar('Invalid JSON Data');
    }
  }

  spcDraft: {
    key: string | null;
    saved: string;
    pending: SpcDraft | null;
    savedTime: number | null;
    timer: ReturnType<typeof setInterval> | null;
    error: string | null;
  } = { key: null, saved: '', pending: null, savedTime: null, timer: null, error: null };

  spcDraftKeyOf(collectionId: string | number) {
    return `${this.username}_${collectionId}`;
  }

  // share_user is left out so restoring an old draft cannot give back access removed meanwhile.
  spcDraftSnapshot() {
    const { name, al, super: spc } = this.collectionData;
    return JSON.stringify({ name, al, fields: spc.fields, data: spc.data });
  }

  // Compares snapshots without the music defaults the picker adds, so just opening entries is not an edit,
  // and without count, which the server manages and editCollection resets before posting.
  spcDraftSignature(snapshot: string) {
    const { fields, data, ...rest } = JSON.parse(snapshot);
    const musicKey = fields?.find(f => f.type == 'music')?.field;
    const entries = data.map(({ count, ...entry }) => musicKey ? { ...entry, [musicKey]: this.editorService.musicWithoutDefaults(entry[musicKey]) } : entry);
    return JSON.stringify({ ...rest, fields, data: entries });
  }

  async startSpcDraft() {
    this.stopSpcDraft();
    const key = this.spcDraftKeyOf(this.currentCollection.id);
    Object.assign(this.spcDraft, { key, saved: this.spcDraftSignature(this.spcDraftSnapshot()), error: null });
    this.spcDraft.timer = setInterval(() => this.saveSpcDraft(), 30000);
    let draft: SpcDraft | undefined;
    try {
      draft = await this.editorService.getSpcDraft(key);
    } catch (error) {
      if (this.spcDraft.key == key) this.spcDraft.error = 'Could not read draft';
      return;
    }
    // The modal may have been closed or opened on another collection while reading.
    if (!draft || this.spcDraft.key != key) return;
    let draftSignature: string;
    try {
      draftSignature = this.spcDraftSignature(draft.snapshot);
    } catch (error) {
      // An unparsable draft would fail on every open.
      await this.editorService.deleteSpcDraft(key).catch(() => undefined);
      return;
    }
    // A draft equal to the saved data holds nothing unsaved.
    if (draftSignature == this.spcDraft.saved) {
      await this.editorService.deleteSpcDraft(key).catch(() => undefined);
      return;
    }
    // Unsaved data is shown only after the user picks Restore, so it is never mistaken for saved data.
    this.spcDraft.pending = draft;
  }

  restoreSpcDraft() {
    const draft = this.spcDraft.pending;
    if (!draft) return;
    this.applySpcSnapshot(draft.snapshot);
    Object.assign(this.spcDraft, { pending: null, saved: this.spcDraftSignature(draft.snapshot), savedTime: draft.updated_time });
  }

  spcDraftChanged() {
    return this.spcDraftSignature(this.spcDraftSnapshot()) != this.spcDraft.saved;
  }

  async saveSpcDraft() {
    const key = this.spcDraft.key;
    // While Restore/Discard is asked the form is hidden, and the waiting draft must not be overwritten.
    if (!key || this.spcDraft.pending) return;
    const snapshot = this.spcDraftSnapshot();
    const signature = this.spcDraftSignature(snapshot);
    if (signature == this.spcDraft.saved) return;
    const updatedTime = Math.floor(Date.now() / 1000);
    try {
      await this.editorService.putSpcDraft({ key, updated_time: updatedTime, snapshot });
      if (this.spcDraft.key == key) Object.assign(this.spcDraft, { saved: signature, savedTime: updatedTime, error: null });
    } catch (error) {
      if (this.spcDraft.key == key) this.spcDraft.error = 'Could not save draft, retrying';
    }
  }

  stopSpcDraft() {
    if (this.spcDraft.timer) clearInterval(this.spcDraft.timer);
    Object.assign(this.spcDraft, { key: null, timer: null, pending: null, savedTime: null });
  }

  applySpcSnapshot(snapshot: string) {
    const { name, al, fields, data } = JSON.parse(snapshot);
    Object.assign(this.collectionData, { name, al });
    Object.assign(this.collectionData.super, { fields, data });
    // A draft may add a footage field that the saved SPC did not have.
    if (fields.some(f => f.type == 'footage')) this.loadFootageSources();
    this.spcValidationErrors.clear();
    this.openEntry(data.length - 1);
  }

  // Only offered while Restore/Discard is asked, when the form still holds the saved data and autosave is paused.
  async discardSpcDraft() {
    const key = this.spcDraft.key;
    if (!key) return;
    this.spcDraft.pending = null;
    try {
      await this.editorService.deleteSpcDraft(key);
    } catch (error) {
      if (this.spcDraft.key == key) this.spcDraft.error = 'Could not discard draft';
    }
  }

  // Leaving the editor route with the modal open skips its hidden handler.
  ngOnDestroy() {
    this.saveSpcDraft();
    this.stopSpcDraft();
  }

  @HostListener('window:beforeunload', ['$event']) beforeUnload(event: BeforeUnloadEvent) {
    if (!this.spcDraft.key || this.spcDraft.pending || !this.spcDraftChanged()) return;
    this.saveSpcDraft();
    // The browser's leave prompt gives the async IndexedDB write time to finish.
    event.preventDefault();
    event.returnValue = '';
  }

  spcVariableCodes: string[] = [];

  // Replaces the previous SPC's variables so the @ suggestions only offer fields of the SPC in use.
  applySpcVariables(fields: { field: string }[]) {
    this.langCodeList = this.langCodeList.filter(x => !this.spcVariableCodes.includes(x.code));
    const added = fields
      .map(item => ({ code: `@@${item.field}@@`, name: this.editorService.convertKeyToName(item.field), value: null }))
      .filter(obj => !this.langCodeList.some(x => x.code == obj.code));
    this.langCodeList.push(...added);
    this.spcVariableCodes = added.map(x => x.code);
    this.setMentionConfig();
  }

  newField() {
    this.collectionData.super.fields.push({ field: '', type: 'string', meta: {} });
  }

  deleteField(index: number) {
    if (this.collectionData.super.fields.length < 2) return;
    this.collectionData.super.fields.splice(index, 1);
  }

  entryClick(index: number) {
    this.currentEntry = index;
    this.spcValidationErrors.clear();
    this.ensureMusicTarget(index);
    // this.paginator.image.page = 0;
    // this.paginator.video.page = 0;
  }

  // The music picker only renders for currentEntry, so the open panel must follow it.
  openEntry(index: number) {
    this.currentEntry = index;
    this.paginator.entry.page = Math.floor(index / this.paginator.entry.limit);
    this.ensureMusicTarget(index);
    // The template already adds `show` to the last entry, and Bootstrap's show() then skips closing the other panel.
    setTimeout(() => {
      $('#accordion-entry .collapse.show').not('#collapse-entry-' + index).collapse('hide');
      $('#collapse-entry-' + index).collapse('show');
    });
  }

  addEntry(index: number) {
    const entry = Object.assign({}, this.collectionData.super.data[index]);
    Object.keys(entry).forEach(k => {
      if (!['count', 'status'].includes(k)) entry[k] = (entry[k] !== null && typeof entry[k] == 'object') ? {} : '';
    });
    this.collectionData.super.data.push(entry);
    this.spcValidationErrors.clear();
    this.openEntry(this.collectionData.super.data.length - 1);
  }

  deleteEntry(index: number) {
    const data = this.collectionData.super.data;
    if (data.length < 2) return;
    data.splice(index, 1);
    this.spcValidationErrors.clear();
    this.openEntry(index < this.currentEntry ? this.currentEntry - 1 : Math.min(this.currentEntry ?? index, data.length - 1));
  }

  uploadStatus: any = {};

  async awsFileInput(file: File, type: string, entry: any, field: string, index: number) {
    this.entryLoading = type + 'File' + index;
    this.uploadStatus[type] = { progress: 0, count: 0, total: 1 };
    let result = await this.editorService.awsCreate(file, type, (percent: number) => {
      const perFile = 100 / this.uploadStatus[type].total;
      this.uploadStatus[type].progress = Math.min(100, (this.uploadStatus[type].count * perFile) + (percent / 100) * perFile);
    });
    if (!result.resource) {
      this.uploadStatus[type].progress = 100;
      this.entryLoading = null;
      this.openSnackBar('Upload failed');
      return;
    }
    this.uploadStatus[type].count++;
    this.uploadStatus[type].progress = 100;
    entry[field] = { resource_id: result.resource.id, poster: result.poster ? result.poster : result.resource.poster, type };
    this.entryLoading = null;
  }

  async awsFilesInput(files: any, type: string, index: number) {
    this.entryLoading = type + 'Files' + index;
    let resources: any = [];
    this.uploadStatus[type] = { progress: 0, count: 0, total: files.length };
    for (let file of files) {
      let result = await this.editorService.awsCreate(file, type, (percent: number) => {
        const perFile = 100 / this.uploadStatus[type].total;
        this.uploadStatus[type].progress = Math.min(100, (this.uploadStatus[type].count * perFile) + (percent / 100) * perFile);
      });
      if (!result.resource || (result.resource && !result.resource.id)) continue;
      this.uploadStatus[type].count++;
      resources.push({ resource_id: result.resource.id, count: 0, status: 1, poster: result.poster ? result.poster : result.resource.poster });
    }
    this.uploadStatus[type].progress = 100;
    this.driveResource[type] = resources;
    this.entryLoading = null;
    this.openSnackBar(`${resources.length} ${type}s uploaded`, 3000);
  }

  driveResource: any = { image: [], video: [] };

  async zipFileInput(value: any, type: string, index: number) {
    const that = this;
    this.entryLoading = type + 'Drive' + index;
    const resourceType = type == 'image' ? 'image-drive-zip' : 'video-drive-zip';
    let formData = new FormData();
    formData.append('user_name', this.username);
    if (value.includes('folders')) formData.append('file_input', value);
    else formData.append('file_input', value.match(/d\/(.*?)\/view/)[1]);
    let uri = encodeURIComponent(`${environment.magic}/resource/${resourceType}`);
    axios.post(`/pass/${uri}`, formData)
      .then(async (response) => {
        let resources: any = [];
        for (let item of response.data) {
          if (!item.id) continue;
          resources.push({ resource_id: item.id, count: 0, status: 1, poster: item.poster });
        }
        that.driveResource[type] = resources;
        that.openSnackBar(`${resources.length} ${type}s uploaded`, 3000);
      })
      .catch((error) => console.log(error))
      .then(() => that.entryLoading = null);
  }

  selectResource(item: any, type: string, entry: any, field: string) {
    entry[field] = { resource_id: item.resource_id, poster: item.poster, type };
  }

  // Read from the entries so a discarded draft or a reopened SPC never leaves a file greyed.
  usedResourceIds() {
    const ids = new Set<string>();
    const fields = this.collectionData.super.fields.filter(f => f.type == 'image' || f.type == 'video');
    for (const entry of this.collectionData.super.data) {
      for (const f of fields) {
        const id = entry[f.field]?.resource_id;
        if (id) ids.add(String(id));
      }
    }
    return ids;
  }

  pickResource(item: SpcResource, type: string, entry: object, field: string, collection: SpcCollection | null) {
    this.selectResource(item, type, entry, field);
    if (collection) this.setEntryCollection(entry, field, type, collection);
  }

  spcCollections: { [type: string]: SpcCollectionList } = {
    image: { results: [], isLoading: false, hasError: false, request: 0, search: '' },
    video: { results: [], isLoading: false, hasError: false, request: 0, search: '' }
  };

  // Picked collections are only a way to browse files, so they stay out of the entry data sent to the server.
  spcPicks: SpcPicks = this.newSpcPicks();

  newSpcPicks(): SpcPicks {
    return { byEntry: new WeakMap(), defaults: {}, pagers: {} };
  }

  searchSpcCollections(type: string, name: string | null) {
    const state = this.spcCollections[type];
    const request = ++state.request;
    Object.assign(state, { isLoading: true, hasError: false, search: name || '' });
    this.editorService.searchCollections(type == 'image' ? 1 : 2, name || null)
      .then((results) => {
        if (request == state.request) state.results = results;
      })
      .catch(() => {
        if (request == state.request) Object.assign(state, { hasError: true, results: [] });
      })
      .then(() => {
        if (request == state.request) state.isLoading = false;
      });
  }

  // After a search the list matches the search box, even when it is empty.
  openSpcCollections(type: string) {
    if (!this.spcCollections[type].request) this.searchSpcCollections(type, null);
  }

  spcCollectionOptions(type: string, picked: SpcCollection | null) {
    const results = this.spcCollections[type].results;
    return picked && !results.some(c => c.id == picked.id) ? [picked, ...results] : results;
  }

  // Keyed by type too, so a field switched between image and video never shows a collection of the other type.
  collectionOf(entry: object, field: string, type: string) {
    const key = `${field}:${type}`;
    return this.spcPicks.byEntry.get(entry)?.[key] || this.spcPicks.defaults[key] || null;
  }

  setEntryCollection(entry: object, field: string, type: string, collection: SpcCollection) {
    const picks = this.spcPicks.byEntry.get(entry) || {};
    picks[`${field}:${type}`] = collection;
    this.spcPicks.byEntry.set(entry, picks);
  }

  chooseEntryCollection(entry: object, field: string, type: string, collection: SpcCollection) {
    this.setEntryCollection(entry, field, type, collection);
    this.spcPicks.defaults[`${field}:${type}`] = collection;
    this.spcPicks.pagers[collection.id] = { page: 0, limit: 10 };
  }

  readonly fieldBadge: { [type: string]: string } = {
    string: 'badge-secondary',
    text: 'badge-info',
    image: 'badge-success',
    video: 'badge-warning',
    music: 'badge-primary',
    footage: 'badge-light'
  };

  footage: { sources: FootageSource[]; isLoading: boolean; hasLoaded: boolean; hasError: boolean } = { sources: [], isLoading: false, hasLoaded: false, hasError: false };

  loadFootageSources() {
    if (this.footage.hasLoaded || this.footage.isLoading) return;
    Object.assign(this.footage, { isLoading: true, hasError: false });
    this.editorService.getSourceUsers()
      .then((results) => Object.assign(this.footage, { sources: results, hasLoaded: true }))
      .catch(() => {
        this.footage.hasError = true;
        this.openSnackBar('Could not load footage sources');
      })
      .then(() => this.footage.isLoading = false);
  }

  // Stats change over time, so keeping them would make an untouched draft look edited.
  footageChange(entry: { [field: string]: unknown }, field: string, sources: FootageSource[]) {
    entry[field] = {
      type: 'footage',
      source_id: sources.length ? sources.map(s => s.id).join(',') : null,
      source_users: sources.map(({ id, name, platform }) => ({ id, name, platform }))
    };
  }

  // Saved sources missing from the list stay as options, otherwise a reopened or cloned entry shows them unselected.
  footageOptions(entry: { [field: string]: { source_users?: FootageSource[] } }, field: string) {
    const saved = (entry[field]?.source_users || []).filter(s => !this.footage.sources.some(x => x.id == s.id));
    return [...saved, ...this.footage.sources];
  }

  cloneEntry(index: number) {
    const entry = { ...JSON.parse(JSON.stringify(this.collectionData.super.data[index])), count: 0 };
    this.collectionData.super.data.splice(index + 1, 0, entry);
    this.spcValidationErrors.clear();
    this.openEntry(index + 1);
  }

  get musicField() {
    return this.collectionData.super.fields.find(f => f.type == 'music');
  }

  get entryFields() {
    return this.collectionData.super.fields.filter(f => f.type != 'music');
  }

  validateSpcMusic() {
    this.spcValidationErrors.clear();
    if (!this.musicField) return true;
    const data = this.collectionData.super.data;
    for (let i = 0; i < data.length; i++) {
      const result = this.editorService.validateEntryMusic(this.musicTargetOf(data[i]), true);
      if (!result.error) continue;
      this.openEntry(i);
      this.spcValidationErrors = new Set(result.errorIndexes);
      // Let the picker of the opened entry render, then switch it to the failing claim/promo tab.
      setTimeout(() => this.spcMusicPicker?.validate());
      this.openSnackBar(`Entry #${i + 1}: ${result.error}`);
      return false;
    }
    return true;
  }

  musicTargetOf(entry: any) {
    const field = this.musicField?.field;
    return field && entry?.[field] && typeof entry[field] == 'object' ? entry[field] : null;
  }

  ensureMusicTarget(index: number) {
    const field = this.musicField?.field;
    const entry = this.collectionData.super.data[index];
    if (!field || !entry) return;
    if (!entry[field] || typeof entry[field] != 'object') entry[field] = {};
    entry[field].type = 'music';
  }

  entryTitle(entry: any) {
    const field = this.collectionData.super.fields.find(f => f.type == 'string');
    return field ? entry[field.field] : '';
  }

  entryHas(entry: any, type: string) {
    const key = type == 'footage' ? 'source_id' : 'resource_id';
    return this.collectionData.super.fields.some(f => f.type == type && entry[f.field]?.[key]);
  }

  entryTrackCount(entry: any) {
    return this.musicField ? this.editorService.countTracks(entry[this.musicField.field]?.music_data) : 0;
  }

  entryMusicSummary(entry: { [field: string]: { music_data?: { music_idx?: string; music_type?: string; limit?: number }[] } }) {
    return this.editorService.musicTypeSummary(this.musicField ? entry[this.musicField.field]?.music_data : null);
  }

  get resourceFields() {
    const s = new Set();
    return this.collectionData.super.fields.filter(
      f => ['image', 'video'].includes(f.type) && !s.has(f.type) && s.add(f.type)
    );
  }

  checkMusicData: any = { music_data: [], spotifyIds: [] };

  async playlistTextChange(event: any) {
    const that = this;
    const { value } = event.target;
    this.checkMusicData.loading = true;
    this.checkMusicData.link_text = value;
    this.checkMusicData.music_data = [];
    this.checkMusicData.spotifyIds = [];
    let links = value.split(/\r?\n/).filter(x => x.includes('spotify.com/playlist'));
    let spotifyPromises = links.map(e =>  {
      let playlistId = e.match(/playlist\/(.*?)(\?|$)/)[1];
      let uri = encodeURIComponent(`${environment.source}/spotify/deezer-checking/${playlistId}`);
      return axios.get(`/pass/${uri}`);
    });
    await Promise.all(spotifyPromises)
      .then(async (responses: any) => {
        const spotifyData = responses.flatMap((response: any) => response.data);
        const deezerPromises = spotifyData.map(track => {
          that.checkMusicData.spotifyIds.push(track.track.id);
          track.is_fuk_artist = track.track.artists.some((x) => that.fukArtists?.has(x.id));

          let isrc = track.track.external_ids.isrc;
          let localDeezerUri = encodeURIComponent(`${environment.track}/tracks/?format=json&isrc=${isrc}`);
          let deezerUri = encodeURIComponent(`https://api.deezer.com/track/isrc:${isrc}`);

          return (async () => {
            try {
              let response = await axios.get(`/pass/${localDeezerUri}`);
              if (response.data.count == 0) throw new Error('no data');
              track.is_deezer = true;
            } catch (error) {
              try {
                let response = await axios.get(`/pass/${deezerUri}`);
                if (response.data.error?.message == 'no data') {
                  track.is_deezer = false;
                  that.getSpotifyList(track);
                } else if (response.data.id) track.is_deezer = true;
                else throw new Error('quota limit');
              } catch (error) {
                try {
                  let response = await axios.get(`/pass-proxy/${deezerUri}`);
                  if (response.data.error?.message == 'no data') {
                    track.is_deezer = false;
                    that.getSpotifyList(track);
                  } else if (response.data.id) track.is_deezer = true;
                  else throw new Error('proxy error');
                } catch (error) {}
              }
            }
            return track;
          })();
        });
        const deezerData = await Promise.all(deezerPromises);
        that.checkMusicData.music_data = deezerData;
      })
      .catch((error) => console.log(error))
      .then(() => that.checkMusicData.loading = false);
  }

  sortedMusicData(data: any) {
    return data.slice().sort((a: any, b: any) => (a.is_deezer === b.is_deezer ? 0 : a.is_deezer ? 1 : -1));
  }

  getSpotifyList(item: any) {
    const that = this;
    let spotifyId = item.track.id;
    this.checkMusicData[spotifyId] = [];
    let uri = encodeURIComponent(`${environment.music}/bom/spotify/get?spotify_id=${spotifyId}`);
    axios.get(`/pass/${uri}`).then((response) => that.checkMusicData[spotifyId] = response.data.data);
  }

  onYoutubeChange(event: any, item: any) {
    const { value } = event.target;
    item.youtube_id = this.parseYoutubeId(value);
    let selectedOption = this.checkMusicData[item.track.id].find(x => x.source_id == value);
    if (selectedOption) item.direct_link = selectedOption.direct_link;
    else item.direct_link = null;
  }

  mapSpotifyYoutube(event: any, item: any) {
    const that = this;
    let uri = encodeURIComponent(`${environment.music}/bom/spotify/save`);
    let data = {
      username: this.username,
      spotify_id: item.track.id,
      youtube_id: item.youtube_id,
      song_name:  item.track.name,
      artist: item.track.artists.map(e => e.name).join(', '),
      duration_ms: item.track.duration_ms,
      genre: item.genre,
    };
    axios.post(`/pass-json/${uri}`, data, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then((response) => {
        if (response.data.status == 'success') {
          item.direct_link = response.data.data.direct_link;
          that.openSnackBar('Saved', 1000);
        } else that.openSnackBar(response.data.message);
      })
      .catch((error) => console.log(error));
    event.srcElement.setAttribute('disabled', true);
    setTimeout(() => event.srcElement.removeAttribute('disabled'), 5000);
  }

  async forceDownloadMusic(event: any) {
    let spotifyPromises = this.checkMusicData.spotifyIds.map(spotifyId =>  {
      let uri = encodeURIComponent(`${environment.source}/spotify/track/get/${spotifyId}`);
      return axios.get(`/pass/${uri}`);
    });
    event.srcElement.innerText = 'Downloading...';
    event.srcElement.setAttribute('disabled', true);
    await Promise.all(spotifyPromises)
      .then((response) => console.log(response))
      .catch((error) => console.log(error))
      .then(() => {
        event.srcElement.innerText = 'Force Download';
        event.srcElement.removeAttribute('disabled');
      });
  }

  async exportSpotifyTimestamp(event: any) {
    const that = this;
    let musicTimestamp = '';
    let data = this.checkMusicData.music_data;
    let lastDurationMs = 0;
    for (const [i, value] of data.entries()) {
      try {
        let artistName = data[i].track.artists.map(e => e.name).join(', ') ?? '';
        let trackName = data[i].track.name ?? '';
        if (i == 0) {
          musicTimestamp = `00:00:00 ${artistName} - ${trackName}\n`;
          continue;
        }
        lastDurationMs += data[i - 1].track.duration_ms ?? 180000;
        let time = new Date(lastDurationMs).toISOString().slice(11, 19);
        musicTimestamp += `${time} ${artistName} - ${trackName}\n`;
      } catch (error) { }
    }
    navigator.clipboard.writeText(musicTimestamp).then(() => that.openSnackBar('Timestamp copied to clipboard', 1000));
    event.srcElement.setAttribute('disabled', true);
    setTimeout(() => event.srcElement.removeAttribute('disabled'), 5000);
  }

  exportCheckMusic(event: any) {
    const that = this;
    let text = this.checkMusicData.music_data
      .filter(x => (x.is_deezer || x.direct_link) && !x.is_fuk_artist)
      .map(e => {
        e.is_deezer ? e = `https://open.spotify.com/track/${e.track.id}` : e = e.direct_link;
        return e;
      })
      .join('\n');
    navigator.clipboard.writeText(text).then(() => that.openSnackBar('Music copied to clipboard', 1000));
    event.srcElement.setAttribute('disabled', true);
    setTimeout(() => event.srcElement.removeAttribute('disabled'), 5000);
  }

  boomMixData: any = { topic: '', pos: 4 };
  claimList: any = [];

  driveLinkChange(event: any) {
    this.boomMixData.links = event.target.value;
    let links = event.target.value.split(/\r?\n/);
    //links = links.filter(x => x.includes('drive.google.com'));
    links = links.map(x => x.trim());
    this.boomMixData.urls = links.join(';;');
  }

  async boomMixTopicTypeChange(value: any) {
    this.boomMixData.topic_type = value;
    this.claimList = await this.editorService.getClaims(value, 'mix', this.username);
  }

  saveBoomMix(event: any) {
    if (!this.boomMixData.topic) this.openSnackBar('Please choose a topic');
    else if (this.boomMixData.pos < 2) this.openSnackBar('Please fill position greater than 1');
    else if (!this.boomMixData.urls) this.openSnackBar('Please fill a link');
    else {
      const that = this;
      Object.assign(this.boomMixData, { isRendering: true, result: null });
      let formData = new FormData();
      formData.append('urls', this.boomMixData.urls);
      formData.append('topic', this.boomMixData.topic);
      formData.append('pos', this.boomMixData.pos);
      formData.append('username', this.username);
      let uri = encodeURIComponent(`http://54.36.172.148/boom/mix.php`);
      axios.post(`/pass/${uri}`, formData)
        .then((response) => {
          that.boomMixData.result = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          Object.assign(that.boomMixData, { links: null, topic: '', pos: 4, urls: null, isRendering: false });
          event.srcElement.removeAttribute('disabled');
        });
      event.srcElement.setAttribute('disabled', true);
    }
  }

  tools: any = { clone_channel: {} };

  async cloneChannel(event: any) {
    try {
      event.srcElement.setAttribute('disabled', true);
      if (!['sangmusic', 'tungtt'].includes(this.username) && !this.channelList.some(x => x.chanel_id == this.tools.clone_channel.source_id)) {
        this.openSnackBar(`You don't own ${this.tools.clone_channel.source_id} channel`);
        return;
      }
      this.tools.clone_channel.is_loading = true;
      if (!this.tools.clone_channel.target_name) {
        let selectedOption = $(`#channels option[value="${this.tools.clone_channel.target_id}"]`);
        this.tools.clone_channel.target_name = selectedOption.text();
      }
      let old_tpl_id;
      let new_tpl_id;
      let old_coll_id;
      let new_coll_id;
      let uri = encodeURIComponent(`${environment.magic}/hub/get/by-channel/${this.tools.clone_channel.source_id}`);
      let hub_res = await axios.get(`/pass/${uri}`);
      for (let item of hub_res.data) {
        if (old_tpl_id != item.template_id) {
          old_tpl_id = item.template_id;
          uri = encodeURIComponent(`${environment.magic}/template/load/${item.template_id}`);
          let tpl_res = await axios.get(`/pass/${uri}`);
          let tpl_data = tpl_res.data;
          Object.assign(tpl_data, { channel_id: this.tools.clone_channel.target_id, channel_name: this.tools.clone_channel.target_name, user_name: this.username });
          let tpl_studio = JSON.parse(tpl_data.tpl_studio);
          Object.assign(tpl_studio, { username: this.username, channel: { id: this.tools.clone_channel.target_id, name: this.tools.clone_channel.target_name } });
          const formData = new FormData();
          formData.append('channel_id', tpl_data.channel_id);
          formData.append('name', tpl_data.name);
          uri = encodeURIComponent(`${environment.magic}/template/create`);
          let tpl_created_res = await axios.post(`/pass/${uri}`, formData);
          new_tpl_id = tpl_created_res.data.id;
          const formData2 = new FormData();
          formData2.append('id', new_tpl_id);
          formData2.append('channel_name', tpl_data.channel_name);
          formData2.append('tpl_render', tpl_data.tpl_render);
          formData2.append('tpl_studio', JSON.stringify(tpl_studio));
          formData2.append('thumbnail_seconds', tpl_data.thumbnail_seconds);
          formData2.append('name', tpl_data.name);
          formData2.append('user_name', tpl_data.user_name);
          uri = encodeURIComponent(`${environment.magic}/template/update`);
          await axios.post(`/pass/${uri}`, formData2);
        }

        let hub = JSON.parse(item.hub);
        for (let obj of hub) {
          if (obj.collection_id) {
            if (old_coll_id != obj.collection_id) {
              old_coll_id = obj.collection_id;
              uri = encodeURIComponent(`${environment.magic}/collection/clone/${obj.collection_id}/${this.username}`);
              let coll_res = await axios.get(`/pass/${uri}`);
              new_coll_id = coll_res.data.id;
            }
            Object.assign(obj, { collection_id: new_coll_id, layer_name: obj.layer_name.replace(/[0-9]+/g, new_coll_id) });
          }
          if (obj.source_id) {
            uri = encodeURIComponent(`${environment.source}/config/load/${obj.source_id}`);
            let src_res = await axios.get(`/pass/${uri}`);
            let src_data = JSON.parse(src_res.data.data);
            if (src_data.claim) src_data.claim.username = this.username;
            const formData = new FormData();
            formData.append('data', JSON.stringify(src_data));
            formData.append('type', src_res.data.type);
            formData.append('id', '');
            uri = encodeURIComponent(`${environment.source}/config/add`);
            let src_added_res = await axios.post(`/pass/${uri}`, formData);
            Object.assign(obj, { source_id: src_added_res.data.id, music_data: [{ uri: `automusic:source:${src_added_res.data.id}` }], layer_name: obj.layer_name.replace(/[0-9]+/g, src_added_res.data.id) });
          }
        }

        const formData = new FormData();
        formData.append('channel_id', this.tools.clone_channel.target_id);
        formData.append('template_id', new_tpl_id);
        formData.append('name', item.name);
        formData.append('type', item.type);
        formData.append('user_name', item.user_name);
        uri = encodeURIComponent(`${environment.magic}/hub/create`);
        let hub_created_res = await axios.post(`/pass/${uri}`, formData);
        const formData2 = new FormData();
        formData2.append('id', hub_created_res.data.id);
        formData2.append('tpl_meta', item.tpl_meta);
        formData2.append('hub', JSON.stringify(hub));
        formData2.append('env', item.env);
        formData2.append('status', '3');
        formData2.append('is_schedule', item.is_schedule);
        formData2.append('time_start', item.time_start);
        formData2.append('time_stop', item.time_stop);
        formData2.append('name', item.name);
        formData2.append('type', item.type);
        formData2.append('post_type', item.post_type);
        formData2.append('supc_id', item.supc_id);
        uri = encodeURIComponent(`${environment.magic}/hub/update`);
        await axios.post(`/pass/${uri}`, formData2);
      }
      this.openSnackBar(`Cloned ${this.tools.clone_channel.target_name} channel`, 1000);
    } catch (error) {
      console.log(error);
      this.openSnackBar(`Failed to clone ${this.tools.clone_channel.target_name} channel`);
    } finally {
      event.srcElement.removeAttribute('disabled');
      this.tools.clone_channel.is_loading = false;
    }
  }

  viewer: any = { type: 1, accounts: [], time_sec: 30, is_like: true, is_subscribe: true };
  accountCtrl = new FormControl();

  accountChanged(event: any) {
    if (event.value) this.viewer.accounts = event.value;
  }

  isChecked(formCtrl: any, values: any) {
    return formCtrl.value && values.length && formCtrl.value.length === values.length;
  }

  isIndeterminate(formCtrl: any, values: any) {
    return formCtrl.value && values.length && formCtrl.value.length > 0 && formCtrl.value.length < values.length;
  }

  toggleSelection(event: any, formCtrl: any, values: any) {
    let value = [];
    if (event.checked) value = values;
    formCtrl.setValue(value);
    this.accountChanged({ value });
  }

  async viewerClicked(event: any) {
    if (!this.viewer.accounts.length) this.openSnackBar('Fill in a accounts');
    else if (this.viewer.type == 1 && !this.viewer.target_url) this.openSnackBar('Fill in a target url');
    else if (this.viewer.type == 2 && !this.viewer.target_source) this.openSnackBar('Fill in a target source');
    else {
      for (let item of this.viewer.accounts) {
        let formData = new FormData();
        formData.append('gmail', item.note);
        formData.append('run_time', '0');
        formData.append('type', '4');
        formData.append('piority', '10');
        switch (this.viewer.type) {
          case 1:
            formData.append('task_list', JSON.stringify([
              {
                "script_name": "profile",
                "func_name": "login",
                "params": []
              },
              {
                "script_name": "view",
                "func_name": "watch",
                "params": [
                  {
                    "name": "url",
                    "type": "string",
                    "value": this.viewer.target_url
                  },
                  {
                    "name": "is_like",
                    "type": "string",
                    "value": this.viewer.is_like
                  },
                  {
                    "name": "is_subscribe",
                    "type": "string",
                    "value": this.viewer.is_subscribe
                  },
                  {
                    "name": "time_sec",
                    "type": "string",
                    "value": this.viewer.time_sec
                  }
                ]
              }
            ]));
            break;
          case 2:
            let targetType = 'channel';
            if (this.viewer.target_source.includes('/channel/')) this.viewer.target_source = this.viewer.target_source.split('/channel/').pop();
            else if (this.viewer.target_source.includes('/c/')) this.viewer.target_source = this.viewer.target_source.split('/c/').pop();
            else {
              this.viewer.target_source = this.viewer.target_source.split('/watch?v=').pop();
              targetType = 'video';
            }
            formData.append('task_list', JSON.stringify([
              {
                "script_name": "profile",
                "func_name": "login",
                "params": []
              },
              {
                "script_name": "view",
                "func_name": "home_watch",
                "params": [
                  {
                    "name": "target_source",
                    "type": "string",
                    "value": this.viewer.target_source
                  },
                  {
                    "name": "target_type",
                    "type": "string",
                    "value": targetType
                  },
                  {
                    "name": "exclude_video_ids",
                    "type": "json",
                    "value": JSON.stringify(this.viewer.exclude_videos.split(/\r?\n/).map(e => e.split('/watch?v=').pop()))
                  },
                  {
                    "name": "is_like",
                    "type": "string",
                    "value": this.viewer.is_like
                  },
                  {
                    "name": "is_subscribe",
                    "type": "string",
                    "value": this.viewer.is_subscribe
                  },
                  {
                    "name": "time_sec",
                    "type": "string",
                    "value": this.viewer.time_sec
                  }
                ]
              }
            ]));
            break;
        }
        let uri = encodeURIComponent(`${environment.reup}/job/add`);
        await axios.post(`/pass/${uri}`, formData);
      }
    }
  }

  boomGenres: any = [];

  getBoomGenres() {
    const that = this;
    let uri = encodeURIComponent(`${environment.music}/genres/list`);
    axios.get(`/pass/${uri}`)
      .then((response) => that.boomGenres = response.data)
      .catch((error) => console.log(error));
  }

  askMetaData: any = {
    language: 'English',
    mention_config: {
      mentions: [
        {
          items: [{ code: 'title:', name: 'Title' }, { code: 'description:', name: 'Description' }, { code: 'tags:', name: 'Tags' }, { code: '@@meta_title@@', name: 'Meta title' }],
          labelKey: 'name',
          triggerChar: '@',
          mentionSelect: item => item.code,
          mentionFilter: this.mentionFilter,
        },
      ]
    },
  };

  askMeta(event: any) {
    const that = this;
    Object.assign(this.askMetaData, { loading: true, env_config: [], meta_config: {} });
    const promptLang = `${this.askMetaData.prompt}\nlanguage: ${this.askMetaData.language}`;
    const formData = new FormData();
    formData.append('prompt', promptLang);
    let uri = encodeURIComponent(`${environment.magic}/hub/meta/ask`);
    axios.post(`/pass/${uri}`, formData)
      .then((response) => {
        response.data.env_config = response.data.env_config?.map((e) => ({...e, value: e.value.replace(/[{}]/g, '').split('|')}));
        Object.assign(that.askMetaData, response.data);
      })
      .catch((error) => console.log(error))
      .finally(() => that.askMetaData.loading = false);
  }

  copyGenEnv(item: any) {
    navigator.clipboard.writeText(`{${item.value.join('|')}}`);
  }

  fillToMeta(event: any) {
    const genMeta = this.askMetaData?.meta_config;
    this.autoTemplate.meta.title = genMeta?.title;
    this.autoTemplate.meta.description = genMeta?.description?.replace('<', '')?.replace('>', '');
    this.autoTemplate.meta.tags = genMeta?.tags;
    this.addTags(['title', 'description', 'tags']);
    this.fillToEnv(event);
  }

  fillToEnv(event: any) {
    const genEnv = JSON.parse(JSON.stringify(this.askMetaData?.env_config));
    for (let e of genEnv) {
      e.value = `{${e.value.join('|')}}`;
      const index = this.autoTemplate.env.findIndex((x) => x.code === e.code);
      if (index !== -1) this.autoTemplate.env[index] = e;
      else this.autoTemplate.env.push(e);
    }
    this.saveEnv(event);
  }

  getPrompts() {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/prompt/list`);
    axios.get(`/pass/${uri}`)
      .then((response) => that.askMetaData.prompts = response.data)
      .catch((error) => console.log(error));
  }

  promptChange(value: any) {
    this.askMetaData.prompt = value;
    this.addPromptTags();
  }

  @ViewChild('promptRef') promptRef: ElementRef;

  promptedChange(value: any) {
    Object.assign(this.askMetaData, { prompted: value, name: value.name, prompt: value.prompt });
    this.promptRef.nativeElement.value = value.prompt;
    this.promptRef.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
    this.addPromptTags();
  }

  addPrompt(event: any) {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/prompt/add`);
    const formData = new FormData();
    formData.append('name', this.askMetaData.name);
    formData.append('prompt', this.askMetaData.prompt);
    formData.append('type', 'hub');
    axios.post(`/pass/${uri}`, formData)
      .then((response) => {
        that.openSnackBar(`Added Prompt: ${response.data.id} ${that.askMetaData.name}`, 1000);
        that.getPrompts();
      })
      .catch((error) => console.log(error));
  }

  deletePrompt(event: any) {
    if (!this.askMetaData.prompted) return;
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/prompt/del/${this.askMetaData.prompted.id}`);
    axios.get(`/pass/${uri}`)
      .then((response) => {
        that.openSnackBar(`Deleted Prompt: ${that.askMetaData.prompted.id} ${that.askMetaData.prompted.name}`, 1000);
        Object.assign(this.askMetaData, { prompted: null, name: null, prompt: null });
        that.highlightTag['prompt'] = [];
        that.getPrompts();
      })
      .catch((error) => console.log(error));
  }

  addPromptTags() {
    this.highlightTag['prompt'] = [];
    let regexList = [/(@@\w+@@) ?/g, /(\w+:) ?/g];
    for (let regex of regexList) {
      let match;
      while ((match = regex.exec(this.askMetaData.prompt))) {
        this.highlightTag['prompt'].push({
          indices: {
            start: match.index,
            end: match.index + match[1].length
          },
          data: match[1],
          cssClass: 'bg-success'
        });
      }
    }
  }
}
